// This file is generated by scripts/generate-bizy3-pose-data.mjs.
// Edit the source SVGs and rerun the generator instead of editing path data here.

export const ALL_BIZY3_STATES = [
	'curious',
	'straightOn',
	'lookingRight',
	'facingRight',
	'facingLeft',
	'flyingRight',
	'flyingLeft',
	'waving',
	'pointingRight',
	'pointingLeft',
	'tickleLeft',
	'excited',
	'headScratch',
	'thinkingRight',
	'thinkingLeft',
	'disappointedLeft',
	'disappointedRight',
	'searchingLeft',
	'searchingRight',
	'searching',
	'peeking',
	'bored',
] as const;

export type Bizy3State = (typeof ALL_BIZY3_STATES)[number];

export type Bizy3Texture = {
	x: number;
	y: number;
	width: number;
	height: number;
	frequency: readonly [number, number];
	numOctaves: number;
	seed: number;
	scale: number;
};

export type Bizy3Part = {
	d: string;
	texture: Bizy3Texture;
};

export type Bizy3Arm = {
	d: string;
	texture: Bizy3Texture;
	front: boolean;
	renderMode: 'fill' | 'stroke';
};

export type Bizy3Antenna = {
	stem: Bizy3Part;
	tip: Bizy3Part;
	front: boolean;
};

export type Bizy3Pose = {
	source: string;
	viewBox: { width: number; height: number };
	wings: {
		tealRight: Bizy3Part;
		tealLeft: Bizy3Part;
		purpleRight: Bizy3Part;
		purpleLeft: Bizy3Part;
	};
	leftArm: Bizy3Arm;
	rightArm: Bizy3Arm;
	antennae: readonly Bizy3Antenna[];
	body: Bizy3Part;
	bodyMask: string;
	bodyShade: Bizy3Part;
	stripes: readonly [Bizy3Part, Bizy3Part, Bizy3Part];
	eyes: readonly Bizy3Part[];
	stinger: Bizy3Part;
	stars: readonly Bizy3Part[];
	squiggles: readonly Bizy3Part[];
	prop: {
		behindEye: string;
		eye: Bizy3Part | null;
		inFrontOfEye: string;
	} | null;
};

export const BIZY3_POSES = {
	curious: {
		source: 'curious.svg',
		viewBox: {
			width: 320,
			height: 321,
		},
		wings: {
			tealRight: {
				d: 'M267.929 189.466C243.007 202.663 183.29 174.619 167.446 166.714C165.648 165.818 165.466 163.16 167.123 161.954C202.113 136.487 267.584 128.098 296.865 127.108C327.18 126.083 290.055 177.749 267.929 189.466Z',
				texture: {
					x: 164.792,
					y: 125.902,
					width: 144.693,
					height: 68.2325,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
			tealLeft: {
				d: 'M76.3654 190.856C101.287 204.053 161.004 176.009 176.849 168.104C178.646 167.207 178.828 164.55 177.172 163.344C142.181 137.877 76.7099 129.488 47.429 128.497C17.1137 127.473 54.2385 179.139 76.3654 190.856Z',
				texture: {
					x: 34.8097,
					y: 127.292,
					width: 144.693,
					height: 68.2325,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
			purpleRight: {
				d: 'M263.205 162.052C244.209 182.895 178.528 176.68 160.944 174.594C158.95 174.358 157.88 171.918 159.032 170.223C183.358 134.431 242.143 104.41 269.366 93.5846C297.552 82.3754 280.071 143.547 263.205 162.052Z',
				texture: {
					x: 157.368,
					y: 91.0333,
					width: 128.077,
					height: 87.2542,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
			purpleLeft: {
				d: 'M80.5254 162.747C99.5213 183.589 165.202 177.375 182.786 175.289C184.78 175.052 185.85 172.613 184.698 170.918C160.372 135.126 101.587 105.105 74.3635 94.2788C46.1779 83.0703 63.6595 144.242 80.5254 162.747Z',
				texture: {
					x: 58.2843,
					y: 91.7277,
					width: 128.077,
					height: 87.2545,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
		},
		leftArm: {
			d: 'M115.086 162.598C115.086 162.598 112.288 185.21 109.313 200.435C106.338 215.661 92.7183 232.897 92.7183 232.897',
			texture: {
				x: 78.8911,
				y: 148.77,
				width: 50.023,
				height: 97.9541,
				frequency: [0.9990000128746033, 0.732045590877533],
				numOctaves: 3,
				seed: 8637,
				scale: 1.5817248821258545,
			},
			front: false,
			renderMode: 'stroke',
		},
		rightArm: {
			d: 'M215.741 164.994C215.741 164.994 225.136 183.371 228.187 197.739C231.238 212.106 227.971 234.494 227.971 234.494',
			texture: {
				x: 201.912,
				y: 151.165,
				width: 41.4045,
				height: 97.1578,
				frequency: [0.9990000128746033, 0.732045590877533],
				numOctaves: 3,
				seed: 8637,
				scale: 1.5817248821258545,
			},
			front: true,
			renderMode: 'stroke',
		},
		antennae: [
			{
				stem: {
					d: 'M128.667 71.9279C131.063 55.1521 139.451 37.9768 159.422 31.1865',
					texture: {
						x: 123.705,
						y: 26.2246,
						width: 40.6791,
						height: 50.6647,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 2801,
						scale: 1.933219313621521,
					},
				},
				tip: {
					d: 'M160.221 40.3736C165.295 40.3736 169.408 36.2605 169.408 31.1868C169.408 26.113 165.295 22 160.221 22C155.147 22 151.034 26.113 151.034 31.1868C151.034 36.2605 155.147 40.3736 160.221 40.3736Z',
					texture: {
						x: 149.668,
						y: 20.634,
						width: 21.1057,
						height: 21.1056,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 8737,
						scale: 2.732070207595825,
					},
				},
				front: false,
			},
			{
				stem: {
					d: 'M176.598 71.9279C178.994 55.1521 187.382 37.9768 207.353 31.1865',
					texture: {
						x: 171.636,
						y: 26.2246,
						width: 40.6791,
						height: 50.6647,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 2801,
						scale: 1.933219313621521,
					},
				},
				tip: {
					d: 'M208.152 40.3736C213.226 40.3736 217.339 36.2605 217.339 31.1868C217.339 26.113 213.226 22 208.152 22C203.078 22 198.965 26.113 198.965 31.1868C198.965 36.2605 203.078 40.3736 208.152 40.3736Z',
					texture: {
						x: 197.599,
						y: 20.634,
						width: 21.1056,
						height: 21.1056,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 8737,
						scale: 2.732070207595825,
					},
				},
				front: true,
			},
		],
		body: {
			d: 'M101.858 96.8471C102.719 76.5189 118.724 60.087 139.022 58.6899L161.405 57.1494L183.998 59.0027C204.371 60.6738 220.194 77.4571 220.664 97.8933L222.132 161.718L220.766 224.058C220.248 247.709 201.096 266.705 177.441 267.028L161.419 267.247H145.569C121.993 267.247 102.62 248.64 101.668 225.084L99.1089 161.718L101.858 96.8471Z',
			texture: {
				x: 95.9441,
				y: 53.9815,
				width: 129.352,
				height: 216.429,
				frequency: [0.29947322607040405, 0.24354049563407898],
				numOctaves: 3,
				seed: 6337,
				scale: 3.131495714187622,
			},
		},
		bodyMask:
			'M100.989 96.1398C101.952 74.6109 120.056 57.9994 141.599 58.5671L163.59 59.1465L179.396 58.6943C201.489 58.0621 219.895 75.4905 220.468 97.5842L222.132 161.718L221.01 223.995C220.58 247.832 201.219 266.977 177.379 267.139L161.42 267.247L143.865 267.128C120.657 266.971 101.573 248.791 100.643 225.601C99.8241 205.167 99.0643 180.842 99.1093 161.718C99.156 141.918 100.066 116.767 100.989 96.1398Z',
		bodyShade: {
			d: 'M206.555 53.5547C211.747 58.3478 221.733 76.1743 224.928 89.9024C228.124 103.63 229.322 132.641 229.322 147.02C229.322 161.4 224.928 182.569 220.934 195.75C216.94 208.931 210.15 222.911 206.555 232.497C202.96 242.083 194.572 257.262 180.992 278.831',
			texture: {
				x: 123.854,
				y: -3.5793,
				width: 162.602,
				height: 339.547,
				frequency: [0.638672411441803, 0.638672411441803],
				numOctaves: 3,
				seed: 9325,
				scale: 60.744625091552734,
			},
		},
		stripes: [
			{
				d: 'M225.328 166.991V187.362C225.328 187.362 202.598 185.764 161.819 185.764C121.041 185.764 95.9141 187.362 95.9141 187.362V166.991C95.9141 166.991 121.041 165.394 161.819 165.394C202.598 165.394 225.328 166.991 225.328 166.991Z',
				texture: {
					x: 95.4587,
					y: 164.938,
					width: 130.325,
					height: 22.8791,
					frequency: [0.5960943698883057, 0.5960943698883057],
					numOctaves: 3,
					seed: 2172,
					scale: 0.9106900691986084,
				},
			},
			{
				d: 'M225.328 200.943V221.314C225.328 221.314 202.598 219.716 161.819 219.716C121.041 219.716 95.9141 221.314 95.9141 221.314V200.943C95.9141 200.943 121.041 199.346 161.819 199.346C202.598 199.346 225.328 200.943 225.328 200.943Z',
				texture: {
					x: 95.4587,
					y: 198.89,
					width: 130.325,
					height: 22.8791,
					frequency: [0.5960943698883057, 0.5960943698883057],
					numOctaves: 3,
					seed: 2172,
					scale: 0.9106900691986084,
				},
			},
			{
				d: 'M225.328 234.494V254.865C225.328 254.865 202.598 253.267 161.819 253.267C121.041 253.267 95.9141 254.865 95.9141 254.865V234.494C95.9141 234.494 121.041 232.896 161.819 232.896C202.598 232.896 225.328 234.494 225.328 234.494Z',
				texture: {
					x: 95.4587,
					y: 232.441,
					width: 130.325,
					height: 22.8791,
					frequency: [0.5960943698883057, 0.5960943698883057],
					numOctaves: 3,
					seed: 2172,
					scale: 0.9106900691986084,
				},
			},
		],
		eyes: [
			{
				d: 'M119.432 125.786C124.038 125.786 127.772 120.436 127.772 113.836C127.772 107.235 124.038 101.885 119.432 101.885C114.826 101.885 111.092 107.235 111.092 113.836C111.092 120.436 114.826 125.786 119.432 125.786Z',
				texture: {
					x: 109.846,
					y: 100.639,
					width: 19.1724,
					height: 26.394,
					frequency: [0.9990000128746033, 0.9990000128746033],
					numOctaves: 3,
					seed: 6148,
					scale: 1.6935639381408691,
				},
			},
			{
				d: 'M167.363 125.786C171.969 125.786 175.703 120.436 175.703 113.836C175.703 107.235 171.969 101.885 167.363 101.885C162.757 101.885 159.023 107.235 159.023 113.836C159.023 120.436 162.757 125.786 167.363 125.786Z',
				texture: {
					x: 157.777,
					y: 100.639,
					width: 19.1724,
					height: 26.394,
					frequency: [0.9990000128746033, 0.9990000128746033],
					numOctaves: 3,
					seed: 6148,
					scale: 1.6935639381408691,
				},
			},
		],
		stinger: {
			d: 'M209.429 275.238C203.374 262.089 188.144 270.95 195.052 281.869C200.98 291.239 212.946 298.802 221.919 299.995C223.698 300.111 224.224 298.053 222.861 296.904C218.538 295.207 215.485 288.387 209.429 275.238Z',
			texture: {
				x: 192.472,
				y: 267.844,
				width: 31.9786,
				height: 32.975,
				frequency: [0.9282835721969604, 0.7064296007156372],
				numOctaves: 3,
				seed: 192,
				scale: 1.6381428241729736,
			},
		},
		stars: [],
		squiggles: [],
		prop: null,
	},
	straightOn: {
		source: 'straightOn.svg',
		viewBox: {
			width: 320,
			height: 320,
		},
		wings: {
			tealRight: {
				d: 'M256.929 189.466C232.007 202.663 172.29 174.619 156.446 166.714C154.648 165.818 154.466 163.16 156.123 161.954C191.113 136.487 256.584 128.098 285.865 127.108C316.18 126.083 279.055 177.749 256.929 189.466Z',
				texture: {
					x: 153.792,
					y: 125.902,
					width: 144.693,
					height: 68.2325,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
			tealLeft: {
				d: 'M65.3654 190.856C90.2869 204.053 150.004 176.009 165.849 168.104C167.646 167.207 167.828 164.55 166.172 163.344C131.181 137.877 65.7099 129.488 36.429 128.497C6.11374 127.473 43.2385 179.139 65.3654 190.856Z',
				texture: {
					x: 23.8097,
					y: 127.292,
					width: 144.693,
					height: 68.2325,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
			purpleRight: {
				d: 'M252.205 162.052C233.208 182.895 167.528 176.68 149.944 174.594C147.95 174.358 146.88 171.918 148.032 170.223C172.357 134.431 231.143 104.41 258.366 93.5846C286.552 82.3754 269.07 143.547 252.205 162.052Z',
				texture: {
					x: 146.368,
					y: 91.0333,
					width: 128.077,
					height: 87.2542,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
			purpleLeft: {
				d: 'M69.5254 162.747C88.5213 183.589 154.202 177.375 171.786 175.289C173.78 175.052 174.85 172.613 173.698 170.918C149.372 135.126 90.5874 105.105 63.3635 94.2788C35.1779 83.0703 52.6595 144.242 69.5254 162.747Z',
				texture: {
					x: 47.2843,
					y: 91.7277,
					width: 128.077,
					height: 87.2545,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
		},
		leftArm: {
			d: 'M101.688 164.507C101.688 164.507 94.0353 183.675 92.3274 198.263C90.6194 212.851 95.9447 234.84 95.9447 234.84',
			texture: {
				x: 78.1645,
				y: 150.677,
				width: 37.3542,
				height: 97.9934,
				frequency: [0.9990000128746033, 0.732045590877533],
				numOctaves: 3,
				seed: 8637,
				scale: 1.5817248821258545,
			},
			front: true,
			renderMode: 'stroke',
		},
		rightArm: {
			d: 'M221.246 164.507C221.246 164.507 228.899 183.675 230.607 198.263C232.315 212.851 226.99 234.84 226.99 234.84',
			texture: {
				x: 207.416,
				y: 150.677,
				width: 37.3542,
				height: 97.9934,
				frequency: [0.9990000128746033, 0.732045590877533],
				numOctaves: 3,
				seed: 8637,
				scale: 1.5817248821258545,
			},
			front: true,
			renderMode: 'stroke',
		},
		antennae: [
			{
				stem: {
					d: 'M134.559 71.9279C136.956 55.1521 145.344 37.9768 165.315 31.1865',
					texture: {
						x: 129.598,
						y: 26.2246,
						width: 40.6791,
						height: 50.6647,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 2801,
						scale: 1.933219313621521,
					},
				},
				tip: {
					d: 'M166.114 40.3736C171.188 40.3736 175.301 36.2605 175.301 31.1868C175.301 26.113 171.188 22 166.114 22C161.04 22 156.927 26.113 156.927 31.1868C156.927 36.2605 161.04 40.3736 166.114 40.3736Z',
					texture: {
						x: 155.561,
						y: 20.634,
						width: 21.1056,
						height: 21.1056,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 8737,
						scale: 2.732070207595825,
					},
				},
				front: true,
			},
			{
				stem: {
					d: 'M182.49 71.9279C184.887 55.1521 193.275 37.9768 213.246 31.1865',
					texture: {
						x: 177.529,
						y: 26.2246,
						width: 40.6791,
						height: 50.6647,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 2801,
						scale: 1.933219313621521,
					},
				},
				tip: {
					d: 'M214.045 40.3736C219.119 40.3736 223.232 36.2605 223.232 31.1868C223.232 26.113 219.119 22 214.045 22C208.971 22 204.858 26.113 204.858 31.1868C204.858 36.2605 208.971 40.3736 214.045 40.3736Z',
					texture: {
						x: 203.492,
						y: 20.634,
						width: 21.1056,
						height: 21.1056,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 8737,
						scale: 2.732070207595825,
					},
				},
				front: true,
			},
		],
		body: {
			d: 'M101.751 96.8471C102.613 76.5189 118.617 60.087 138.915 58.6899L161.298 57.1494L183.891 59.0027C204.264 60.6738 220.087 77.4571 220.557 97.8933L222.025 161.718L220.659 224.058C220.141 247.709 200.989 266.705 177.334 267.028L161.312 267.247H145.462C121.886 267.247 102.513 248.64 101.561 225.084L99.002 161.718L101.751 96.8471Z',
			texture: {
				x: 95.8371,
				y: 53.9815,
				width: 129.352,
				height: 216.429,
				frequency: [0.29947322607040405, 0.24354049563407898],
				numOctaves: 3,
				seed: 6337,
				scale: 3.131495714187622,
			},
		},
		bodyMask:
			'M100.881 96.1398C101.845 74.6109 119.949 57.9994 141.492 58.5671L163.482 59.1465L179.289 58.6943C201.381 58.0621 219.787 75.4905 220.361 97.5842L222.025 161.718L220.902 223.995C220.473 247.832 201.112 266.977 177.271 267.139L161.312 267.247L143.757 267.128C120.55 266.971 101.466 248.791 100.536 225.601C99.7167 205.167 98.9569 180.842 99.0019 161.718C99.0485 141.918 99.9583 116.767 100.881 96.1398Z',
		bodyShade: {
			d: 'M206.447 53.5547C211.64 58.3478 221.626 76.1743 224.821 89.9024C228.016 103.63 229.215 132.641 229.215 147.02C229.215 161.4 224.821 182.569 220.827 195.75C216.832 208.931 210.042 222.911 206.447 232.497C202.853 242.083 194.465 257.262 180.884 278.831',
			texture: {
				x: 123.747,
				y: -3.5793,
				width: 162.602,
				height: 339.547,
				frequency: [0.638672411441803, 0.638672411441803],
				numOctaves: 3,
				seed: 9325,
				scale: 60.744625091552734,
			},
		},
		stripes: [
			{
				d: 'M225.22 166.991V187.362C225.22 187.362 202.49 185.764 161.712 185.764C120.933 185.764 95.8065 187.362 95.8065 187.362V166.991C95.8065 166.991 120.933 165.393 161.712 165.393C202.49 165.393 225.22 166.991 225.22 166.991Z',
				texture: {
					x: 95.3512,
					y: 164.938,
					width: 130.325,
					height: 22.8791,
					frequency: [0.5960943698883057, 0.5960943698883057],
					numOctaves: 3,
					seed: 2172,
					scale: 0.9106900691986084,
				},
			},
			{
				d: 'M225.22 200.943V221.314C225.22 221.314 202.49 219.716 161.712 219.716C120.933 219.716 95.8065 221.314 95.8065 221.314V200.943C95.8065 200.943 120.933 199.346 161.712 199.346C202.49 199.346 225.22 200.943 225.22 200.943Z',
				texture: {
					x: 95.3512,
					y: 198.89,
					width: 130.325,
					height: 22.8791,
					frequency: [0.5960943698883057, 0.5960943698883057],
					numOctaves: 3,
					seed: 2172,
					scale: 0.9106900691986084,
				},
			},
			{
				d: 'M225.22 234.494V254.865C225.22 254.865 202.49 253.267 161.712 253.267C120.933 253.267 95.8065 254.865 95.8065 254.865V234.494C95.8065 234.494 120.933 232.896 161.712 232.896C202.49 232.896 225.22 234.494 225.22 234.494Z',
				texture: {
					x: 95.3512,
					y: 232.441,
					width: 130.325,
					height: 22.8791,
					frequency: [0.5960943698883057, 0.5960943698883057],
					numOctaves: 3,
					seed: 2172,
					scale: 0.9106900691986084,
				},
			},
		],
		eyes: [
			{
				d: 'M136.34 125.786C140.946 125.786 144.68 120.436 144.68 113.836C144.68 107.235 140.946 101.885 136.34 101.885C131.734 101.885 128 107.235 128 113.836C128 120.436 131.734 125.786 136.34 125.786Z',
				texture: {
					x: 126.754,
					y: 100.639,
					width: 19.1724,
					height: 26.394,
					frequency: [0.9990000128746033, 0.9990000128746033],
					numOctaves: 3,
					seed: 6148,
					scale: 1.6935639381408691,
				},
			},
			{
				d: 'M184.271 125.786C188.877 125.786 192.611 120.436 192.611 113.836C192.611 107.235 188.877 101.885 184.271 101.885C179.665 101.885 175.931 107.235 175.931 113.836C175.931 120.436 179.665 125.786 184.271 125.786Z',
				texture: {
					x: 174.685,
					y: 100.639,
					width: 19.1724,
					height: 26.394,
					frequency: [0.9990000128746033, 0.9990000128746033],
					numOctaves: 3,
					seed: 6148,
					scale: 1.6935639381408691,
				},
			},
		],
		stinger: {
			d: 'M209.322 275.238C203.266 262.089 188.037 270.95 194.945 281.869C200.873 291.239 212.838 298.802 221.812 299.995C223.59 300.111 224.116 298.053 222.754 296.904C218.43 295.207 215.377 288.387 209.322 275.238Z',
			texture: {
				x: 192.365,
				y: 267.844,
				width: 31.9786,
				height: 32.975,
				frequency: [0.9282835721969604, 0.7064296007156372],
				numOctaves: 3,
				seed: 192,
				scale: 1.6381428241729736,
			},
		},
		stars: [],
		squiggles: [],
		prop: null,
	},
	lookingRight: {
		source: 'lookingRight.svg',
		viewBox: {
			width: 320,
			height: 320,
		},
		wings: {
			tealRight: {
				d: 'M243.639 188.466C218.717 201.663 159 173.619 143.156 165.714C141.358 164.818 141.176 162.16 142.833 160.954C177.823 135.487 243.294 127.098 272.575 126.108C302.89 125.083 265.765 176.749 243.639 188.466Z',
				texture: {
					x: 140.502,
					y: 124.902,
					width: 144.693,
					height: 68.2325,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
			tealLeft: {
				d: 'M52.0754 189.856C76.9968 203.053 136.714 175.009 152.559 167.104C154.356 166.207 154.538 163.55 152.882 162.344C117.891 136.877 52.4199 128.488 23.139 127.497C-7.1763 126.473 29.9484 178.139 52.0754 189.856Z',
				texture: {
					x: 10.5197,
					y: 126.292,
					width: 144.693,
					height: 68.2325,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
			purpleRight: {
				d: 'M238.915 161.052C219.918 181.895 154.238 175.68 136.654 173.594C134.66 173.358 133.59 170.918 134.742 169.223C159.067 133.431 217.853 103.41 245.076 92.5846C273.262 81.3754 255.78 142.547 238.915 161.052Z',
				texture: {
					x: 133.078,
					y: 90.0333,
					width: 128.077,
					height: 87.2542,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
			purpleLeft: {
				d: 'M56.2354 161.747C75.2312 182.589 140.912 176.375 158.496 174.289C160.49 174.052 161.56 171.613 160.408 169.918C136.082 134.126 77.2973 104.105 50.0734 93.2788C21.8878 82.0703 39.3695 143.242 56.2354 161.747Z',
				texture: {
					x: 33.9943,
					y: 90.7277,
					width: 128.077,
					height: 87.2545,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
		},
		leftArm: {
			d: 'M107.466 163.994C107.466 163.994 98.0713 182.371 95.0204 196.739C91.9694 211.106 95.2365 233.494 95.2365 233.494',
			texture: {
				x: 79.8908,
				y: 150.165,
				width: 41.4045,
				height: 97.1578,
				frequency: [0.9990000128746033, 0.732045590877533],
				numOctaves: 3,
				seed: 8637,
				scale: 1.5817248821258545,
			},
			front: true,
			renderMode: 'stroke',
		},
		rightArm: {
			d: 'M216.121 161.598C216.121 161.598 218.919 184.21 221.894 199.435C224.869 214.661 238.489 231.897 238.489 231.897',
			texture: {
				x: 202.293,
				y: 147.77,
				width: 50.023,
				height: 97.9541,
				frequency: [0.9990000128746033, 0.732045590877533],
				numOctaves: 3,
				seed: 8637,
				scale: 1.5817248821258545,
			},
			front: false,
			renderMode: 'stroke',
		},
		antennae: [
			{
				stem: {
					d: 'M129.667 70.9279C132.063 54.1521 140.451 36.9768 160.422 30.1865',
					texture: {
						x: 124.705,
						y: 25.2246,
						width: 40.6791,
						height: 50.6647,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 2801,
						scale: 1.933219313621521,
					},
				},
				tip: {
					d: 'M161.221 39.3736C166.295 39.3736 170.408 35.2605 170.408 30.1868C170.408 25.113 166.295 21 161.221 21C156.147 21 152.034 25.113 152.034 30.1868C152.034 35.2605 156.147 39.3736 161.221 39.3736Z',
					texture: {
						x: 150.668,
						y: 19.634,
						width: 21.1056,
						height: 21.1056,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 8737,
						scale: 2.732070207595825,
					},
				},
				front: true,
			},
			{
				stem: {
					d: 'M177.598 70.9279C179.994 54.1521 188.382 36.9768 208.353 30.1865',
					texture: {
						x: 172.636,
						y: 25.2246,
						width: 40.6791,
						height: 50.6647,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 2801,
						scale: 1.933219313621521,
					},
				},
				tip: {
					d: 'M209.152 39.3736C214.226 39.3736 218.339 35.2605 218.339 30.1868C218.339 25.113 214.226 21 209.152 21C204.078 21 199.965 25.113 199.965 30.1868C199.965 35.2605 204.078 39.3736 209.152 39.3736Z',
					texture: {
						x: 198.599,
						y: 19.634,
						width: 21.1056,
						height: 21.1056,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 8737,
						scale: 2.732070207595825,
					},
				},
				front: false,
			},
		],
		body: {
			d: 'M102.858 95.8472C103.72 75.519 119.724 59.0871 140.022 57.69L162.405 56.1495L184.998 58.0028C205.371 59.6739 221.195 76.4572 221.664 96.8934L223.132 160.718L221.766 223.058C221.248 246.71 202.096 265.705 178.441 266.028L162.419 266.247H146.569C122.993 266.247 103.62 247.64 102.668 224.084L100.109 160.718L102.858 95.8472Z',
			texture: {
				x: 96.9441,
				y: 52.9816,
				width: 129.352,
				height: 216.429,
				frequency: [0.29947322607040405, 0.24354049563407898],
				numOctaves: 3,
				seed: 6337,
				scale: 3.131495714187622,
			},
		},
		bodyMask:
			'M101.989 95.1398C102.952 73.6109 121.056 56.9994 142.599 57.5671L164.59 58.1465L180.396 57.6943C202.489 57.0621 220.895 74.4905 221.468 96.5842L223.132 160.718L222.01 222.995C221.58 246.832 202.219 265.977 178.379 266.139L162.42 266.247L144.865 266.128C121.657 265.971 102.573 247.791 101.643 224.601C100.824 204.167 100.064 179.842 100.109 160.718C100.156 140.918 101.066 115.767 101.989 95.1398Z',
		bodyShade: {
			d: 'M207.555 52.5547C212.747 57.3478 222.733 75.1743 225.928 88.9024C229.124 102.63 230.322 131.641 230.322 146.02C230.322 160.4 225.928 181.569 221.934 194.75C217.94 207.931 211.15 221.911 207.555 231.497C203.96 241.083 195.572 256.262 181.992 277.831',
			texture: {
				x: 124.854,
				y: -4.5793,
				width: 162.602,
				height: 339.547,
				frequency: [0.638672411441803, 0.638672411441803],
				numOctaves: 3,
				seed: 9325,
				scale: 60.744625091552734,
			},
		},
		stripes: [
			{
				d: 'M226.328 165.991V186.362C226.328 186.362 203.598 184.764 162.819 184.764C122.04 184.764 96.9139 186.362 96.9139 186.362V165.991C96.9139 165.991 122.04 164.393 162.819 164.393C203.598 164.393 226.328 165.991 226.328 165.991Z',
				texture: {
					x: 96.4586,
					y: 163.938,
					width: 130.325,
					height: 22.8791,
					frequency: [0.5960943698883057, 0.5960943698883057],
					numOctaves: 3,
					seed: 2172,
					scale: 0.9106900691986084,
				},
			},
			{
				d: 'M226.328 199.943V220.314C226.328 220.314 203.598 218.716 162.819 218.716C122.04 218.716 96.9139 220.314 96.9139 220.314V199.943C96.9139 199.943 122.04 198.346 162.819 198.346C203.598 198.346 226.328 199.943 226.328 199.943Z',
				texture: {
					x: 96.4586,
					y: 197.89,
					width: 130.325,
					height: 22.8791,
					frequency: [0.5960943698883057, 0.5960943698883057],
					numOctaves: 3,
					seed: 2172,
					scale: 0.9106900691986084,
				},
			},
			{
				d: 'M226.328 233.494V253.865C226.328 253.865 203.598 252.267 162.819 252.267C122.04 252.267 96.9139 253.865 96.9139 253.865V233.494C96.9139 233.494 122.04 231.896 162.819 231.896C203.598 231.896 226.328 233.494 226.328 233.494Z',
				texture: {
					x: 96.4586,
					y: 231.441,
					width: 130.325,
					height: 22.8791,
					frequency: [0.5960943698883057, 0.5960943698883057],
					numOctaves: 3,
					seed: 2172,
					scale: 0.9106900691986084,
				},
			},
		],
		eyes: [
			{
				d: 'M155.432 124.786C160.038 124.786 163.772 119.436 163.772 112.836C163.772 106.235 160.038 100.885 155.432 100.885C150.826 100.885 147.092 106.235 147.092 112.836C147.092 119.436 150.826 124.786 155.432 124.786Z',
				texture: {
					x: 145.846,
					y: 99.6386,
					width: 19.1724,
					height: 26.394,
					frequency: [0.9990000128746033, 0.9990000128746033],
					numOctaves: 3,
					seed: 6148,
					scale: 1.6935639381408691,
				},
			},
			{
				d: 'M203.363 124.786C207.969 124.786 211.703 119.436 211.703 112.836C211.703 106.235 207.969 100.885 203.363 100.885C198.757 100.885 195.023 106.235 195.023 112.836C195.023 119.436 198.757 124.786 203.363 124.786Z',
				texture: {
					x: 193.777,
					y: 99.6386,
					width: 19.1724,
					height: 26.394,
					frequency: [0.9990000128746033, 0.9990000128746033],
					numOctaves: 3,
					seed: 6148,
					scale: 1.6935639381408691,
				},
			},
		],
		stinger: {
			d: 'M110.493 274.238C116.549 261.089 131.778 269.95 124.87 280.869C118.942 290.239 106.977 297.802 98.0034 298.995C96.2245 299.111 95.6986 297.053 97.0613 295.904C101.385 294.207 104.438 287.387 110.493 274.238Z',
			texture: {
				x: 95.4718,
				y: 266.844,
				width: 31.9786,
				height: 32.975,
				frequency: [0.9282835721969604, 0.7064296007156372],
				numOctaves: 3,
				seed: 192,
				scale: 1.6381428241729736,
			},
		},
		stars: [],
		squiggles: [],
		prop: null,
	},
	facingRight: {
		source: 'facingRight.svg',
		viewBox: {
			width: 320,
			height: 320,
		},
		wings: {
			tealRight: {
				d: 'M44.3652 188.466C69.2869 201.663 129.004 173.619 144.848 165.714C146.646 164.818 146.828 162.16 145.171 160.954C110.181 135.487 44.7097 127.098 15.4289 126.108C-14.8861 125.083 22.2386 176.749 44.3652 188.466Z',
				texture: {
					x: 2.80971,
					y: 124.902,
					width: 144.693,
					height: 68.2325,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
			tealLeft: {
				d: 'M52.0754 189.856C76.9968 203.053 136.714 175.009 152.559 167.104C154.356 166.207 154.538 163.55 152.882 162.344C117.891 136.877 52.4199 128.488 23.139 127.497C-7.1763 126.473 29.9484 178.139 52.0754 189.856Z',
				texture: {
					x: 10.5197,
					y: 126.292,
					width: 144.693,
					height: 68.2325,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
			purpleRight: {
				d: 'M49.0895 161.052C68.0857 181.895 133.766 175.68 151.35 173.594C153.344 173.358 154.414 170.918 153.262 169.223C128.937 133.431 70.1513 103.41 42.9279 92.5846C14.7424 81.3754 32.2237 142.547 49.0895 161.052Z',
				texture: {
					x: 26.8487,
					y: 90.0333,
					width: 128.077,
					height: 87.2542,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
			purpleLeft: {
				d: 'M56.2354 161.747C75.2312 182.589 140.912 176.375 158.496 174.289C160.49 174.052 161.56 171.613 160.408 169.918C136.082 134.126 77.2973 104.105 50.0734 93.2788C21.8878 82.0703 39.3695 143.242 56.2354 161.747Z',
				texture: {
					x: 33.9943,
					y: 90.7277,
					width: 128.077,
					height: 87.2545,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
		},
		leftArm: {
			d: 'M158.838 167C158.838 167 156.64 187.522 158.931 202.03C161.222 216.538 172.283 236.275 172.283 236.275',
			texture: {
				x: 144.061,
				y: 153.172,
				width: 42.0508,
				height: 96.9319,
				frequency: [0.9990000128746033, 0.732045590877533],
				numOctaves: 3,
				seed: 8637,
				scale: 1.5817248821258545,
			},
			front: true,
			renderMode: 'stroke',
		},
		rightArm: {
			d: 'M176.121 161.598C176.121 161.598 178.919 184.21 181.894 199.435C184.869 214.661 198.489 231.897 198.489 231.897',
			texture: {
				x: 162.293,
				y: 147.77,
				width: 50.023,
				height: 97.9541,
				frequency: [0.9990000128746033, 0.732045590877533],
				numOctaves: 3,
				seed: 8637,
				scale: 1.5817248821258545,
			},
			front: false,
			renderMode: 'stroke',
		},
		antennae: [
			{
				stem: {
					d: 'M149.667 70.9279C152.063 54.1521 160.451 36.9768 180.422 30.1865',
					texture: {
						x: 144.705,
						y: 25.2246,
						width: 40.6791,
						height: 50.6647,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 2801,
						scale: 1.933219313621521,
					},
				},
				tip: {
					d: 'M181.221 39.3736C186.295 39.3736 190.408 35.2605 190.408 30.1868C190.408 25.113 186.295 21 181.221 21C176.147 21 172.034 25.113 172.034 30.1868C172.034 35.2605 176.147 39.3736 181.221 39.3736Z',
					texture: {
						x: 170.668,
						y: 19.634,
						width: 21.1056,
						height: 21.1056,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 8737,
						scale: 2.732070207595825,
					},
				},
				front: true,
			},
			{
				stem: {
					d: 'M167.598 70.9279C169.994 54.1521 178.382 36.9768 198.353 30.1865',
					texture: {
						x: 162.636,
						y: 25.2246,
						width: 40.6791,
						height: 50.6647,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 2801,
						scale: 1.933219313621521,
					},
				},
				tip: {
					d: 'M199.152 39.3736C204.226 39.3736 208.339 35.2605 208.339 30.1868C208.339 25.113 204.226 21 199.152 21C194.078 21 189.965 25.113 189.965 30.1868C189.965 35.2605 194.078 39.3736 199.152 39.3736Z',
					texture: {
						x: 188.599,
						y: 19.634,
						width: 21.1056,
						height: 21.1056,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 8737,
						scale: 2.732070207595825,
					},
				},
				front: false,
			},
		],
		body: {
			d: 'M102.858 95.8472C103.72 75.519 119.724 59.0871 140.022 57.69L162.405 56.1495L184.998 58.0028C205.371 59.6739 221.195 76.4572 221.664 96.8934L223.132 160.718L221.766 223.058C221.248 246.71 202.096 265.705 178.441 266.028L162.419 266.247H146.569C122.993 266.247 103.62 247.64 102.668 224.084L100.109 160.718L102.858 95.8472Z',
			texture: {
				x: 96.9441,
				y: 52.9816,
				width: 129.352,
				height: 216.429,
				frequency: [0.29947322607040405, 0.24354049563407898],
				numOctaves: 3,
				seed: 6337,
				scale: 3.131495714187622,
			},
		},
		bodyMask:
			'M101.989 95.1398C102.952 73.6109 121.056 56.9994 142.599 57.5671L164.59 58.1465L180.396 57.6943C202.489 57.0621 220.895 74.4905 221.468 96.5842L223.132 160.718L222.01 222.995C221.58 246.832 202.219 265.977 178.379 266.139L162.42 266.247L144.865 266.128C121.657 265.971 102.573 247.791 101.643 224.601C100.824 204.167 100.064 179.842 100.109 160.718C100.156 140.918 101.066 115.767 101.989 95.1398Z',
		bodyShade: {
			d: 'M207.555 52.5547C212.747 57.3478 222.733 75.1743 225.928 88.9024C229.124 102.63 230.322 131.641 230.322 146.02C230.322 160.4 225.928 181.569 221.934 194.75C217.94 207.931 211.15 221.911 207.555 231.497C203.96 241.083 195.572 256.262 181.992 277.831',
			texture: {
				x: 124.854,
				y: -4.5793,
				width: 162.602,
				height: 339.547,
				frequency: [0.638672411441803, 0.638672411441803],
				numOctaves: 3,
				seed: 9325,
				scale: 60.744625091552734,
			},
		},
		stripes: [
			{
				d: 'M226.328 165.991V186.362C226.328 186.362 203.598 184.764 162.819 184.764C122.04 184.764 96.9139 186.362 96.9139 186.362V165.991C96.9139 165.991 122.04 164.393 162.819 164.393C203.598 164.393 226.328 165.991 226.328 165.991Z',
				texture: {
					x: 96.4586,
					y: 163.938,
					width: 130.325,
					height: 22.8791,
					frequency: [0.5960943698883057, 0.5960943698883057],
					numOctaves: 3,
					seed: 2172,
					scale: 0.9106900691986084,
				},
			},
			{
				d: 'M226.328 199.943V220.314C226.328 220.314 203.598 218.716 162.819 218.716C122.04 218.716 96.9139 220.314 96.9139 220.314V199.943C96.9139 199.943 122.04 198.346 162.819 198.346C203.598 198.346 226.328 199.943 226.328 199.943Z',
				texture: {
					x: 96.4586,
					y: 197.89,
					width: 130.325,
					height: 22.8791,
					frequency: [0.5960943698883057, 0.5960943698883057],
					numOctaves: 3,
					seed: 2172,
					scale: 0.9106900691986084,
				},
			},
			{
				d: 'M226.328 233.494V253.865C226.328 253.865 203.598 252.267 162.819 252.267C122.04 252.267 96.9139 253.865 96.9139 253.865V233.494C96.9139 233.494 122.04 231.896 162.819 231.896C203.598 231.896 226.328 233.494 226.328 233.494Z',
				texture: {
					x: 96.4586,
					y: 231.441,
					width: 130.325,
					height: 22.8791,
					frequency: [0.5960943698883057, 0.5960943698883057],
					numOctaves: 3,
					seed: 2172,
					scale: 0.9106900691986084,
				},
			},
		],
		eyes: [
			{
				d: 'M201.34 124.786C205.946 124.786 209.68 119.436 209.68 112.836C209.68 106.235 205.946 100.885 201.34 100.885C196.734 100.885 193 106.235 193 112.836C193 119.436 196.734 124.786 201.34 124.786Z',
				texture: {
					x: 191.754,
					y: 99.6386,
					width: 19.1724,
					height: 26.394,
					frequency: [0.9990000128746033, 0.9990000128746033],
					numOctaves: 3,
					seed: 6148,
					scale: 1.6935639381408691,
				},
			},
		],
		stinger: {
			d: 'M110.493 274.238C116.549 261.089 131.778 269.95 124.87 280.869C118.942 290.239 106.977 297.802 98.0034 298.995C96.2245 299.111 95.6986 297.053 97.0613 295.904C101.385 294.207 104.438 287.387 110.493 274.238Z',
			texture: {
				x: 95.4718,
				y: 266.844,
				width: 31.9786,
				height: 32.975,
				frequency: [0.9282835721969604, 0.7064296007156372],
				numOctaves: 3,
				seed: 192,
				scale: 1.6381428241729736,
			},
		},
		stars: [],
		squiggles: [],
		prop: null,
	},
	facingLeft: {
		source: 'facingLeft.svg',
		viewBox: {
			width: 320,
			height: 321,
		},
		wings: {
			tealRight: {
				d: 'M267.929 189.466C243.007 202.663 183.29 174.619 167.446 166.714C165.648 165.818 165.466 163.16 167.123 161.954C202.113 136.487 267.584 128.098 296.865 127.108C327.18 126.083 290.055 177.749 267.929 189.466Z',
				texture: {
					x: 164.792,
					y: 125.902,
					width: 144.693,
					height: 68.2325,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
			tealLeft: {
				d: 'M274.806 190.856C249.885 204.053 190.168 176.009 174.323 168.104C172.526 167.207 172.343 164.55 174 163.344C208.99 137.877 274.461 129.488 303.742 128.497C334.058 127.473 296.933 179.139 274.806 190.856Z',
				texture: {
					x: 171.669,
					y: 127.292,
					width: 144.693,
					height: 68.2325,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
			purpleRight: {
				d: 'M263.205 162.052C244.209 182.895 178.528 176.68 160.944 174.594C158.95 174.358 157.88 171.918 159.032 170.223C183.358 134.431 242.143 104.41 269.366 93.5846C297.552 82.3754 280.071 143.547 263.205 162.052Z',
				texture: {
					x: 157.368,
					y: 91.0333,
					width: 128.077,
					height: 87.2542,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
			purpleLeft: {
				d: 'M270.646 162.747C251.65 183.589 185.97 177.375 168.386 175.289C166.391 175.052 165.322 172.613 166.473 170.918C190.799 135.126 249.584 105.105 276.808 94.2788C304.994 83.0703 287.512 144.242 270.646 162.747Z',
				texture: {
					x: 164.81,
					y: 91.7277,
					width: 128.077,
					height: 87.2545,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
		},
		leftArm: {
			d: 'M155.086 162.598C155.086 162.598 152.288 185.21 149.313 200.435C146.338 215.661 132.718 232.897 132.718 232.897',
			texture: {
				x: 118.891,
				y: 148.77,
				width: 50.023,
				height: 97.9541,
				frequency: [0.9990000128746033, 0.732045590877533],
				numOctaves: 3,
				seed: 8637,
				scale: 1.5817248821258545,
			},
			front: false,
			renderMode: 'stroke',
		},
		rightArm: {
			d: 'M164.385 164.986C164.385 164.986 166.099 185.554 163.467 200.004C160.836 214.454 149.314 233.926 149.314 233.926',
			texture: {
				x: 135.485,
				y: 151.159,
				width: 43.2751,
				height: 96.5958,
				frequency: [0.9990000128746033, 0.732045590877533],
				numOctaves: 3,
				seed: 8637,
				scale: 1.5817248821258545,
			},
			front: true,
			renderMode: 'stroke',
		},
		antennae: [
			{
				stem: {
					d: 'M155.522 71.5506C153.635 54.7098 157.447 35.9797 175.077 24.3975',
					texture: {
						x: 150.127,
						y: 19.4362,
						width: 29.9107,
						height: 57.0756,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 2801,
						scale: 1.933219313621521,
					},
				},
				tip: {
					d: 'M178.154 33.0906C183.066 31.818 186.016 26.8048 184.743 21.8933C183.471 16.9817 178.458 14.0317 173.546 15.3043C168.635 16.5768 165.685 21.59 166.957 26.5016C168.23 31.4131 173.243 34.3631 178.154 33.0906Z',
					texture: {
						x: 165.295,
						y: 13.6424,
						width: 21.1101,
						height: 21.1101,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 8737,
						scale: 2.732070207595825,
					},
				},
				front: false,
			},
			{
				stem: {
					d: 'M164.598 71.9279C166.994 55.1521 175.382 37.9768 195.353 31.1865',
					texture: {
						x: 159.636,
						y: 26.2246,
						width: 40.6791,
						height: 50.6647,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 2801,
						scale: 1.933219313621521,
					},
				},
				tip: {
					d: 'M196.152 40.3736C201.226 40.3736 205.339 36.2605 205.339 31.1868C205.339 26.113 201.226 22 196.152 22C191.078 22 186.965 26.113 186.965 31.1868C186.965 36.2605 191.078 40.3736 196.152 40.3736Z',
					texture: {
						x: 185.599,
						y: 20.634,
						width: 21.1057,
						height: 21.1056,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 8737,
						scale: 2.732070207595825,
					},
				},
				front: true,
			},
		],
		body: {
			d: 'M101.858 96.8471C102.719 76.5189 118.724 60.087 139.022 58.6899L161.405 57.1494L183.998 59.0027C204.371 60.6738 220.194 77.4571 220.664 97.8933L222.132 161.718L220.766 224.058C220.248 247.709 201.096 266.705 177.441 267.028L161.419 267.247H145.569C121.993 267.247 102.62 248.64 101.668 225.084L99.1089 161.718L101.858 96.8471Z',
			texture: {
				x: 95.9441,
				y: 53.9815,
				width: 129.352,
				height: 216.429,
				frequency: [0.29947322607040405, 0.24354049563407898],
				numOctaves: 3,
				seed: 6337,
				scale: 3.131495714187622,
			},
		},
		bodyMask:
			'M100.989 96.1398C101.952 74.6109 120.056 57.9994 141.599 58.5671L163.59 59.1465L179.396 58.6943C201.489 58.0621 219.895 75.4905 220.468 97.5842L222.132 161.718L221.01 223.995C220.58 247.832 201.219 266.977 177.379 267.139L161.42 267.247L143.865 267.128C120.657 266.971 101.573 248.791 100.643 225.601C99.8241 205.167 99.0643 180.842 99.1093 161.718C99.156 141.918 100.066 116.767 100.989 96.1398Z',
		bodyShade: {
			d: 'M206.555 53.5547C211.747 58.3478 221.733 76.1743 224.928 89.9024C228.124 103.63 229.322 132.641 229.322 147.02C229.322 161.4 224.928 182.569 220.934 195.75C216.94 208.931 210.15 222.911 206.555 232.497C202.96 242.083 194.572 257.262 180.992 278.831',
			texture: {
				x: 123.854,
				y: -3.5793,
				width: 162.602,
				height: 339.547,
				frequency: [0.638672411441803, 0.638672411441803],
				numOctaves: 3,
				seed: 9325,
				scale: 60.744625091552734,
			},
		},
		stripes: [
			{
				d: 'M225.328 166.991V187.362C225.328 187.362 202.598 185.764 161.819 185.764C121.041 185.764 95.9141 187.362 95.9141 187.362V166.991C95.9141 166.991 121.041 165.394 161.819 165.394C202.598 165.394 225.328 166.991 225.328 166.991Z',
				texture: {
					x: 95.4587,
					y: 164.938,
					width: 130.325,
					height: 22.8791,
					frequency: [0.5960943698883057, 0.5960943698883057],
					numOctaves: 3,
					seed: 2172,
					scale: 0.9106900691986084,
				},
			},
			{
				d: 'M225.328 200.943V221.314C225.328 221.314 202.598 219.716 161.819 219.716C121.041 219.716 95.9141 221.314 95.9141 221.314V200.943C95.9141 200.943 121.041 199.346 161.819 199.346C202.598 199.346 225.328 200.943 225.328 200.943Z',
				texture: {
					x: 95.4587,
					y: 198.89,
					width: 130.325,
					height: 22.8791,
					frequency: [0.5960943698883057, 0.5960943698883057],
					numOctaves: 3,
					seed: 2172,
					scale: 0.9106900691986084,
				},
			},
			{
				d: 'M225.328 234.494V254.865C225.328 254.865 202.598 253.267 161.819 253.267C121.041 253.267 95.9141 254.865 95.9141 254.865V234.494C95.9141 234.494 121.041 232.896 161.819 232.896C202.598 232.896 225.328 234.494 225.328 234.494Z',
				texture: {
					x: 95.4587,
					y: 232.441,
					width: 130.325,
					height: 22.8791,
					frequency: [0.5960943698883057, 0.5960943698883057],
					numOctaves: 3,
					seed: 2172,
					scale: 0.9106900691986084,
				},
			},
		],
		eyes: [
			{
				d: 'M120.271 125.786C124.877 125.786 128.611 120.436 128.611 113.836C128.611 107.235 124.877 101.885 120.271 101.885C115.665 101.885 111.931 107.235 111.931 113.836C111.931 120.436 115.665 125.786 120.271 125.786Z',
				texture: {
					x: 110.685,
					y: 100.639,
					width: 19.1724,
					height: 26.394,
					frequency: [0.9990000128746033, 0.9990000128746033],
					numOctaves: 3,
					seed: 6148,
					scale: 1.6935639381408691,
				},
			},
		],
		stinger: {
			d: 'M209.429 275.238C203.374 262.089 188.144 270.95 195.052 281.869C200.98 291.239 212.946 298.802 221.919 299.995C223.698 300.111 224.224 298.053 222.861 296.904C218.538 295.207 215.485 288.387 209.429 275.238Z',
			texture: {
				x: 192.472,
				y: 267.844,
				width: 31.9786,
				height: 32.975,
				frequency: [0.9282835721969604, 0.7064296007156372],
				numOctaves: 3,
				seed: 192,
				scale: 1.6381428241729736,
			},
		},
		stars: [],
		squiggles: [],
		prop: null,
	},
	flyingRight: {
		source: 'flyingRight.svg',
		viewBox: {
			width: 320,
			height: 320,
		},
		wings: {
			tealRight: {
				d: 'M44.3651 188.466C69.2867 201.663 129.003 173.619 144.848 165.714C146.646 164.818 146.828 162.16 145.171 160.954C110.181 135.487 44.7096 127.098 15.4288 126.108C-14.8863 125.083 22.2385 176.749 44.3651 188.466Z',
				texture: {
					x: 2.80971,
					y: 124.902,
					width: 144.693,
					height: 68.2325,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
			tealLeft: {
				d: 'M52.0754 189.856C76.9968 203.053 136.714 175.009 152.559 167.104C154.356 166.207 154.538 163.55 152.882 162.344C117.891 136.877 52.4199 128.488 23.139 127.497C-7.1763 126.473 29.9484 178.139 52.0754 189.856Z',
				texture: {
					x: 10.5197,
					y: 126.292,
					width: 144.693,
					height: 68.2325,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
			purpleRight: {
				d: 'M49.0894 161.052C68.0855 181.895 133.766 175.68 151.35 173.594C153.344 173.358 154.414 170.918 153.262 169.223C128.937 133.431 70.1512 103.41 42.9278 92.5846C14.7423 81.3754 32.2235 142.547 49.0894 161.052Z',
				texture: {
					x: 26.8485,
					y: 90.0333,
					width: 128.077,
					height: 87.2542,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
			purpleLeft: {
				d: 'M56.2354 161.747C75.2312 182.589 140.912 176.375 158.496 174.289C160.49 174.052 161.56 171.613 160.408 169.918C136.082 134.126 77.2973 104.105 50.0734 93.2788C21.8878 82.0703 39.3695 143.242 56.2354 161.747Z',
				texture: {
					x: 33.9943,
					y: 90.7277,
					width: 128.077,
					height: 87.2545,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
		},
		leftArm: {
			d: 'M158.838 167C158.838 167 148.5 169.5 133 175.5C117.5 181.499 99.5001 181.499 99.5001 181.499',
			texture: {
				x: 85.6735,
				y: 153.17,
				width: 86.9938,
				height: 42.1558,
				frequency: [0.9990000128746033, 0.732045590877533],
				numOctaves: 3,
				seed: 8637,
				scale: 1.5817248821258545,
			},
			front: true,
			renderMode: 'stroke',
		},
		rightArm: {
			d: 'M176 162C176 162 188.507 166.503 201.81 169.535C215.109 172.568 275 162 275 162',
			texture: {
				x: 162.17,
				y: 148.17,
				width: 126.659,
				height: 35.7392,
				frequency: [0.9990000128746033, 0.732045590877533],
				numOctaves: 3,
				seed: 8637,
				scale: 1.5817248821258545,
			},
			front: false,
			renderMode: 'stroke',
		},
		antennae: [
			{
				stem: {
					d: 'M226.809 91.1131C236.976 77.5562 243.19 59.4803 233.87 40.557',
					texture: {
						x: 221.848,
						y: 35.5953,
						width: 21.5646,
						height: 60.479,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 2801,
						scale: 1.933219313621521,
					},
				},
				tip: {
					d: 'M226.809 46.4885C223.221 42.9008 223.221 37.0841 226.809 33.4964C230.396 29.9087 236.213 29.9087 239.801 33.4964C243.388 37.0841 243.388 42.9008 239.801 46.4885C236.213 50.0761 230.396 50.0761 226.809 46.4885Z',
					texture: {
						x: 222.752,
						y: 29.4396,
						width: 21.1058,
						height: 21.1057,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 8737,
						scale: 2.732070207595825,
					},
				},
				front: false,
			},
			{
				stem: {
					d: 'M239.488 103.793C249.656 90.2359 255.869 72.1599 246.549 53.2367',
					texture: {
						x: 234.527,
						y: 48.2749,
						width: 21.5646,
						height: 60.479,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 2801,
						scale: 1.933219313621521,
					},
				},
				tip: {
					d: 'M239.488 59.1681C235.9 55.5805 235.9 49.7637 239.488 46.1761C243.075 42.5884 248.892 42.5884 252.48 46.1761C256.067 49.7637 256.067 55.5805 252.48 59.1681C248.892 62.7558 243.075 62.7558 239.488 59.1681Z',
					texture: {
						x: 235.431,
						y: 42.1193,
						width: 21.1058,
						height: 21.1057,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 8737,
						scale: 2.732070207595825,
					},
				},
				front: true,
			},
		],
		body: {
			d: 'M166.279 73.4373C181.263 59.6722 204.199 59.3698 219.54 72.7351L236.456 87.4726L251.121 104.759C264.345 120.346 263.667 143.403 249.548 158.186L205.455 204.355L160.409 247.47C143.318 263.828 116.344 263.717 99.3884 247.219L87.9045 236.045L76.6968 224.837C60.0261 208.166 59.484 181.31 75.4683 163.98L118.465 117.364L166.279 73.4373Z',
			texture: {
				x: 60.6645,
				y: 59.7454,
				width: 203.105,
				height: 203.083,
				frequency: [0.29947322607040405, 0.24354049563407898],
				numOctaves: 3,
				seed: 6337,
				scale: 3.131495714187622,
			},
		},
		bodyMask:
			'M166.165 72.3223C182.069 57.7804 206.617 58.8358 221.449 74.4704L236.588 90.4297L248.085 101.287C264.154 116.461 264.845 141.8 249.628 157.828L205.455 204.355L160.625 247.597C143.466 264.149 116.238 263.996 99.2659 247.253L87.9046 236.045L75.5756 223.547C59.2767 207.025 58.6375 180.676 74.3775 163.621C88.2473 148.593 104.91 130.855 118.465 117.364C132.499 103.396 150.926 86.2554 166.165 72.3223Z',
		bodyShade: {
			d: 'M270.923 116.856C271.206 123.917 265.661 143.584 258.214 155.55C250.766 167.517 231.1 188.878 220.932 199.045C210.764 209.213 192.688 221.076 180.544 227.572C168.399 234.068 153.712 239.151 144.392 243.388C135.071 247.625 118.408 252.426 93.5533 258.075',
			texture: {
				x: 36.4136,
				y: 59.7223,
				width: 291.652,
				height: 255.492,
				frequency: [0.638672411441803, 0.638672411441803],
				numOctaves: 3,
				seed: 9325,
				scale: 60.744625091552734,
			},
		},
		stripes: [
			{
				d: 'M203.986 210.343L189.582 224.747C189.582 224.747 174.639 207.545 145.804 178.71C116.969 149.875 98.0724 133.238 98.0724 133.238L112.477 118.833C112.477 118.833 131.374 135.471 160.208 164.306C189.043 193.14 203.986 210.343 203.986 210.343Z',
				texture: {
					x: 97.6172,
					y: 118.378,
					width: 106.824,
					height: 106.824,
					frequency: [0.5960943698883057, 0.5960943698883057],
					numOctaves: 3,
					seed: 2172,
					scale: 0.9106900691986084,
				},
			},
			{
				d: 'M179.978 234.351L165.574 248.755C165.574 248.755 150.631 231.553 121.796 202.718C92.9615 173.883 74.0646 157.245 74.0646 157.245L88.4689 142.841C88.4689 142.841 107.366 159.479 136.201 188.313C165.036 217.148 179.978 234.351 179.978 234.351Z',
				texture: {
					x: 73.6094,
					y: 142.386,
					width: 106.824,
					height: 106.824,
					frequency: [0.5960943698883057, 0.5960943698883057],
					numOctaves: 3,
					seed: 2172,
					scale: 0.9106900691986084,
				},
			},
			{
				d: 'M156.254 258.075L141.85 272.479C141.85 272.479 126.907 255.277 98.0725 226.442C69.2376 197.607 50.3408 180.969 50.3408 180.969L64.745 166.565C64.745 166.565 83.6419 183.202 112.477 212.037C141.312 240.872 156.254 258.075 156.254 258.075Z',
				texture: {
					x: 49.8855,
					y: 166.11,
					width: 106.824,
					height: 106.824,
					frequency: [0.5960943698883057, 0.5960943698883057],
					numOctaves: 3,
					seed: 2172,
					scale: 0.9106900691986084,
				},
			},
		],
		eyes: [
			{
				d: 'M215.453 163.538C218.71 166.795 225.134 165.651 229.801 160.984C234.468 156.317 235.611 149.894 232.354 146.637C229.097 143.38 222.674 144.523 218.007 149.19C213.339 153.857 212.196 160.281 215.453 163.538Z',
				texture: {
					x: 212.352,
					y: 143.535,
					width: 23.1032,
					height: 23.1033,
					frequency: [0.9990000128746033, 0.9990000128746033],
					numOctaves: 3,
					seed: 6148,
					scale: 1.6935639381408691,
				},
			},
			{
				d: 'M249.346 197.43C252.603 200.687 259.026 199.544 263.693 194.877C268.361 190.21 269.504 183.786 266.247 180.529C262.99 177.272 256.566 178.415 251.899 183.082C247.232 187.749 246.089 194.173 249.346 197.43Z',
				texture: {
					x: 246.245,
					y: 177.428,
					width: 23.1032,
					height: 23.1033,
					frequency: [0.9990000128746033, 0.9990000128746033],
					numOctaves: 3,
					seed: 6148,
					scale: 1.6935639381408691,
				},
			},
		],
		stinger: {
			d: 'M41.5519 202.692C55.1317 197.676 59.6347 214.71 47.0289 217.547C36.2116 219.98 22.4034 216.867 15.2144 211.366C13.8743 210.19 14.9581 208.363 16.7343 208.514C20.9912 210.371 27.9722 207.708 41.5519 202.692Z',
			texture: {
				x: 13.7962,
				y: 200.954,
				width: 41.4829,
				height: 18.2493,
				frequency: [0.9282835721969604, 0.7064296007156372],
				numOctaves: 3,
				seed: 192,
				scale: 1.6381428241729736,
			},
		},
		stars: [],
		squiggles: [],
		prop: null,
	},
	flyingLeft: {
		source: 'flying left.svg',
		viewBox: {
			width: 322,
			height: 321,
		},
		wings: {
			tealRight: {
				d: 'M272.929 169.466C248.007 182.663 188.29 154.619 172.446 146.714C170.648 145.818 170.466 143.16 172.123 141.954C207.113 116.487 272.584 108.098 301.865 107.108C332.18 106.083 295.055 157.749 272.929 169.466Z',
				texture: {
					x: 169.792,
					y: 105.902,
					width: 144.693,
					height: 68.2325,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
			tealLeft: {
				d: 'M279.806 160.856C254.885 174.053 195.168 146.009 179.323 138.104C177.526 137.207 177.343 134.55 179 133.344C213.99 107.877 279.461 99.4879 308.742 98.4974C339.058 97.4729 301.933 149.139 279.806 160.856Z',
				texture: {
					x: 176.669,
					y: 97.2921,
					width: 144.693,
					height: 68.2325,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
			purpleRight: {
				d: 'M268.205 142.052C249.209 162.895 183.528 156.68 165.944 154.594C163.95 154.358 162.88 151.918 164.032 150.223C188.358 114.431 247.143 84.4104 274.366 73.5846C302.552 62.3754 285.071 123.547 268.205 142.052Z',
				texture: {
					x: 162.368,
					y: 71.0333,
					width: 128.077,
					height: 87.2542,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
			purpleLeft: {
				d: 'M275.646 132.747C256.65 153.589 190.97 147.375 173.386 145.289C171.391 145.052 170.322 142.613 171.473 140.918C195.799 105.126 254.584 75.1052 281.808 64.2788C309.994 53.0703 292.512 114.242 275.646 132.747Z',
				texture: {
					x: 169.81,
					y: 61.7277,
					width: 128.077,
					height: 87.2545,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
		},
		leftArm: {
			d: 'M144 173C144 173 131 192 104.5 192C78 192 53.5 180 53.5 180',
			texture: {
				x: 39.6704,
				y: 159.172,
				width: 118.158,
				height: 46.6546,
				frequency: [0.9990000128746033, 0.732045590877533],
				numOctaves: 3,
				seed: 8637,
				scale: 1.5817248821258545,
			},
			front: false,
			renderMode: 'stroke',
		},
		rightArm: {
			d: 'M164.385 164.986C164.385 164.986 182.501 173.499 195.501 175.499C208.5 177.5 227 175.499 227 175.499',
			texture: {
				x: 150.555,
				y: 151.156,
				width: 90.2729,
				height: 39.0593,
				frequency: [0.9990000128746033, 0.732045590877533],
				numOctaves: 3,
				seed: 8637,
				scale: 1.5817248821258545,
			},
			front: true,
			renderMode: 'stroke',
		},
		antennae: [
			{
				stem: {
					d: 'M93.3041 106.378C83.1364 92.8214 76.9228 74.7455 86.2432 55.8222',
					texture: {
						x: 76.7006,
						y: 50.8605,
						width: 21.5646,
						height: 60.479,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 2801,
						scale: 1.933219313621521,
					},
				},
				tip: {
					d: 'M93.305 61.7534C96.8927 58.1657 96.8927 52.3489 93.305 48.7613C89.7173 45.1736 83.9006 45.1736 80.3129 48.7613C76.7253 52.3489 76.7253 58.1657 80.3129 61.7534C83.9006 65.341 89.7173 65.341 93.305 61.7534Z',
					texture: {
						x: 76.2561,
						y: 44.7045,
						width: 21.1057,
						height: 21.1057,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 8737,
						scale: 2.732070207595825,
					},
				},
				front: false,
			},
			{
				stem: {
					d: 'M98.8766 94.731C93.6803 78.6012 93.6946 59.4871 108.672 44.6327',
					texture: {
						x: 90.7865,
						y: 39.6719,
						width: 22.8459,
						height: 60.0211,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 2801,
						scale: 1.933219313621521,
					},
				},
				tip: {
					d: 'M113.415 52.541C117.976 50.3179 119.871 44.8185 117.648 40.2577C115.424 35.697 109.925 33.8019 105.364 36.025C100.804 38.2482 98.9085 43.7475 101.132 48.3083C103.355 52.869 108.854 54.7641 113.415 52.541Z',
					texture: {
						x: 98.8347,
						y: 33.7281,
						width: 21.1098,
						height: 21.1098,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 8737,
						scale: 2.732070207595825,
					},
				},
				front: true,
			},
		],
		body: {
			d: 'M72.8587 157.539C59.0936 142.556 58.7912 119.62 72.1565 104.279L86.894 87.3626L104.18 72.6974C119.768 59.473 142.824 60.1517 157.607 74.27L203.776 118.363L246.891 163.41C263.249 180.5 263.138 207.475 246.64 224.43L235.466 235.914L224.258 247.122C207.588 263.792 180.731 264.334 163.401 248.35L116.786 205.354L72.8587 157.539Z',
			texture: {
				x: 59.1668,
				y: 60.0494,
				width: 203.083,
				height: 203.105,
				frequency: [0.29947322607040405, 0.24354049563407898],
				numOctaves: 3,
				seed: 6337,
				scale: 3.131495714187622,
			},
		},
		bodyMask:
			'M71.7439 157.653C57.2019 141.749 58.2573 117.201 73.8919 102.37L89.8513 87.2297L100.709 75.7329C115.883 59.6644 141.222 58.9731 157.25 74.1903L203.776 118.363L247.019 163.193C263.57 180.352 263.417 207.58 246.674 224.552L235.466 235.914L222.969 248.243C206.447 264.541 180.097 265.181 163.043 249.441C148.014 235.571 130.276 218.908 116.786 205.353C102.818 191.319 85.677 172.892 71.7439 157.653Z',
		bodyShade: {
			d: 'M116.278 52.8948C123.339 52.6124 143.005 58.1567 154.972 65.6045C166.939 73.0522 188.299 92.7184 198.467 102.886C208.635 113.054 220.497 131.13 226.993 143.274C233.489 155.419 238.573 170.106 242.81 179.426C247.046 188.747 251.848 205.41 257.496 230.265',
			texture: {
				x: 59.1438,
				y: -4.24748,
				width: 255.492,
				height: 291.652,
				frequency: [0.638672411441803, 0.638672411441803],
				numOctaves: 3,
				seed: 9325,
				scale: 60.744625091552734,
			},
		},
		stripes: [
			{
				d: 'M209.764 119.831L224.169 134.236C224.169 134.236 206.966 149.178 178.131 178.013C149.297 206.848 132.659 225.745 132.659 225.745L118.255 211.341C118.255 211.341 134.892 192.444 163.727 163.609C192.562 134.774 209.764 119.831 209.764 119.831Z',
				texture: {
					x: 117.8,
					y: 119.376,
					width: 106.824,
					height: 106.824,
					frequency: [0.5960943698883057, 0.5960943698883057],
					numOctaves: 3,
					seed: 2172,
					scale: 0.9106900691986084,
				},
			},
			{
				d: 'M233.773 143.839L248.177 158.243C248.177 158.243 230.975 173.186 202.14 202.021C173.305 230.856 156.667 249.753 156.667 249.753L142.263 235.349C142.263 235.349 158.901 216.452 187.735 187.617C216.57 158.782 233.773 143.839 233.773 143.839Z',
				texture: {
					x: 141.808,
					y: 143.384,
					width: 106.824,
					height: 106.824,
					frequency: [0.5960943698883057, 0.5960943698883057],
					numOctaves: 3,
					seed: 2172,
					scale: 0.9106900691986084,
				},
			},
			{
				d: 'M257.496 167.564L271.9 181.968C271.9 181.968 254.698 196.911 225.863 225.746C197.028 254.581 180.391 273.477 180.391 273.477L165.987 259.073C165.987 259.073 182.624 240.176 211.459 211.341C240.294 182.507 257.496 167.564 257.496 167.564Z',
				texture: {
					x: 165.532,
					y: 167.108,
					width: 106.824,
					height: 106.824,
					frequency: [0.5960943698883057, 0.5960943698883057],
					numOctaves: 3,
					seed: 2172,
					scale: 0.9106900691986084,
				},
			},
		],
		eyes: [
			{
				d: 'M72.4493 198.875C75.7063 195.618 74.5632 189.194 69.8961 184.527C65.229 179.86 58.8053 178.717 55.5483 181.974C52.2913 185.231 53.4344 191.655 58.1015 196.322C62.7686 200.989 69.1923 202.132 72.4493 198.875Z',
				texture: {
					x: 52.4471,
					y: 178.873,
					width: 23.1033,
					height: 23.1033,
					frequency: [0.9990000128746033, 0.9990000128746033],
					numOctaves: 3,
					seed: 6148,
					scale: 1.6935639381408691,
				},
			},
			{
				d: 'M106.342 164.982C109.599 161.725 108.456 155.302 103.789 150.635C99.1214 145.968 92.6977 144.824 89.4407 148.081C86.1838 151.338 87.3269 157.762 91.994 162.429C96.661 167.096 103.085 168.239 106.342 164.982Z',
				texture: {
					x: 86.3396,
					y: 144.98,
					width: 23.1033,
					height: 23.1033,
					frequency: [0.9990000128746033, 0.9990000128746033],
					numOctaves: 3,
					seed: 6148,
					scale: 1.6935639381408691,
				},
			},
		],
		stinger: {
			d: 'M283.264 201.795C271.445 193.435 262.686 208.724 274.128 214.726C283.947 219.877 298.091 220.444 306.459 216.99C308.057 216.202 307.483 214.156 305.729 213.842C301.136 214.534 295.082 210.155 283.264 201.795Z',
			texture: {
				x: 267.965,
				y: 198.532,
				width: 40.2517,
				height: 21.4591,
				frequency: [0.9282835721969604, 0.7064296007156372],
				numOctaves: 3,
				seed: 192,
				scale: 1.6381428241729736,
			},
		},
		stars: [],
		squiggles: [],
		prop: null,
	},
	waving: {
		source: 'waving.svg',
		viewBox: {
			width: 320,
			height: 320,
		},
		wings: {
			tealRight: {
				d: 'M256.929 189.466C232.007 202.663 172.29 174.619 156.446 166.714C154.648 165.818 154.466 163.16 156.123 161.954C191.113 136.487 256.584 128.098 285.865 127.108C316.18 126.083 279.055 177.749 256.929 189.466Z',
				texture: {
					x: 153.792,
					y: 125.902,
					width: 144.693,
					height: 68.2325,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
			tealLeft: {
				d: 'M65.3654 190.856C90.2869 204.053 150.004 176.009 165.849 168.104C167.646 167.207 167.828 164.55 166.172 163.344C131.181 137.877 65.7099 129.488 36.429 128.497C6.11374 127.473 43.2385 179.139 65.3654 190.856Z',
				texture: {
					x: 23.8097,
					y: 127.292,
					width: 144.693,
					height: 68.2325,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
			purpleRight: {
				d: 'M252.205 162.052C233.208 182.895 167.528 176.68 149.944 174.594C147.95 174.358 146.88 171.918 148.032 170.223C172.357 134.431 231.143 104.41 258.366 93.5846C286.552 82.3754 269.07 143.547 252.205 162.052Z',
				texture: {
					x: 146.368,
					y: 91.0333,
					width: 128.077,
					height: 87.2542,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
			purpleLeft: {
				d: 'M69.5254 162.747C88.5213 183.589 154.202 177.375 171.786 175.289C173.78 175.052 174.85 172.613 173.698 170.918C149.372 135.126 90.5874 105.105 63.3635 94.2788C35.1779 83.0703 52.6595 144.242 69.5254 162.747Z',
				texture: {
					x: 47.2843,
					y: 91.7277,
					width: 128.077,
					height: 87.2545,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
		},
		leftArm: {
			d: 'M101.688 164.507C101.688 164.507 94.0353 183.675 92.3274 198.263C90.6194 212.851 95.9447 234.84 95.9447 234.84',
			texture: {
				x: 78.1645,
				y: 150.677,
				width: 37.3542,
				height: 97.9934,
				frequency: [0.9990000128746033, 0.732045590877533],
				numOctaves: 3,
				seed: 8637,
				scale: 1.5817248821258545,
			},
			front: true,
			renderMode: 'stroke',
		},
		rightArm: {
			d: 'M220.246 164.507C220.246 164.507 230.262 149.159 236 135.5C241.738 121.841 243.255 102.924 243.255 102.924',
			texture: {
				x: 206.418,
				y: 89.0964,
				width: 50.6645,
				height: 89.2386,
				frequency: [0.9990000128746033, 0.732045590877533],
				numOctaves: 3,
				seed: 8637,
				scale: 1.5817248821258545,
			},
			front: true,
			renderMode: 'stroke',
		},
		antennae: [
			{
				stem: {
					d: 'M134.559 71.9279C136.956 55.1521 145.344 37.9768 165.315 31.1865',
					texture: {
						x: 129.598,
						y: 26.2246,
						width: 40.6791,
						height: 50.6647,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 2801,
						scale: 1.933219313621521,
					},
				},
				tip: {
					d: 'M166.114 40.3736C171.188 40.3736 175.301 36.2605 175.301 31.1868C175.301 26.113 171.188 22 166.114 22C161.04 22 156.927 26.113 156.927 31.1868C156.927 36.2605 161.04 40.3736 166.114 40.3736Z',
					texture: {
						x: 155.561,
						y: 20.634,
						width: 21.1056,
						height: 21.1057,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 8737,
						scale: 2.732070207595825,
					},
				},
				front: true,
			},
			{
				stem: {
					d: 'M182.49 71.9279C184.887 55.1521 193.275 37.9768 213.246 31.1865',
					texture: {
						x: 177.529,
						y: 26.2246,
						width: 40.6791,
						height: 50.6647,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 2801,
						scale: 1.933219313621521,
					},
				},
				tip: {
					d: 'M214.045 40.3736C219.119 40.3736 223.232 36.2605 223.232 31.1868C223.232 26.113 219.119 22 214.045 22C208.971 22 204.858 26.113 204.858 31.1868C204.858 36.2605 208.971 40.3736 214.045 40.3736Z',
					texture: {
						x: 203.492,
						y: 20.634,
						width: 21.1056,
						height: 21.1057,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 8737,
						scale: 2.732070207595825,
					},
				},
				front: true,
			},
		],
		body: {
			d: 'M101.751 96.8471C102.613 76.5189 118.617 60.087 138.915 58.6899L161.298 57.1494L183.891 59.0027C204.264 60.6738 220.087 77.4571 220.557 97.8933L222.025 161.718L220.659 224.058C220.141 247.709 200.989 266.705 177.334 267.028L161.312 267.247H145.462C121.886 267.247 102.513 248.64 101.561 225.084L99.002 161.718L101.751 96.8471Z',
			texture: {
				x: 95.8371,
				y: 53.9814,
				width: 129.352,
				height: 216.429,
				frequency: [0.29947322607040405, 0.24354049563407898],
				numOctaves: 3,
				seed: 6337,
				scale: 3.131495714187622,
			},
		},
		bodyMask:
			'M100.881 96.1398C101.845 74.6109 119.949 57.9994 141.492 58.5671L163.482 59.1465L179.289 58.6943C201.381 58.0621 219.787 75.4905 220.361 97.5842L222.025 161.718L220.902 223.995C220.473 247.832 201.112 266.977 177.271 267.139L161.312 267.247L143.757 267.128C120.55 266.971 101.466 248.791 100.536 225.601C99.7167 205.167 98.9569 180.842 99.0019 161.718C99.0485 141.918 99.9583 116.767 100.881 96.1398Z',
		bodyShade: {
			d: 'M206.447 53.5546C211.64 58.3477 221.626 76.1742 224.821 89.9023C228.016 103.63 229.215 132.641 229.215 147.02C229.215 161.399 224.821 182.569 220.827 195.75C216.832 208.931 210.042 222.911 206.447 232.497C202.853 242.083 194.465 257.262 180.884 278.831',
			texture: {
				x: 123.747,
				y: -3.57931,
				width: 162.602,
				height: 339.547,
				frequency: [0.638672411441803, 0.638672411441803],
				numOctaves: 3,
				seed: 9325,
				scale: 60.744625091552734,
			},
		},
		stripes: [
			{
				d: 'M225.22 166.991V187.362C225.22 187.362 202.49 185.764 161.712 185.764C120.933 185.764 95.8065 187.362 95.8065 187.362V166.991C95.8065 166.991 120.933 165.393 161.712 165.393C202.49 165.393 225.22 166.991 225.22 166.991Z',
				texture: {
					x: 95.3512,
					y: 164.938,
					width: 130.325,
					height: 22.8791,
					frequency: [0.5960943698883057, 0.5960943698883057],
					numOctaves: 3,
					seed: 2172,
					scale: 0.9106900691986084,
				},
			},
			{
				d: 'M225.22 200.943V221.314C225.22 221.314 202.49 219.716 161.712 219.716C120.933 219.716 95.8065 221.314 95.8065 221.314V200.943C95.8065 200.943 120.933 199.346 161.712 199.346C202.49 199.346 225.22 200.943 225.22 200.943Z',
				texture: {
					x: 95.3512,
					y: 198.89,
					width: 130.325,
					height: 22.8791,
					frequency: [0.5960943698883057, 0.5960943698883057],
					numOctaves: 3,
					seed: 2172,
					scale: 0.9106900691986084,
				},
			},
			{
				d: 'M225.22 234.494V254.865C225.22 254.865 202.49 253.267 161.712 253.267C120.933 253.267 95.8065 254.865 95.8065 254.865V234.494C95.8065 234.494 120.933 232.896 161.712 232.896C202.49 232.896 225.22 234.494 225.22 234.494Z',
				texture: {
					x: 95.3512,
					y: 232.441,
					width: 130.325,
					height: 22.8791,
					frequency: [0.5960943698883057, 0.5960943698883057],
					numOctaves: 3,
					seed: 2172,
					scale: 0.9106900691986084,
				},
			},
		],
		eyes: [
			{
				d: 'M136.34 125.786C140.946 125.786 144.68 120.436 144.68 113.836C144.68 107.235 140.946 101.885 136.34 101.885C131.734 101.885 128 107.235 128 113.836C128 120.436 131.734 125.786 136.34 125.786Z',
				texture: {
					x: 126.754,
					y: 100.639,
					width: 19.1724,
					height: 26.394,
					frequency: [0.9990000128746033, 0.9990000128746033],
					numOctaves: 3,
					seed: 6148,
					scale: 1.6935639381408691,
				},
			},
			{
				d: 'M184.271 125.786C188.877 125.786 192.611 120.436 192.611 113.836C192.611 107.235 188.877 101.885 184.271 101.885C179.665 101.885 175.931 107.235 175.931 113.836C175.931 120.436 179.665 125.786 184.271 125.786Z',
				texture: {
					x: 174.685,
					y: 100.639,
					width: 19.1724,
					height: 26.394,
					frequency: [0.9990000128746033, 0.9990000128746033],
					numOctaves: 3,
					seed: 6148,
					scale: 1.6935639381408691,
				},
			},
		],
		stinger: {
			d: 'M209.322 275.238C203.266 262.089 188.037 270.95 194.945 281.869C200.873 291.239 212.838 298.802 221.812 299.995C223.59 300.111 224.116 298.053 222.754 296.904C218.43 295.207 215.377 288.387 209.322 275.238Z',
			texture: {
				x: 192.365,
				y: 267.844,
				width: 31.9786,
				height: 32.975,
				frequency: [0.9282835721969604, 0.7064296007156372],
				numOctaves: 3,
				seed: 192,
				scale: 1.6381428241729736,
			},
		},
		stars: [],
		squiggles: [],
		prop: null,
	},
	pointingRight: {
		source: 'pointingRight.svg',
		viewBox: {
			width: 320,
			height: 320,
		},
		wings: {
			tealRight: {
				d: 'M243.639 188.466C218.717 201.663 159 173.619 143.156 165.714C141.358 164.818 141.176 162.16 142.833 160.954C177.823 135.487 243.294 127.098 272.575 126.108C302.89 125.083 265.765 176.749 243.639 188.466Z',
				texture: {
					x: 140.502,
					y: 124.902,
					width: 144.693,
					height: 68.2325,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
			tealLeft: {
				d: 'M52.0754 189.856C76.9968 203.053 136.714 175.009 152.559 167.104C154.356 166.207 154.538 163.55 152.882 162.344C117.891 136.877 52.4199 128.488 23.139 127.497C-7.1763 126.473 29.9484 178.139 52.0754 189.856Z',
				texture: {
					x: 10.5197,
					y: 126.292,
					width: 144.693,
					height: 68.2325,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
			purpleRight: {
				d: 'M238.915 161.052C219.918 181.895 154.238 175.68 136.654 173.594C134.66 173.358 133.59 170.918 134.742 169.223C159.067 133.431 217.853 103.41 245.076 92.5846C273.262 81.3754 255.78 142.547 238.915 161.052Z',
				texture: {
					x: 133.078,
					y: 90.0333,
					width: 128.077,
					height: 87.2542,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
			purpleLeft: {
				d: 'M56.2354 161.747C75.2312 182.589 140.912 176.375 158.496 174.289C160.49 174.052 161.56 171.613 160.408 169.918C136.082 134.126 77.2973 104.105 50.0734 93.2788C21.8878 82.0703 39.3695 143.242 56.2354 161.747Z',
				texture: {
					x: 33.9943,
					y: 90.7277,
					width: 128.077,
					height: 87.2545,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
		},
		leftArm: {
			d: 'M107.466 163.994C107.466 163.994 98.0713 182.371 95.0204 196.739C91.9694 211.106 95.2365 233.494 95.2365 233.494',
			texture: {
				x: 79.8908,
				y: 150.165,
				width: 41.4045,
				height: 97.1578,
				frequency: [0.9990000128746033, 0.732045590877533],
				numOctaves: 3,
				seed: 8637,
				scale: 1.5817248821258545,
			},
			front: true,
			renderMode: 'stroke',
		},
		rightArm: {
			d: 'M216 162C216 162 235.47 159.841 247 155.5C258.53 151.159 276 128 276 128',
			texture: {
				x: 202.172,
				y: 114.173,
				width: 87.6553,
				height: 61.6552,
				frequency: [0.9990000128746033, 0.732045590877533],
				numOctaves: 3,
				seed: 8637,
				scale: 1.5817248821258545,
			},
			front: false,
			renderMode: 'stroke',
		},
		antennae: [
			{
				stem: {
					d: 'M129.667 70.9279C132.063 54.1521 140.451 36.9768 160.422 30.1865',
					texture: {
						x: 124.705,
						y: 25.2246,
						width: 40.6791,
						height: 50.6647,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 2801,
						scale: 1.933219313621521,
					},
				},
				tip: {
					d: 'M161.221 39.3736C166.295 39.3736 170.408 35.2605 170.408 30.1868C170.408 25.113 166.295 21 161.221 21C156.147 21 152.034 25.113 152.034 30.1868C152.034 35.2605 156.147 39.3736 161.221 39.3736Z',
					texture: {
						x: 150.668,
						y: 19.634,
						width: 21.1056,
						height: 21.1057,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 8737,
						scale: 2.732070207595825,
					},
				},
				front: true,
			},
			{
				stem: {
					d: 'M177.598 70.9279C179.994 54.1521 188.382 36.9768 208.353 30.1865',
					texture: {
						x: 172.636,
						y: 25.2246,
						width: 40.6791,
						height: 50.6647,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 2801,
						scale: 1.933219313621521,
					},
				},
				tip: {
					d: 'M209.152 39.3736C214.226 39.3736 218.339 35.2605 218.339 30.1868C218.339 25.113 214.226 21 209.152 21C204.078 21 199.965 25.113 199.965 30.1868C199.965 35.2605 204.078 39.3736 209.152 39.3736Z',
					texture: {
						x: 198.599,
						y: 19.634,
						width: 21.1056,
						height: 21.1057,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 8737,
						scale: 2.732070207595825,
					},
				},
				front: false,
			},
		],
		body: {
			d: 'M102.858 95.8472C103.72 75.5191 119.724 59.0871 140.022 57.69L162.405 56.1495L184.998 58.0028C205.371 59.6739 221.195 76.4572 221.664 96.8934L223.132 160.718L221.766 223.058C221.248 246.71 202.096 265.705 178.441 266.028L162.419 266.247H146.569C122.993 266.247 103.62 247.64 102.668 224.084L100.109 160.718L102.858 95.8472Z',
			texture: {
				x: 96.9441,
				y: 52.9816,
				width: 129.352,
				height: 216.429,
				frequency: [0.29947322607040405, 0.24354049563407898],
				numOctaves: 3,
				seed: 6337,
				scale: 3.131495714187622,
			},
		},
		bodyMask:
			'M101.989 95.1398C102.952 73.6109 121.056 56.9994 142.599 57.5671L164.59 58.1465L180.396 57.6943C202.489 57.0621 220.895 74.4905 221.468 96.5842L223.132 160.718L222.01 222.995C221.58 246.832 202.219 265.977 178.379 266.139L162.42 266.247L144.865 266.128C121.657 265.971 102.573 247.791 101.643 224.601C100.824 204.167 100.064 179.842 100.109 160.718C100.156 140.918 101.066 115.767 101.989 95.1398Z',
		bodyShade: {
			d: 'M207.555 52.5546C212.747 57.3477 222.733 75.1742 225.928 88.9023C229.124 102.63 230.322 131.641 230.322 146.02C230.322 160.399 225.928 181.569 221.934 194.75C217.94 207.931 211.15 221.911 207.555 231.497C203.96 241.083 195.572 256.262 181.992 277.831',
			texture: {
				x: 124.854,
				y: -4.57931,
				width: 162.602,
				height: 339.547,
				frequency: [0.638672411441803, 0.638672411441803],
				numOctaves: 3,
				seed: 9325,
				scale: 60.744625091552734,
			},
		},
		stripes: [
			{
				d: 'M226.328 165.991V186.362C226.328 186.362 203.598 184.764 162.819 184.764C122.04 184.764 96.9139 186.362 96.9139 186.362V165.991C96.9139 165.991 122.04 164.393 162.819 164.393C203.598 164.393 226.328 165.991 226.328 165.991Z',
				texture: {
					x: 96.4586,
					y: 163.938,
					width: 130.325,
					height: 22.8791,
					frequency: [0.5960943698883057, 0.5960943698883057],
					numOctaves: 3,
					seed: 2172,
					scale: 0.9106900691986084,
				},
			},
			{
				d: 'M226.328 199.943V220.314C226.328 220.314 203.598 218.716 162.819 218.716C122.04 218.716 96.9139 220.314 96.9139 220.314V199.943C96.9139 199.943 122.04 198.346 162.819 198.346C203.598 198.346 226.328 199.943 226.328 199.943Z',
				texture: {
					x: 96.4586,
					y: 197.89,
					width: 130.325,
					height: 22.8791,
					frequency: [0.5960943698883057, 0.5960943698883057],
					numOctaves: 3,
					seed: 2172,
					scale: 0.9106900691986084,
				},
			},
			{
				d: 'M226.328 233.494V253.865C226.328 253.865 203.598 252.267 162.819 252.267C122.04 252.267 96.9139 253.865 96.9139 253.865V233.494C96.9139 233.494 122.04 231.896 162.819 231.896C203.598 231.896 226.328 233.494 226.328 233.494Z',
				texture: {
					x: 96.4586,
					y: 231.441,
					width: 130.325,
					height: 22.8791,
					frequency: [0.5960943698883057, 0.5960943698883057],
					numOctaves: 3,
					seed: 2172,
					scale: 0.9106900691986084,
				},
			},
		],
		eyes: [
			{
				d: 'M155.432 124.786C160.038 124.786 163.772 119.436 163.772 112.836C163.772 106.235 160.038 100.885 155.432 100.885C150.826 100.885 147.092 106.235 147.092 112.836C147.092 119.436 150.826 124.786 155.432 124.786Z',
				texture: {
					x: 145.846,
					y: 99.6386,
					width: 19.1724,
					height: 26.394,
					frequency: [0.9990000128746033, 0.9990000128746033],
					numOctaves: 3,
					seed: 6148,
					scale: 1.6935639381408691,
				},
			},
			{
				d: 'M203.363 124.786C207.969 124.786 211.703 119.436 211.703 112.836C211.703 106.235 207.969 100.885 203.363 100.885C198.757 100.885 195.023 106.235 195.023 112.836C195.023 119.436 198.757 124.786 203.363 124.786Z',
				texture: {
					x: 193.777,
					y: 99.6386,
					width: 19.1724,
					height: 26.394,
					frequency: [0.9990000128746033, 0.9990000128746033],
					numOctaves: 3,
					seed: 6148,
					scale: 1.6935639381408691,
				},
			},
		],
		stinger: {
			d: 'M110.493 274.238C116.549 261.089 131.778 269.95 124.87 280.869C118.942 290.239 106.977 297.802 98.0034 298.995C96.2245 299.111 95.6986 297.053 97.0613 295.904C101.385 294.207 104.438 287.387 110.493 274.238Z',
			texture: {
				x: 95.4718,
				y: 266.844,
				width: 31.9786,
				height: 32.975,
				frequency: [0.9282835721969604, 0.7064296007156372],
				numOctaves: 3,
				seed: 192,
				scale: 1.6381428241729736,
			},
		},
		stars: [],
		squiggles: [],
		prop: null,
	},
	pointingLeft: {
		source: 'pointingLeft.svg',
		viewBox: {
			width: 320,
			height: 321,
		},
		wings: {
			tealRight: {
				d: 'M267.929 189.466C243.007 202.663 183.29 174.619 167.446 166.714C165.648 165.818 165.466 163.16 167.123 161.954C202.113 136.487 267.584 128.098 296.865 127.108C327.18 126.083 290.055 177.749 267.929 189.466Z',
				texture: {
					x: 164.792,
					y: 125.902,
					width: 144.693,
					height: 68.2325,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
			tealLeft: {
				d: 'M76.3654 190.856C101.287 204.053 161.004 176.009 176.849 168.104C178.646 167.207 178.828 164.55 177.172 163.344C142.181 137.877 76.7099 129.488 47.429 128.497C17.1137 127.473 54.2385 179.139 76.3654 190.856Z',
				texture: {
					x: 34.8097,
					y: 127.292,
					width: 144.693,
					height: 68.2325,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
			purpleRight: {
				d: 'M263.205 162.052C244.209 182.895 178.528 176.68 160.944 174.594C158.95 174.358 157.88 171.918 159.032 170.223C183.358 134.431 242.143 104.41 269.366 93.5846C297.552 82.3754 280.071 143.547 263.205 162.052Z',
				texture: {
					x: 157.368,
					y: 91.0333,
					width: 128.077,
					height: 87.2542,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
			purpleLeft: {
				d: 'M80.5254 162.747C99.5213 183.589 165.202 177.375 182.786 175.289C184.78 175.052 185.85 172.613 184.698 170.918C160.372 135.126 101.587 105.105 74.3635 94.2788C46.1779 83.0703 63.6595 144.242 80.5254 162.747Z',
				texture: {
					x: 58.2843,
					y: 91.7277,
					width: 128.077,
					height: 87.2545,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
		},
		leftArm: {
			d: 'M115 162.851C115 162.851 94.0203 169.936 78.3469 162.851C62.6734 155.766 47 135 47 135',
			texture: {
				x: 33.1726,
				y: 121.173,
				width: 95.6577,
				height: 58.6547,
				frequency: [0.9990000128746033, 0.732045590877533],
				numOctaves: 3,
				seed: 8637,
				scale: 1.5817248821258545,
			},
			front: false,
			renderMode: 'stroke',
		},
		rightArm: {
			d: 'M215.741 164.994C215.741 164.994 225.136 183.371 228.187 197.739C231.238 212.106 227.971 234.494 227.971 234.494',
			texture: {
				x: 201.912,
				y: 151.165,
				width: 41.4045,
				height: 97.1578,
				frequency: [0.9990000128746033, 0.732045590877533],
				numOctaves: 3,
				seed: 8637,
				scale: 1.5817248821258545,
			},
			front: true,
			renderMode: 'stroke',
		},
		antennae: [
			{
				stem: {
					d: 'M128.667 71.9279C131.063 55.1521 139.451 37.9768 159.422 31.1865',
					texture: {
						x: 123.705,
						y: 26.2246,
						width: 40.6791,
						height: 50.6647,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 2801,
						scale: 1.933219313621521,
					},
				},
				tip: {
					d: 'M160.221 40.3736C165.295 40.3736 169.408 36.2605 169.408 31.1868C169.408 26.113 165.295 22 160.221 22C155.147 22 151.034 26.113 151.034 31.1868C151.034 36.2605 155.147 40.3736 160.221 40.3736Z',
					texture: {
						x: 149.668,
						y: 20.634,
						width: 21.1057,
						height: 21.1057,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 8737,
						scale: 2.732070207595825,
					},
				},
				front: false,
			},
			{
				stem: {
					d: 'M176.598 71.9279C178.994 55.1521 187.382 37.9768 207.353 31.1865',
					texture: {
						x: 171.636,
						y: 26.2246,
						width: 40.6791,
						height: 50.6647,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 2801,
						scale: 1.933219313621521,
					},
				},
				tip: {
					d: 'M208.152 40.3736C213.226 40.3736 217.339 36.2605 217.339 31.1868C217.339 26.113 213.226 22 208.152 22C203.078 22 198.965 26.113 198.965 31.1868C198.965 36.2605 203.078 40.3736 208.152 40.3736Z',
					texture: {
						x: 197.599,
						y: 20.634,
						width: 21.1057,
						height: 21.1057,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 8737,
						scale: 2.732070207595825,
					},
				},
				front: true,
			},
		],
		body: {
			d: 'M101.858 96.8471C102.719 76.5189 118.724 60.087 139.022 58.6899L161.405 57.1494L183.998 59.0027C204.371 60.6738 220.194 77.4571 220.664 97.8933L222.132 161.718L220.766 224.058C220.248 247.709 201.096 266.705 177.441 267.028L161.419 267.247H145.569C121.993 267.247 102.62 248.64 101.668 225.084L99.1089 161.718L101.858 96.8471Z',
			texture: {
				x: 95.9441,
				y: 53.9814,
				width: 129.352,
				height: 216.429,
				frequency: [0.29947322607040405, 0.24354049563407898],
				numOctaves: 3,
				seed: 6337,
				scale: 3.131495714187622,
			},
		},
		bodyMask:
			'M100.989 96.1398C101.952 74.6109 120.056 57.9994 141.599 58.5671L163.59 59.1465L179.396 58.6943C201.489 58.0621 219.895 75.4905 220.468 97.5842L222.132 161.718L221.01 223.995C220.58 247.832 201.219 266.977 177.379 267.139L161.42 267.247L143.865 267.128C120.657 266.971 101.573 248.791 100.643 225.601C99.8241 205.167 99.0643 180.842 99.1093 161.718C99.156 141.918 100.066 116.767 100.989 96.1398Z',
		bodyShade: {
			d: 'M206.555 53.5546C211.747 58.3477 221.733 76.1742 224.928 89.9023C228.124 103.63 229.322 132.641 229.322 147.02C229.322 161.399 224.928 182.569 220.934 195.75C216.94 208.931 210.15 222.911 206.555 232.497C202.96 242.083 194.572 257.262 180.992 278.831',
			texture: {
				x: 123.854,
				y: -3.57931,
				width: 162.602,
				height: 339.547,
				frequency: [0.638672411441803, 0.638672411441803],
				numOctaves: 3,
				seed: 9325,
				scale: 60.744625091552734,
			},
		},
		stripes: [
			{
				d: 'M225.328 166.991V187.362C225.328 187.362 202.598 185.764 161.819 185.764C121.041 185.764 95.9141 187.362 95.9141 187.362V166.991C95.9141 166.991 121.041 165.394 161.819 165.394C202.598 165.394 225.328 166.991 225.328 166.991Z',
				texture: {
					x: 95.4587,
					y: 164.938,
					width: 130.325,
					height: 22.8791,
					frequency: [0.5960943698883057, 0.5960943698883057],
					numOctaves: 3,
					seed: 2172,
					scale: 0.9106900691986084,
				},
			},
			{
				d: 'M225.328 200.943V221.314C225.328 221.314 202.598 219.716 161.819 219.716C121.041 219.716 95.9141 221.314 95.9141 221.314V200.943C95.9141 200.943 121.041 199.346 161.819 199.346C202.598 199.346 225.328 200.943 225.328 200.943Z',
				texture: {
					x: 95.4587,
					y: 198.89,
					width: 130.325,
					height: 22.8791,
					frequency: [0.5960943698883057, 0.5960943698883057],
					numOctaves: 3,
					seed: 2172,
					scale: 0.9106900691986084,
				},
			},
			{
				d: 'M225.328 234.494V254.865C225.328 254.865 202.598 253.267 161.819 253.267C121.041 253.267 95.9141 254.865 95.9141 254.865V234.494C95.9141 234.494 121.041 232.896 161.819 232.896C202.598 232.896 225.328 234.494 225.328 234.494Z',
				texture: {
					x: 95.4587,
					y: 232.441,
					width: 130.325,
					height: 22.8791,
					frequency: [0.5960943698883057, 0.5960943698883057],
					numOctaves: 3,
					seed: 2172,
					scale: 0.9106900691986084,
				},
			},
		],
		eyes: [
			{
				d: 'M119.432 125.786C124.038 125.786 127.772 120.436 127.772 113.836C127.772 107.235 124.038 101.885 119.432 101.885C114.826 101.885 111.092 107.235 111.092 113.836C111.092 120.436 114.826 125.786 119.432 125.786Z',
				texture: {
					x: 109.846,
					y: 100.639,
					width: 19.1724,
					height: 26.394,
					frequency: [0.9990000128746033, 0.9990000128746033],
					numOctaves: 3,
					seed: 6148,
					scale: 1.6935639381408691,
				},
			},
			{
				d: 'M167.363 125.786C171.969 125.786 175.703 120.436 175.703 113.836C175.703 107.235 171.969 101.885 167.363 101.885C162.757 101.885 159.023 107.235 159.023 113.836C159.023 120.436 162.757 125.786 167.363 125.786Z',
				texture: {
					x: 157.777,
					y: 100.639,
					width: 19.1724,
					height: 26.394,
					frequency: [0.9990000128746033, 0.9990000128746033],
					numOctaves: 3,
					seed: 6148,
					scale: 1.6935639381408691,
				},
			},
		],
		stinger: {
			d: 'M209.429 275.238C203.374 262.089 188.144 270.95 195.052 281.869C200.98 291.239 212.946 298.802 221.919 299.995C223.698 300.111 224.224 298.053 222.861 296.904C218.538 295.207 215.485 288.387 209.429 275.238Z',
			texture: {
				x: 192.472,
				y: 267.844,
				width: 31.9786,
				height: 32.975,
				frequency: [0.9282835721969604, 0.7064296007156372],
				numOctaves: 3,
				seed: 192,
				scale: 1.6381428241729736,
			},
		},
		stars: [],
		squiggles: [],
		prop: null,
	},
	tickleLeft: {
		source: 'tickleLeft.svg',
		viewBox: {
			width: 320,
			height: 320,
		},
		wings: {
			tealRight: {
				d: 'M267.929 189.466C243.007 202.663 183.29 174.619 167.446 166.714C165.648 165.818 165.466 163.16 167.123 161.954C202.113 136.487 267.584 128.098 296.865 127.108C327.18 126.083 290.055 177.749 267.929 189.466Z',
				texture: {
					x: 164.792,
					y: 125.902,
					width: 144.693,
					height: 68.2325,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
			tealLeft: {
				d: 'M76.3654 190.856C101.287 204.053 161.004 176.009 176.849 168.104C178.646 167.207 178.828 164.55 177.172 163.344C142.181 137.877 76.7099 129.488 47.429 128.497C17.1137 127.473 54.2385 179.139 76.3654 190.856Z',
				texture: {
					x: 34.8097,
					y: 127.292,
					width: 144.693,
					height: 68.2325,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
			purpleRight: {
				d: 'M263.205 162.052C244.209 182.895 178.528 176.68 160.944 174.594C158.95 174.358 157.88 171.918 159.032 170.223C183.358 134.431 242.143 104.41 269.366 93.5846C297.552 82.3754 280.071 143.547 263.205 162.052Z',
				texture: {
					x: 157.368,
					y: 91.0333,
					width: 128.077,
					height: 87.2542,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
			purpleLeft: {
				d: 'M80.5254 162.747C99.5213 183.589 165.202 177.375 182.786 175.289C184.78 175.052 185.85 172.613 184.698 170.918C160.372 135.126 101.587 105.105 74.3635 94.2788C46.1779 83.0703 63.6595 144.242 80.5254 162.747Z',
				texture: {
					x: 58.2843,
					y: 91.7277,
					width: 128.077,
					height: 87.2545,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
		},
		leftArm: {
			d: 'M95 172C95 172 98.9258 160.129 105.247 154.565C111.567 149 129 149 129 149',
			texture: {
				x: 81.1698,
				y: 135.173,
				width: 61.6569,
				height: 50.6568,
				frequency: [0.9990000128746033, 0.732045590877533],
				numOctaves: 3,
				seed: 8637,
				scale: 1.5817248821258545,
			},
			front: true,
			renderMode: 'stroke',
		},
		rightArm: {
			d: 'M215.006 165C215.006 165 224.294 184.48 202.777 199.743C181.259 215.007 159 212.902 159 212.902',
			texture: {
				x: 145.173,
				y: 151.17,
				width: 85.6542,
				height: 75.6563,
				frequency: [0.9990000128746033, 0.732045590877533],
				numOctaves: 3,
				seed: 8637,
				scale: 1.5817248821258545,
			},
			front: true,
			renderMode: 'stroke',
		},
		antennae: [
			{
				stem: {
					d: 'M128.667 71.9279C131.063 55.1521 139.451 37.9768 159.422 31.1865',
					texture: {
						x: 123.705,
						y: 26.2246,
						width: 40.6793,
						height: 50.6647,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 2801,
						scale: 1.933219313621521,
					},
				},
				tip: {
					d: 'M160.221 40.3736C165.295 40.3736 169.408 36.2605 169.408 31.1868C169.408 26.113 165.295 22 160.221 22C155.147 22 151.034 26.113 151.034 31.1868C151.034 36.2605 155.147 40.3736 160.221 40.3736Z',
					texture: {
						x: 149.668,
						y: 20.634,
						width: 21.1056,
						height: 21.1057,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 8737,
						scale: 2.732070207595825,
					},
				},
				front: false,
			},
			{
				stem: {
					d: 'M176.598 71.9279C178.994 55.1521 187.382 37.9768 207.353 31.1865',
					texture: {
						x: 171.636,
						y: 26.2246,
						width: 40.6793,
						height: 50.6647,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 2801,
						scale: 1.933219313621521,
					},
				},
				tip: {
					d: 'M208.152 40.3736C213.226 40.3736 217.339 36.2605 217.339 31.1868C217.339 26.113 213.226 22 208.152 22C203.078 22 198.965 26.113 198.965 31.1868C198.965 36.2605 203.078 40.3736 208.152 40.3736Z',
					texture: {
						x: 197.599,
						y: 20.634,
						width: 21.1056,
						height: 21.1057,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 8737,
						scale: 2.732070207595825,
					},
				},
				front: true,
			},
		],
		body: {
			d: 'M101.858 96.8471C102.719 76.5189 118.724 60.087 139.022 58.6899L161.405 57.1494L183.998 59.0027C204.371 60.6738 220.194 77.4571 220.664 97.8933L222.132 161.718L220.766 224.058C220.248 247.709 201.096 266.705 177.441 267.028L161.419 267.247H145.569C121.993 267.247 102.62 248.64 101.668 225.084L99.1089 161.718L101.858 96.8471Z',
			texture: {
				x: 95.944,
				y: 53.9814,
				width: 129.352,
				height: 216.429,
				frequency: [0.29947322607040405, 0.24354049563407898],
				numOctaves: 3,
				seed: 6337,
				scale: 3.131495714187622,
			},
		},
		bodyMask:
			'M100.989 96.1398C101.952 74.6109 120.056 57.9994 141.599 58.5671L163.59 59.1465L179.396 58.6943C201.489 58.0621 219.895 75.4905 220.468 97.5842L222.132 161.718L221.01 223.995C220.58 247.832 201.219 266.977 177.379 267.139L161.42 267.247L143.865 267.128C120.657 266.971 101.573 248.791 100.643 225.601C99.8241 205.167 99.0643 180.842 99.1093 161.718C99.156 141.918 100.066 116.767 100.989 96.1398Z',
		bodyShade: {
			d: 'M206.555 53.5546C211.747 58.3477 221.733 76.1742 224.928 89.9023C228.124 103.63 229.322 132.641 229.322 147.02C229.322 161.399 224.928 182.569 220.934 195.75C216.94 208.931 210.15 222.911 206.555 232.497C202.96 242.083 194.572 257.262 180.991 278.831',
			texture: {
				x: 123.854,
				y: -3.57934,
				width: 162.602,
				height: 339.547,
				frequency: [0.638672411441803, 0.638672411441803],
				numOctaves: 3,
				seed: 9325,
				scale: 60.744625091552734,
			},
		},
		stripes: [
			{
				d: 'M225.328 166.991V187.362C225.328 187.362 202.598 185.764 161.819 185.764C121.041 185.764 95.9141 187.362 95.9141 187.362V166.991C95.9141 166.991 121.041 165.394 161.819 165.394C202.598 165.394 225.328 166.991 225.328 166.991Z',
				texture: {
					x: 95.4587,
					y: 164.938,
					width: 130.325,
					height: 22.8791,
					frequency: [0.5960943698883057, 0.5960943698883057],
					numOctaves: 3,
					seed: 2172,
					scale: 0.9106900691986084,
				},
			},
			{
				d: 'M225.328 200.943V221.314C225.328 221.314 202.598 219.716 161.819 219.716C121.041 219.716 95.9141 221.314 95.9141 221.314V200.943C95.9141 200.943 121.041 199.346 161.819 199.346C202.598 199.346 225.328 200.943 225.328 200.943Z',
				texture: {
					x: 95.4587,
					y: 198.89,
					width: 130.325,
					height: 22.8791,
					frequency: [0.5960943698883057, 0.5960943698883057],
					numOctaves: 3,
					seed: 2172,
					scale: 0.9106900691986084,
				},
			},
			{
				d: 'M225.328 234.494V254.865C225.328 254.865 202.598 253.267 161.819 253.267C121.041 253.267 95.9141 254.865 95.9141 254.865V234.494C95.9141 234.494 121.041 232.896 161.819 232.896C202.598 232.896 225.328 234.494 225.328 234.494Z',
				texture: {
					x: 95.4587,
					y: 232.441,
					width: 130.325,
					height: 22.8791,
					frequency: [0.5960943698883057, 0.5960943698883057],
					numOctaves: 3,
					seed: 2172,
					scale: 0.9106900691986084,
				},
			},
		],
		eyes: [
			{
				d: 'M119.432 120.786C124.038 120.786 127.772 126.436 127.772 119.836C127.772 113.235 124.038 107.885 119.432 107.885C114.826 107.885 111.092 113.235 111.092 119.836C111.092 126.436 114.826 120.786 119.432 120.786Z',
				texture: {
					x: 109.846,
					y: 106.639,
					width: 19.1723,
					height: 17.6452,
					frequency: [0.9990000128746033, 0.9990000128746033],
					numOctaves: 3,
					seed: 6148,
					scale: 1.6935639381408691,
				},
			},
			{
				d: 'M167.363 120.786C171.969 120.786 175.703 126.436 175.703 119.836C175.703 113.235 171.969 107.885 167.363 107.885C162.757 107.885 159.023 113.235 159.023 119.836C159.023 126.436 162.757 120.786 167.363 120.786Z',
				texture: {
					x: 157.777,
					y: 106.639,
					width: 19.1723,
					height: 17.6452,
					frequency: [0.9990000128746033, 0.9990000128746033],
					numOctaves: 3,
					seed: 6148,
					scale: 1.6935639381408691,
				},
			},
		],
		stinger: {
			d: 'M209.429 275.238C203.374 262.089 188.144 270.95 195.052 281.869C200.98 291.239 212.946 298.802 221.919 299.995C223.698 300.111 224.224 298.053 222.861 296.904C218.538 295.207 215.485 288.387 209.429 275.238Z',
			texture: {
				x: 192.472,
				y: 267.844,
				width: 31.9787,
				height: 32.975,
				frequency: [0.9282835721969604, 0.7064296007156372],
				numOctaves: 3,
				seed: 192,
				scale: 1.6381428241729736,
			},
		},
		stars: [],
		squiggles: [],
		prop: null,
	},
	excited: {
		source: 'excited.svg',
		viewBox: {
			width: 320,
			height: 321,
		},
		wings: {
			tealRight: {
				d: 'M267.929 189.466C243.007 202.663 183.29 174.619 167.446 166.714C165.648 165.818 165.466 163.16 167.123 161.954C202.113 136.487 267.584 128.098 296.865 127.108C327.18 126.083 290.055 177.749 267.929 189.466Z',
				texture: {
					x: 164.792,
					y: 125.902,
					width: 144.693,
					height: 68.2325,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
			tealLeft: {
				d: 'M76.3654 190.856C101.287 204.053 161.004 176.009 176.849 168.104C178.646 167.207 178.828 164.55 177.172 163.344C142.181 137.877 76.7099 129.488 47.429 128.497C17.1137 127.473 54.2385 179.139 76.3654 190.856Z',
				texture: {
					x: 34.8097,
					y: 127.292,
					width: 144.693,
					height: 68.2325,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
			purpleRight: {
				d: 'M263.205 162.052C244.209 182.895 178.528 176.68 160.944 174.594C158.95 174.358 157.88 171.918 159.032 170.223C183.358 134.431 242.143 104.41 269.366 93.5846C297.552 82.3754 280.071 143.547 263.205 162.052Z',
				texture: {
					x: 157.368,
					y: 91.0333,
					width: 128.077,
					height: 87.2541,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
			purpleLeft: {
				d: 'M80.5254 162.747C99.5213 183.589 165.202 177.375 182.786 175.289C184.78 175.052 185.85 172.613 184.698 170.918C160.372 135.126 101.587 105.105 74.3635 94.2788C46.1779 83.0703 63.6595 144.242 80.5254 162.747Z',
				texture: {
					x: 58.2843,
					y: 91.7277,
					width: 128.077,
					height: 87.2545,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
		},
		leftArm: {
			d: 'M115.104 162.598C115.104 162.598 100.427 152.109 97.5 135C94.5743 117.89 90 88 90 88',
			texture: {
				x: 76.1715,
				y: 74.1715,
				width: 52.7596,
				height: 102.254,
				frequency: [0.9990000128746033, 0.732045590877533],
				numOctaves: 3,
				seed: 8637,
				scale: 1.5817248821258545,
			},
			front: false,
			renderMode: 'stroke',
		},
		rightArm: {
			d: 'M216.104 159.598C216.104 159.598 226.115 141.125 229 125C231.885 108.875 237 89 237 89',
			texture: {
				x: 202.274,
				y: 75.1702,
				width: 48.5555,
				height: 98.2567,
				frequency: [0.9990000128746033, 0.732045590877533],
				numOctaves: 3,
				seed: 8637,
				scale: 1.5817248821258545,
			},
			front: true,
			renderMode: 'stroke',
		},
		antennae: [
			{
				stem: {
					d: 'M128.667 71.9279C131.063 55.1521 139.451 37.9768 159.422 31.1865',
					texture: {
						x: 123.705,
						y: 26.2246,
						width: 40.6791,
						height: 50.6648,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 2801,
						scale: 1.933219313621521,
					},
				},
				tip: {
					d: 'M160.221 40.3736C165.295 40.3736 169.408 36.2605 169.408 31.1868C169.408 26.113 165.295 22 160.221 22C155.147 22 151.034 26.113 151.034 31.1868C151.034 36.2605 155.147 40.3736 160.221 40.3736Z',
					texture: {
						x: 149.668,
						y: 20.634,
						width: 21.1056,
						height: 21.1056,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 8737,
						scale: 2.732070207595825,
					},
				},
				front: false,
			},
			{
				stem: {
					d: 'M176.598 71.9279C178.994 55.1521 187.382 37.9768 207.353 31.1865',
					texture: {
						x: 171.636,
						y: 26.2246,
						width: 40.6791,
						height: 50.6648,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 2801,
						scale: 1.933219313621521,
					},
				},
				tip: {
					d: 'M208.152 40.3736C213.226 40.3736 217.339 36.2605 217.339 31.1868C217.339 26.113 213.226 22 208.152 22C203.078 22 198.965 26.113 198.965 31.1868C198.965 36.2605 203.078 40.3736 208.152 40.3736Z',
					texture: {
						x: 197.599,
						y: 20.634,
						width: 21.1056,
						height: 21.1056,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 8737,
						scale: 2.732070207595825,
					},
				},
				front: true,
			},
		],
		body: {
			d: 'M101.858 96.8471C102.719 76.5189 118.724 60.087 139.022 58.6899L161.405 57.1494L183.998 59.0027C204.371 60.6738 220.194 77.4571 220.664 97.8933L222.132 161.718L220.766 224.058C220.248 247.709 201.096 266.705 177.441 267.028L161.419 267.247H145.569C121.993 267.247 102.62 248.64 101.668 225.084L99.1089 161.718L101.858 96.8471Z',
			texture: {
				x: 95.944,
				y: 53.9815,
				width: 129.352,
				height: 216.429,
				frequency: [0.29947322607040405, 0.24354049563407898],
				numOctaves: 3,
				seed: 6337,
				scale: 3.131495714187622,
			},
		},
		bodyMask:
			'M100.989 96.1398C101.952 74.6109 120.056 57.9994 141.599 58.5671L163.59 59.1465L179.396 58.6943C201.489 58.0621 219.895 75.4905 220.468 97.5842L222.132 161.718L221.01 223.995C220.58 247.832 201.219 266.977 177.379 267.139L161.42 267.247L143.865 267.128C120.657 266.971 101.573 248.791 100.643 225.601C99.8241 205.167 99.0643 180.842 99.1093 161.718C99.156 141.918 100.066 116.767 100.989 96.1398Z',
		bodyShade: {
			d: 'M206.555 53.5547C211.747 58.3478 221.733 76.1743 224.928 89.9024C228.124 103.631 229.322 132.641 229.322 147.02C229.322 161.4 224.928 182.569 220.934 195.75C216.94 208.931 210.15 222.911 206.555 232.497C202.96 242.083 194.572 257.262 180.992 278.831',
			texture: {
				x: 123.854,
				y: -3.57922,
				width: 162.602,
				height: 339.547,
				frequency: [0.638672411441803, 0.638672411441803],
				numOctaves: 3,
				seed: 9325,
				scale: 60.744625091552734,
			},
		},
		stripes: [
			{
				d: 'M225.328 166.991V187.362C225.328 187.362 202.598 185.764 161.819 185.764C121.04 185.764 95.9138 187.362 95.9138 187.362V166.991C95.9138 166.991 121.04 165.394 161.819 165.394C202.598 165.394 225.328 166.991 225.328 166.991Z',
				texture: {
					x: 95.4585,
					y: 164.938,
					width: 130.325,
					height: 22.8791,
					frequency: [0.5960943698883057, 0.5960943698883057],
					numOctaves: 3,
					seed: 2172,
					scale: 0.9106900691986084,
				},
			},
			{
				d: 'M225.328 200.943V221.314C225.328 221.314 202.598 219.716 161.819 219.716C121.04 219.716 95.9138 221.314 95.9138 221.314V200.943C95.9138 200.943 121.04 199.346 161.819 199.346C202.598 199.346 225.328 200.943 225.328 200.943Z',
				texture: {
					x: 95.4585,
					y: 198.89,
					width: 130.325,
					height: 22.8791,
					frequency: [0.5960943698883057, 0.5960943698883057],
					numOctaves: 3,
					seed: 2172,
					scale: 0.9106900691986084,
				},
			},
			{
				d: 'M225.328 234.494V254.865C225.328 254.865 202.598 253.267 161.819 253.267C121.04 253.267 95.9138 254.865 95.9138 254.865V234.494C95.9138 234.494 121.04 232.896 161.819 232.896C202.598 232.896 225.328 234.494 225.328 234.494Z',
				texture: {
					x: 95.4585,
					y: 232.441,
					width: 130.325,
					height: 22.8791,
					frequency: [0.5960943698883057, 0.5960943698883057],
					numOctaves: 3,
					seed: 2172,
					scale: 0.9106900691986084,
				},
			},
		],
		eyes: [
			{
				d: 'M119.432 120.786C124.038 120.786 127.772 126.436 127.772 119.836C127.772 113.235 124.038 107.885 119.432 107.885C114.826 107.885 111.092 113.235 111.092 119.836C111.092 126.436 114.826 120.786 119.432 120.786Z',
				texture: {
					x: 109.846,
					y: 106.639,
					width: 19.1724,
					height: 17.6452,
					frequency: [0.9990000128746033, 0.9990000128746033],
					numOctaves: 3,
					seed: 6148,
					scale: 1.6935639381408691,
				},
			},
			{
				d: 'M167.363 120.786C171.969 120.786 175.703 126.436 175.703 119.836C175.703 113.235 171.969 107.885 167.363 107.885C162.757 107.885 159.023 113.235 159.023 119.836C159.023 126.436 162.757 120.786 167.363 120.786Z',
				texture: {
					x: 157.777,
					y: 106.639,
					width: 19.1724,
					height: 17.6452,
					frequency: [0.9990000128746033, 0.9990000128746033],
					numOctaves: 3,
					seed: 6148,
					scale: 1.6935639381408691,
				},
			},
		],
		stinger: {
			d: 'M209.429 275.238C203.373 262.089 188.144 270.95 195.052 281.869C200.98 291.239 212.945 298.802 221.919 299.995C223.698 300.111 224.224 298.053 222.861 296.904C218.537 295.207 215.485 288.387 209.429 275.238Z',
			texture: {
				x: 192.472,
				y: 267.844,
				width: 31.9786,
				height: 32.9749,
				frequency: [0.9282835721969604, 0.7064296007156372],
				numOctaves: 3,
				seed: 192,
				scale: 1.6381428241729736,
			},
		},
		stars: [
			{
				d: 'M289.562 60.5345C289.884 59.6639 291.116 59.6639 291.438 60.5345L293.446 65.9627C293.548 66.2364 293.764 66.4522 294.037 66.5535L299.465 68.5621C300.336 68.8843 300.336 70.1157 299.465 70.4379L294.037 72.4465C293.764 72.5478 293.548 72.7636 293.446 73.0373L291.438 78.4655C291.116 79.3361 289.884 79.3361 289.562 78.4655L287.554 73.0373C287.452 72.7636 287.236 72.5478 286.963 72.4465L281.535 70.4379C280.664 70.1157 280.664 68.8843 281.535 68.5621L286.963 66.5535C287.236 66.4522 287.452 66.2364 287.554 65.9627L289.562 60.5345Z',
				texture: {
					x: 279.752,
					y: 58.7516,
					width: 21.4968,
					height: 21.4968,
					frequency: [0.5102040767669678, 0.5102040767669678],
					numOctaves: 3,
					seed: 6815,
					scale: 2.259999990463257,
				},
			},
			{
				d: 'M273.566 28.4484C273.893 27.5904 275.107 27.5904 275.434 28.4484L278.793 37.2491C278.897 37.5217 279.115 37.7353 279.389 37.8338L288.377 41.0588C289.26 41.3756 289.26 42.6244 288.377 42.9412L279.389 46.1662C279.115 46.2647 278.897 46.4783 278.793 46.7509L275.434 55.5516C275.107 56.4096 273.893 56.4096 273.566 55.5516L270.207 46.7509C270.103 46.4783 269.885 46.2647 269.611 46.1662L260.623 42.9412C259.74 42.6244 259.74 41.3756 260.623 41.0588L269.611 37.8338C269.885 37.7353 270.103 37.5217 270.207 37.2491L273.566 28.4484Z',
				texture: {
					x: 258.831,
					y: 26.6749,
					width: 31.3381,
					height: 30.6501,
					frequency: [0.5102040767669678, 0.5102040767669678],
					numOctaves: 3,
					seed: 6815,
					scale: 2.259999990463257,
				},
			},
			{
				d: 'M28.5621 198.535C28.8843 197.664 30.1157 197.664 30.4379 198.535L32.4465 203.963C32.5478 204.236 32.7636 204.452 33.0373 204.554L38.4655 206.562C39.3361 206.884 39.3361 208.116 38.4655 208.438L33.0373 210.446C32.7636 210.548 32.5478 210.764 32.4465 211.037L30.4379 216.465C30.1157 217.336 28.8843 217.336 28.5621 216.465L26.5535 211.037C26.4522 210.764 26.2364 210.548 25.9627 210.446L20.5345 208.438C19.6639 208.116 19.6639 206.884 20.5345 206.562L25.9627 204.554C26.2364 204.452 26.4522 204.236 26.5535 203.963L28.5621 198.535Z',
				texture: {
					x: 18.7516,
					y: 196.752,
					width: 21.4968,
					height: 21.4968,
					frequency: [0.5102040767669678, 0.5102040767669678],
					numOctaves: 3,
					seed: 6815,
					scale: 2.259999990463257,
				},
			},
			{
				d: 'M46.5589 221.62C46.8759 220.738 48.1241 220.738 48.4411 221.62L51.8011 230.976C51.8997 231.25 52.1134 231.468 52.386 231.572L61.5491 235.066C62.4075 235.393 62.4075 236.607 61.5491 236.934L52.386 240.428C52.1134 240.532 51.8997 240.75 51.8011 241.024L48.4411 250.38C48.1241 251.262 46.8759 251.262 46.5589 250.38L43.1989 241.024C43.1003 240.75 42.8866 240.532 42.614 240.428L33.4509 236.934C32.5925 236.607 32.5925 235.393 33.4509 235.066L42.614 231.572C42.8866 231.468 43.1003 231.25 43.1989 230.976L46.5589 221.62Z',
				texture: {
					x: 31.6771,
					y: 219.828,
					width: 31.6457,
					height: 32.343,
					frequency: [0.5102040767669678, 0.5102040767669678],
					numOctaves: 3,
					seed: 6815,
					scale: 2.259999990463257,
				},
			},
		],
		squiggles: [],
		prop: null,
	},
	headScratch: {
		source: 'headScratch.svg',
		viewBox: {
			width: 320,
			height: 320,
		},
		wings: {
			tealRight: {
				d: 'M256.929 189.466C232.007 202.663 172.29 174.619 156.446 166.714C154.648 165.818 154.466 163.16 156.123 161.954C191.113 136.487 256.584 128.098 285.865 127.108C316.18 126.083 279.055 177.749 256.929 189.466Z',
				texture: {
					x: 153.792,
					y: 125.902,
					width: 144.693,
					height: 68.2325,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
			tealLeft: {
				d: 'M65.3654 190.856C90.2869 204.053 150.004 176.009 165.849 168.104C167.646 167.207 167.828 164.55 166.172 163.344C131.181 137.877 65.7099 129.488 36.429 128.497C6.11374 127.473 43.2385 179.139 65.3654 190.856Z',
				texture: {
					x: 23.8097,
					y: 127.292,
					width: 144.693,
					height: 68.2325,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
			purpleRight: {
				d: 'M252.205 162.052C233.208 182.895 167.528 176.68 149.944 174.594C147.95 174.358 146.88 171.918 148.032 170.223C172.357 134.431 231.143 104.41 258.366 93.5846C286.552 82.3754 269.07 143.547 252.205 162.052Z',
				texture: {
					x: 146.368,
					y: 91.0333,
					width: 128.077,
					height: 87.2542,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
			purpleLeft: {
				d: 'M69.5254 162.747C88.5213 183.589 154.202 177.375 171.786 175.289C173.78 175.052 174.85 172.613 173.698 170.918C149.372 135.126 90.5874 105.105 63.3635 94.2788C35.1779 83.0703 52.6595 144.242 69.5254 162.747Z',
				texture: {
					x: 47.2843,
					y: 91.7277,
					width: 128.077,
					height: 87.2545,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
		},
		leftArm: {
			d: 'M99.9451 164.762C99.9451 164.762 89.2722 176.525 89.5835 192.617C89.8948 208.71 101.003 219.449 101.003 219.449',
			texture: {
				x: 75.7502,
				y: 150.935,
				width: 39.0794,
				height: 82.3409,
				frequency: [0.9990000128746033, 0.732045590877533],
				numOctaves: 3,
				seed: 8637,
				scale: 1.5817248821258545,
			},
			front: true,
			renderMode: 'stroke',
		},
		rightArm: {
			d: 'M220.321 171C220.321 171 239.5 155.5 239.5 139.5C239.5 123.5 215 109.5 215 109.5',
			texture: {
				x: 201.171,
				y: 95.6711,
				width: 52.1556,
				height: 89.1558,
				frequency: [0.9990000128746033, 0.732045590877533],
				numOctaves: 3,
				seed: 8637,
				scale: 1.5817248821258545,
			},
			front: true,
			renderMode: 'stroke',
		},
		antennae: [
			{
				stem: {
					d: 'M134.559 71.9279C136.956 55.1521 145.344 37.9768 165.315 31.1865',
					texture: {
						x: 129.598,
						y: 26.2246,
						width: 40.6791,
						height: 50.6647,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 2801,
						scale: 1.933219313621521,
					},
				},
				tip: {
					d: 'M166.114 40.3736C171.188 40.3736 175.301 36.2605 175.301 31.1868C175.301 26.113 171.188 22 166.114 22C161.04 22 156.927 26.113 156.927 31.1868C156.927 36.2605 161.04 40.3736 166.114 40.3736Z',
					texture: {
						x: 155.561,
						y: 20.634,
						width: 21.1056,
						height: 21.1057,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 8737,
						scale: 2.732070207595825,
					},
				},
				front: true,
			},
			{
				stem: {
					d: 'M182.49 71.9279C184.887 55.1521 193.275 37.9768 213.246 31.1865',
					texture: {
						x: 177.529,
						y: 26.2246,
						width: 40.6791,
						height: 50.6647,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 2801,
						scale: 1.933219313621521,
					},
				},
				tip: {
					d: 'M214.045 40.3736C219.119 40.3736 223.232 36.2605 223.232 31.1868C223.232 26.113 219.119 22 214.045 22C208.971 22 204.858 26.113 204.858 31.1868C204.858 36.2605 208.971 40.3736 214.045 40.3736Z',
					texture: {
						x: 203.492,
						y: 20.634,
						width: 21.1056,
						height: 21.1057,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 8737,
						scale: 2.732070207595825,
					},
				},
				front: true,
			},
		],
		body: {
			d: 'M101.751 96.8471C102.613 76.5189 118.617 60.087 138.915 58.6899L161.298 57.1494L183.891 59.0027C204.264 60.6738 220.087 77.4571 220.557 97.8933L222.025 161.718L220.659 224.058C220.141 247.709 200.989 266.705 177.334 267.028L161.312 267.247H145.462C121.886 267.247 102.513 248.64 101.561 225.084L99.002 161.718L101.751 96.8471Z',
			texture: {
				x: 95.8371,
				y: 53.9814,
				width: 129.352,
				height: 216.429,
				frequency: [0.29947322607040405, 0.24354049563407898],
				numOctaves: 3,
				seed: 6337,
				scale: 3.131495714187622,
			},
		},
		bodyMask:
			'M100.881 96.1398C101.845 74.6109 119.949 57.9994 141.492 58.5671L163.482 59.1465L179.289 58.6943C201.381 58.0621 219.787 75.4905 220.361 97.5842L222.025 161.718L220.902 223.995C220.473 247.832 201.112 266.977 177.271 267.139L161.312 267.247L143.757 267.128C120.55 266.971 101.466 248.791 100.536 225.601C99.7167 205.167 98.9569 180.842 99.0019 161.718C99.0485 141.918 99.9583 116.767 100.881 96.1398Z',
		bodyShade: {
			d: 'M206.447 53.5546C211.64 58.3477 221.626 76.1742 224.821 89.9023C228.016 103.63 229.215 132.641 229.215 147.02C229.215 161.399 224.821 182.569 220.827 195.75C216.832 208.931 210.042 222.911 206.447 232.497C202.853 242.083 194.465 257.262 180.884 278.831',
			texture: {
				x: 123.747,
				y: -3.57934,
				width: 162.602,
				height: 339.547,
				frequency: [0.638672411441803, 0.638672411441803],
				numOctaves: 3,
				seed: 9325,
				scale: 60.744625091552734,
			},
		},
		stripes: [
			{
				d: 'M225.22 166.991V187.362C225.22 187.362 202.49 185.764 161.712 185.764C120.933 185.764 95.8065 187.362 95.8065 187.362V166.991C95.8065 166.991 120.933 165.393 161.712 165.393C202.49 165.393 225.22 166.991 225.22 166.991Z',
				texture: {
					x: 95.3512,
					y: 164.938,
					width: 130.325,
					height: 22.8791,
					frequency: [0.5960943698883057, 0.5960943698883057],
					numOctaves: 3,
					seed: 2172,
					scale: 0.9106900691986084,
				},
			},
			{
				d: 'M225.22 200.943V221.314C225.22 221.314 202.49 219.716 161.712 219.716C120.933 219.716 95.8065 221.314 95.8065 221.314V200.943C95.8065 200.943 120.933 199.346 161.712 199.346C202.49 199.346 225.22 200.943 225.22 200.943Z',
				texture: {
					x: 95.3512,
					y: 198.89,
					width: 130.325,
					height: 22.8791,
					frequency: [0.5960943698883057, 0.5960943698883057],
					numOctaves: 3,
					seed: 2172,
					scale: 0.9106900691986084,
				},
			},
			{
				d: 'M225.22 234.494V254.865C225.22 254.865 202.49 253.267 161.712 253.267C120.933 253.267 95.8065 254.865 95.8065 254.865V234.494C95.8065 234.494 120.933 232.896 161.712 232.896C202.49 232.896 225.22 234.494 225.22 234.494Z',
				texture: {
					x: 95.3512,
					y: 232.441,
					width: 130.325,
					height: 22.8791,
					frequency: [0.5960943698883057, 0.5960943698883057],
					numOctaves: 3,
					seed: 2172,
					scale: 0.9106900691986084,
				},
			},
		],
		eyes: [
			{
				d: 'M136.306 134.901C141 134.901 144.806 130.2 144.806 124.401C144.806 118.602 141 114.901 136.306 114.901C131.611 114.901 127.806 118.602 127.806 124.401C127.806 130.2 131.611 134.901 136.306 134.901Z',
				texture: {
					x: 126.559,
					y: 113.655,
					width: 19.4924,
					height: 22.4924,
					frequency: [0.9990000128746033, 0.9990000128746033],
					numOctaves: 3,
					seed: 6148,
					scale: 1.6935639381408691,
				},
			},
			{
				d: 'M184.306 124.901C189 124.901 192.806 130.2 192.806 124.401C192.806 118.602 189 114.901 184.306 114.901C179.611 114.901 175.806 118.602 175.806 124.401C175.806 130.2 179.611 124.901 184.306 124.901Z',
				texture: {
					x: 174.559,
					y: 113.655,
					width: 19.4924,
					height: 14.706,
					frequency: [0.9990000128746033, 0.9990000128746033],
					numOctaves: 3,
					seed: 6148,
					scale: 1.6935639381408691,
				},
			},
		],
		stinger: {
			d: 'M209.322 275.238C203.266 262.089 188.037 270.95 194.945 281.869C200.873 291.239 212.838 298.802 221.812 299.995C223.59 300.111 224.116 298.053 222.754 296.904C218.43 295.207 215.377 288.387 209.322 275.238Z',
			texture: {
				x: 192.365,
				y: 267.844,
				width: 31.9786,
				height: 32.9749,
				frequency: [0.9282835721969604, 0.7064296007156372],
				numOctaves: 3,
				seed: 192,
				scale: 1.6381428241729736,
			},
		},
		stars: [],
		squiggles: [],
		prop: null,
	},
	thinkingRight: {
		source: 'thinkingRight.svg',
		viewBox: {
			width: 320,
			height: 320,
		},
		wings: {
			tealRight: {
				d: 'M243.639 188.466C218.717 201.663 159 173.619 143.156 165.714C141.358 164.818 141.176 162.16 142.833 160.954C177.823 135.487 243.294 127.098 272.575 126.108C302.89 125.083 265.765 176.749 243.639 188.466Z',
				texture: {
					x: 140.502,
					y: 124.902,
					width: 144.693,
					height: 68.2325,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
			tealLeft: {
				d: 'M52.0754 189.856C76.9968 203.053 136.714 175.009 152.559 167.104C154.356 166.207 154.538 163.55 152.882 162.344C117.891 136.877 52.4199 128.488 23.139 127.497C-7.1763 126.473 29.9484 178.139 52.0754 189.856Z',
				texture: {
					x: 10.5197,
					y: 126.292,
					width: 144.693,
					height: 68.2325,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
			purpleRight: {
				d: 'M238.915 161.052C219.918 181.895 154.238 175.68 136.654 173.594C134.66 173.358 133.59 170.918 134.742 169.223C159.067 133.431 217.853 103.41 245.076 92.5846C273.262 81.3754 255.78 142.547 238.915 161.052Z',
				texture: {
					x: 133.078,
					y: 90.0333,
					width: 128.077,
					height: 87.2542,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
			purpleLeft: {
				d: 'M56.2354 161.747C75.2312 182.589 140.912 176.375 158.496 174.289C160.49 174.052 161.56 171.613 160.408 169.918C136.082 134.126 77.2973 104.105 50.0734 93.2788C21.8878 82.0703 39.3695 143.242 56.2354 161.747Z',
				texture: {
					x: 33.9943,
					y: 90.7277,
					width: 128.077,
					height: 87.2545,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
		},
		leftArm: {
			d: 'M107.466 163.994C107.466 163.994 89.5509 173.132 86.5 187.5C83.4491 201.868 107.466 211.5 107.466 211.5',
			texture: {
				x: 72.3815,
				y: 150.165,
				width: 48.9145,
				height: 75.1655,
				frequency: [0.9990000128746033, 0.732045590877533],
				numOctaves: 3,
				seed: 8637,
				scale: 1.5817248821258545,
			},
			front: true,
			renderMode: 'stroke',
		},
		rightArm: {
			d: 'M225 184.5C225 184.5 218 169 209.5 161.5C201 154 186.5 145 186.5 145',
			texture: {
				x: 172.672,
				y: 131.172,
				width: 66.1584,
				height: 67.1583,
				frequency: [0.9990000128746033, 0.732045590877533],
				numOctaves: 3,
				seed: 8637,
				scale: 1.5817248821258545,
			},
			front: true,
			renderMode: 'stroke',
		},
		antennae: [
			{
				stem: {
					d: 'M129.667 70.9279C132.063 54.1521 140.451 36.9768 160.422 30.1865',
					texture: {
						x: 124.705,
						y: 25.2246,
						width: 40.6791,
						height: 50.6647,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 2801,
						scale: 1.933219313621521,
					},
				},
				tip: {
					d: 'M161.221 39.3736C166.295 39.3736 170.408 35.2605 170.408 30.1868C170.408 25.113 166.295 21 161.221 21C156.147 21 152.034 25.113 152.034 30.1868C152.034 35.2605 156.147 39.3736 161.221 39.3736Z',
					texture: {
						x: 150.668,
						y: 19.634,
						width: 21.1056,
						height: 21.1057,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 8737,
						scale: 2.732070207595825,
					},
				},
				front: true,
			},
			{
				stem: {
					d: 'M177.598 70.9279C179.994 54.1521 188.382 36.9768 208.353 30.1865',
					texture: {
						x: 172.636,
						y: 25.2246,
						width: 40.6791,
						height: 50.6647,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 2801,
						scale: 1.933219313621521,
					},
				},
				tip: {
					d: 'M209.152 39.3736C214.226 39.3736 218.339 35.2605 218.339 30.1868C218.339 25.113 214.226 21 209.152 21C204.078 21 199.965 25.113 199.965 30.1868C199.965 35.2605 204.078 39.3736 209.152 39.3736Z',
					texture: {
						x: 198.599,
						y: 19.634,
						width: 21.1056,
						height: 21.1057,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 8737,
						scale: 2.732070207595825,
					},
				},
				front: false,
			},
		],
		body: {
			d: 'M102.858 95.8472C103.72 75.5191 119.724 59.0871 140.022 57.69L162.405 56.1495L184.998 58.0028C205.371 59.6739 221.195 76.4572 221.664 96.8934L223.132 160.718L221.766 223.058C221.248 246.71 202.096 265.705 178.441 266.028L162.419 266.247H146.569C122.993 266.247 103.62 247.64 102.668 224.084L100.109 160.718L102.858 95.8472Z',
			texture: {
				x: 96.9441,
				y: 52.9816,
				width: 129.352,
				height: 216.429,
				frequency: [0.29947322607040405, 0.24354049563407898],
				numOctaves: 3,
				seed: 6337,
				scale: 3.131495714187622,
			},
		},
		bodyMask:
			'M101.989 95.1398C102.952 73.6109 121.056 56.9994 142.599 57.5671L164.59 58.1465L180.396 57.6943C202.489 57.0621 220.895 74.4905 221.468 96.5842L223.132 160.718L222.01 222.995C221.58 246.832 202.219 265.977 178.379 266.139L162.42 266.247L144.865 266.128C121.657 265.971 102.573 247.791 101.643 224.601C100.824 204.167 100.064 179.842 100.109 160.718C100.156 140.918 101.066 115.767 101.989 95.1398Z',
		bodyShade: {
			d: 'M207.555 52.5546C212.747 57.3477 222.733 75.1742 225.928 88.9023C229.124 102.63 230.322 131.641 230.322 146.02C230.322 160.399 225.928 181.569 221.934 194.75C217.94 207.931 211.15 221.911 207.555 231.497C203.96 241.083 195.572 256.262 181.992 277.831',
			texture: {
				x: 124.854,
				y: -4.57934,
				width: 162.602,
				height: 339.547,
				frequency: [0.638672411441803, 0.638672411441803],
				numOctaves: 3,
				seed: 9325,
				scale: 60.744625091552734,
			},
		},
		stripes: [
			{
				d: 'M226.328 165.991V186.362C226.328 186.362 203.598 184.764 162.819 184.764C122.04 184.764 96.9139 186.362 96.9139 186.362V165.991C96.9139 165.991 122.04 164.393 162.819 164.393C203.598 164.393 226.328 165.991 226.328 165.991Z',
				texture: {
					x: 96.4586,
					y: 163.938,
					width: 130.325,
					height: 22.8791,
					frequency: [0.5960943698883057, 0.5960943698883057],
					numOctaves: 3,
					seed: 2172,
					scale: 0.9106900691986084,
				},
			},
			{
				d: 'M226.328 199.943V220.314C226.328 220.314 203.598 218.716 162.819 218.716C122.04 218.716 96.9139 220.314 96.9139 220.314V199.943C96.9139 199.943 122.04 198.346 162.819 198.346C203.598 198.346 226.328 199.943 226.328 199.943Z',
				texture: {
					x: 96.4586,
					y: 197.89,
					width: 130.325,
					height: 22.8791,
					frequency: [0.5960943698883057, 0.5960943698883057],
					numOctaves: 3,
					seed: 2172,
					scale: 0.9106900691986084,
				},
			},
			{
				d: 'M226.328 233.494V253.865C226.328 253.865 203.598 252.267 162.819 252.267C122.04 252.267 96.9139 253.865 96.9139 253.865V233.494C96.9139 233.494 122.04 231.896 162.819 231.896C203.598 231.896 226.328 233.494 226.328 233.494Z',
				texture: {
					x: 96.4586,
					y: 231.441,
					width: 130.325,
					height: 22.8791,
					frequency: [0.5960943698883057, 0.5960943698883057],
					numOctaves: 3,
					seed: 2172,
					scale: 0.9106900691986084,
				},
			},
		],
		eyes: [
			{
				d: 'M155.432 120.786C160.038 120.786 163.772 122.436 163.772 115.836C163.772 109.235 160.038 103.885 155.432 103.885C150.826 103.885 147.092 109.235 147.092 115.836C147.092 122.436 150.826 120.786 155.432 120.786Z',
				texture: {
					x: 145.846,
					y: 102.639,
					width: 19.1724,
					height: 19.5773,
					frequency: [0.9990000128746033, 0.9990000128746033],
					numOctaves: 3,
					seed: 6148,
					scale: 1.6935639381408691,
				},
			},
			{
				d: 'M203.363 120.786C207.969 120.786 211.703 122.436 211.703 115.836C211.703 109.235 207.969 103.885 203.363 103.885C198.757 103.885 195.023 109.235 195.023 115.836C195.023 122.436 198.757 120.786 203.363 120.786Z',
				texture: {
					x: 193.777,
					y: 102.639,
					width: 19.1724,
					height: 19.5773,
					frequency: [0.9990000128746033, 0.9990000128746033],
					numOctaves: 3,
					seed: 6148,
					scale: 1.6935639381408691,
				},
			},
		],
		stinger: {
			d: 'M110.493 274.238C116.549 261.089 131.778 269.95 124.87 280.869C118.942 290.239 106.977 297.802 98.0034 298.995C96.2245 299.111 95.6986 297.053 97.0613 295.904C101.385 294.207 104.438 287.387 110.493 274.238Z',
			texture: {
				x: 95.4718,
				y: 266.844,
				width: 31.9786,
				height: 32.9749,
				frequency: [0.9282835721969604, 0.7064296007156372],
				numOctaves: 3,
				seed: 192,
				scale: 1.6381428241729736,
			},
		},
		stars: [],
		squiggles: [],
		prop: null,
	},
	thinkingLeft: {
		source: 'thinkingLeft.svg',
		viewBox: {
			width: 320,
			height: 321,
		},
		wings: {
			tealRight: {
				d: 'M267.929 189.466C243.007 202.663 183.29 174.619 167.446 166.714C165.648 165.818 165.466 163.16 167.123 161.954C202.113 136.487 267.584 128.098 296.865 127.108C327.18 126.083 290.055 177.749 267.929 189.466Z',
				texture: {
					x: 164.792,
					y: 125.902,
					width: 144.693,
					height: 68.2325,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
			tealLeft: {
				d: 'M76.3654 190.856C101.287 204.053 161.004 176.009 176.849 168.104C178.646 167.207 178.828 164.55 177.172 163.344C142.181 137.877 76.7099 129.488 47.429 128.497C17.1137 127.473 54.2385 179.139 76.3654 190.856Z',
				texture: {
					x: 34.8097,
					y: 127.292,
					width: 144.693,
					height: 68.2325,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
			purpleRight: {
				d: 'M263.205 162.052C244.209 182.895 178.528 176.68 160.944 174.594C158.95 174.358 157.88 171.918 159.032 170.223C183.358 134.431 242.143 104.41 269.366 93.5846C297.552 82.3754 280.071 143.547 263.205 162.052Z',
				texture: {
					x: 157.368,
					y: 91.0333,
					width: 128.077,
					height: 87.2542,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
			purpleLeft: {
				d: 'M80.5254 162.747C99.5213 183.589 165.202 177.375 182.786 175.289C184.78 175.052 185.85 172.613 184.698 170.918C160.372 135.126 101.587 105.105 74.3635 94.2788C46.1779 83.0703 63.6595 144.242 80.5254 162.747Z',
				texture: {
					x: 58.2843,
					y: 91.7277,
					width: 128.077,
					height: 87.2545,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
		},
		leftArm: {
			d: 'M96.5001 181C96.5001 181 99.5 168 113 158.5C126.5 149 139 147 139 147',
			texture: {
				x: 82.6705,
				y: 133.171,
				width: 70.1581,
				height: 61.6581,
				frequency: [0.9990000128746033, 0.732045590877533],
				numOctaves: 3,
				seed: 8637,
				scale: 1.5817248821258545,
			},
			front: true,
			renderMode: 'stroke',
		},
		rightArm: {
			d: 'M216 165C216 165 231.769 180 231.667 189.698C231.566 199.396 216 216 216 216',
			texture: {
				x: 202.173,
				y: 151.173,
				width: 43.321,
				height: 78.6534,
				frequency: [0.9990000128746033, 0.732045590877533],
				numOctaves: 3,
				seed: 8637,
				scale: 1.5817248821258545,
			},
			front: true,
			renderMode: 'stroke',
		},
		antennae: [
			{
				stem: {
					d: 'M128.667 71.9279C131.063 55.1521 139.451 37.9768 159.422 31.1865',
					texture: {
						x: 123.705,
						y: 26.2246,
						width: 40.6791,
						height: 50.6647,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 2801,
						scale: 1.933219313621521,
					},
				},
				tip: {
					d: 'M160.221 40.3736C165.295 40.3736 169.408 36.2605 169.408 31.1868C169.408 26.113 165.295 22 160.221 22C155.147 22 151.034 26.113 151.034 31.1868C151.034 36.2605 155.147 40.3736 160.221 40.3736Z',
					texture: {
						x: 149.668,
						y: 20.634,
						width: 21.1057,
						height: 21.1057,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 8737,
						scale: 2.732070207595825,
					},
				},
				front: false,
			},
			{
				stem: {
					d: 'M176.598 71.9279C178.994 55.1521 187.382 37.9768 207.353 31.1865',
					texture: {
						x: 171.636,
						y: 26.2246,
						width: 40.6791,
						height: 50.6647,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 2801,
						scale: 1.933219313621521,
					},
				},
				tip: {
					d: 'M208.152 40.3736C213.226 40.3736 217.339 36.2605 217.339 31.1868C217.339 26.113 213.226 22 208.152 22C203.078 22 198.965 26.113 198.965 31.1868C198.965 36.2605 203.078 40.3736 208.152 40.3736Z',
					texture: {
						x: 197.599,
						y: 20.634,
						width: 21.1056,
						height: 21.1057,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 8737,
						scale: 2.732070207595825,
					},
				},
				front: true,
			},
		],
		body: {
			d: 'M101.858 96.8471C102.719 76.5189 118.724 60.087 139.022 58.6899L161.405 57.1494L183.998 59.0027C204.371 60.6738 220.194 77.4571 220.664 97.8933L222.132 161.718L220.766 224.058C220.248 247.709 201.096 266.705 177.441 267.028L161.419 267.247H145.569C121.993 267.247 102.62 248.64 101.668 225.084L99.1089 161.718L101.858 96.8471Z',
			texture: {
				x: 95.9441,
				y: 53.9814,
				width: 129.352,
				height: 216.429,
				frequency: [0.29947322607040405, 0.24354049563407898],
				numOctaves: 3,
				seed: 6337,
				scale: 3.131495714187622,
			},
		},
		bodyMask:
			'M100.989 96.1398C101.952 74.6109 120.056 57.9994 141.599 58.5671L163.59 59.1465L179.396 58.6943C201.489 58.0621 219.895 75.4905 220.468 97.5842L222.132 161.718L221.01 223.995C220.58 247.832 201.219 266.977 177.379 267.139L161.42 267.247L143.865 267.128C120.657 266.971 101.573 248.791 100.643 225.601C99.8241 205.167 99.0643 180.842 99.1093 161.718C99.156 141.918 100.066 116.767 100.989 96.1398Z',
		bodyShade: {
			d: 'M206.555 53.5546C211.747 58.3477 221.733 76.1742 224.928 89.9023C228.124 103.63 229.322 132.641 229.322 147.02C229.322 161.399 224.928 182.569 220.934 195.75C216.94 208.931 210.15 222.911 206.555 232.497C202.96 242.083 194.572 257.262 180.992 278.831',
			texture: {
				x: 123.854,
				y: -3.57934,
				width: 162.602,
				height: 339.547,
				frequency: [0.638672411441803, 0.638672411441803],
				numOctaves: 3,
				seed: 9325,
				scale: 60.744625091552734,
			},
		},
		stripes: [
			{
				d: 'M225.328 166.991V187.362C225.328 187.362 202.598 185.764 161.819 185.764C121.041 185.764 95.9141 187.362 95.9141 187.362V166.991C95.9141 166.991 121.041 165.394 161.819 165.394C202.598 165.394 225.328 166.991 225.328 166.991Z',
				texture: {
					x: 95.4587,
					y: 164.938,
					width: 130.325,
					height: 22.8791,
					frequency: [0.5960943698883057, 0.5960943698883057],
					numOctaves: 3,
					seed: 2172,
					scale: 0.9106900691986084,
				},
			},
			{
				d: 'M225.328 200.943V221.314C225.328 221.314 202.598 219.716 161.819 219.716C121.041 219.716 95.9141 221.314 95.9141 221.314V200.943C95.9141 200.943 121.041 199.346 161.819 199.346C202.598 199.346 225.328 200.943 225.328 200.943Z',
				texture: {
					x: 95.4587,
					y: 198.89,
					width: 130.325,
					height: 22.8791,
					frequency: [0.5960943698883057, 0.5960943698883057],
					numOctaves: 3,
					seed: 2172,
					scale: 0.9106900691986084,
				},
			},
			{
				d: 'M225.328 234.494V254.865C225.328 254.865 202.598 253.267 161.819 253.267C121.041 253.267 95.9141 254.865 95.9141 254.865V234.494C95.9141 234.494 121.041 232.896 161.819 232.896C202.598 232.896 225.328 234.494 225.328 234.494Z',
				texture: {
					x: 95.4587,
					y: 232.441,
					width: 130.325,
					height: 22.8791,
					frequency: [0.5960943698883057, 0.5960943698883057],
					numOctaves: 3,
					seed: 2172,
					scale: 0.9106900691986084,
				},
			},
		],
		eyes: [
			{
				d: 'M119.432 122.786C124.038 122.786 127.772 123.436 127.772 116.836C127.772 110.235 124.038 104.885 119.432 104.885C114.826 104.885 111.092 110.235 111.092 116.836C111.092 123.436 114.826 122.786 119.432 122.786Z',
				texture: {
					x: 109.846,
					y: 103.639,
					width: 19.1724,
					height: 20.4115,
					frequency: [0.9990000128746033, 0.9990000128746033],
					numOctaves: 3,
					seed: 6148,
					scale: 1.6935639381408691,
				},
			},
			{
				d: 'M167.363 122.786C171.969 122.786 175.703 123.436 175.703 116.836C175.703 110.235 171.969 104.885 167.363 104.885C162.757 104.885 159.023 110.235 159.023 116.836C159.023 123.436 162.757 122.786 167.363 122.786Z',
				texture: {
					x: 157.777,
					y: 103.639,
					width: 19.1724,
					height: 20.4115,
					frequency: [0.9990000128746033, 0.9990000128746033],
					numOctaves: 3,
					seed: 6148,
					scale: 1.6935639381408691,
				},
			},
		],
		stinger: {
			d: 'M209.429 275.238C203.374 262.089 188.144 270.95 195.052 281.869C200.98 291.239 212.946 298.802 221.919 299.995C223.698 300.111 224.224 298.053 222.861 296.904C218.538 295.207 215.485 288.387 209.429 275.238Z',
			texture: {
				x: 192.472,
				y: 267.844,
				width: 31.9786,
				height: 32.9749,
				frequency: [0.9282835721969604, 0.7064296007156372],
				numOctaves: 3,
				seed: 192,
				scale: 1.6381428241729736,
			},
		},
		stars: [],
		squiggles: [],
		prop: null,
	},
	disappointedLeft: {
		source: 'disappointedLeft.svg',
		viewBox: {
			width: 320,
			height: 320,
		},
		wings: {
			tealRight: {
				d: 'M267.929 189.466C243.007 202.663 183.29 174.619 167.446 166.714C165.648 165.818 165.466 163.16 167.123 161.954C202.113 136.487 267.584 128.098 296.865 127.108C327.18 126.083 290.055 177.749 267.929 189.466Z',
				texture: {
					x: 164.792,
					y: 125.902,
					width: 144.693,
					height: 68.2325,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
			tealLeft: {
				d: 'M76.3654 190.856C101.287 204.053 161.004 176.009 176.849 168.104C178.646 167.207 178.828 164.55 177.172 163.344C142.181 137.877 76.7099 129.488 47.429 128.497C17.1137 127.473 54.2385 179.139 76.3654 190.856Z',
				texture: {
					x: 34.8097,
					y: 127.292,
					width: 144.693,
					height: 68.2325,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
			purpleRight: {
				d: 'M263.205 162.052C244.209 182.895 178.528 176.68 160.944 174.594C158.95 174.358 157.88 171.918 159.032 170.223C183.358 134.431 242.143 104.41 269.366 93.5846C297.552 82.3754 280.071 143.547 263.205 162.052Z',
				texture: {
					x: 157.368,
					y: 91.0333,
					width: 128.077,
					height: 87.2541,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
			purpleLeft: {
				d: 'M80.5254 162.747C99.5213 183.589 165.202 177.375 182.786 175.289C184.78 175.052 185.85 172.613 184.698 170.918C160.372 135.126 101.587 105.105 74.3635 94.2788C46.1779 83.0703 63.6595 144.242 80.5254 162.747Z',
				texture: {
					x: 58.2843,
					y: 91.7277,
					width: 128.077,
					height: 87.2545,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
		},
		leftArm: {
			d: 'M115.086 162.598C115.086 162.598 112.288 185.21 109.313 200.435C106.338 215.661 92.7183 232.897 92.7183 232.897',
			texture: {
				x: 78.8908,
				y: 148.77,
				width: 50.0231,
				height: 97.954,
				frequency: [0.9990000128746033, 0.732045590877533],
				numOctaves: 3,
				seed: 8637,
				scale: 1.5817248821258545,
			},
			front: false,
			renderMode: 'stroke',
		},
		rightArm: {
			d: 'M215.741 164.994C215.741 164.994 225.136 183.371 228.187 197.739C231.238 212.106 227.971 234.494 227.971 234.494',
			texture: {
				x: 201.912,
				y: 151.165,
				width: 41.4045,
				height: 97.1579,
				frequency: [0.9990000128746033, 0.732045590877533],
				numOctaves: 3,
				seed: 8637,
				scale: 1.5817248821258545,
			},
			front: true,
			renderMode: 'stroke',
		},
		antennae: [
			{
				stem: {
					d: 'M133.771 65.9223C116.947 63.8953 98.1856 67.5521 86.4578 85.0855',
					texture: {
						x: 81.4963,
						y: 60.462,
						width: 57.236,
						height: 29.5848,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 2801,
						scale: 1.933219313621521,
					},
				},
				tip: {
					d: 'M95.1252 88.2346C93.812 93.1355 88.7745 96.0439 83.8737 94.7307C78.9728 93.4175 76.0645 88.3801 77.3777 83.4792C78.6908 78.5784 83.7283 75.67 88.6291 76.9832C93.53 78.2964 96.4383 83.3338 95.1252 88.2346Z',
					texture: {
						x: 75.6965,
						y: 75.3018,
						width: 21.11,
						height: 21.1102,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 8737,
						scale: 2.732070207595825,
					},
				},
				front: false,
			},
			{
				stem: {
					d: 'M178.784 67.7734C195.714 67.0207 214.145 72.0817 224.518 90.4494',
					texture: {
						x: 173.823,
						y: 62.7421,
						width: 55.6559,
						height: 32.6688,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 2801,
						scale: 1.933219313621521,
					},
				},
				tip: {
					d: 'M215.638 92.9362C216.577 97.9221 221.381 101.202 226.367 100.262C231.353 99.3221 234.633 94.5183 233.693 89.5324C232.753 84.5465 227.949 81.2666 222.963 82.2065C217.978 83.1464 214.698 87.9503 215.638 92.9362Z',
					texture: {
						x: 214.111,
						y: 80.6797,
						width: 21.109,
						height: 21.109,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 8737,
						scale: 2.732070207595825,
					},
				},
				front: true,
			},
		],
		body: {
			d: 'M101.858 96.8471C102.719 76.5189 118.724 60.087 139.022 58.6899L161.405 57.1494L183.998 59.0027C204.371 60.6738 220.194 77.4571 220.664 97.8933L222.132 161.718L220.766 224.058C220.248 247.709 201.096 266.705 177.441 267.028L161.419 267.247H145.569C121.993 267.247 102.62 248.64 101.668 225.084L99.1089 161.718L101.858 96.8471Z',
			texture: {
				x: 95.944,
				y: 53.9815,
				width: 129.352,
				height: 216.429,
				frequency: [0.29947322607040405, 0.24354049563407898],
				numOctaves: 3,
				seed: 6337,
				scale: 3.131495714187622,
			},
		},
		bodyMask:
			'M100.989 96.1398C101.952 74.6109 120.056 57.9994 141.599 58.5671L163.59 59.1465L179.396 58.6943C201.489 58.0621 219.895 75.4905 220.468 97.5842L222.132 161.718L221.01 223.995C220.58 247.832 201.219 266.977 177.379 267.139L161.42 267.247L143.865 267.128C120.657 266.971 101.573 248.791 100.643 225.601C99.8241 205.167 99.0643 180.842 99.1093 161.718C99.156 141.918 100.066 116.767 100.989 96.1398Z',
		bodyShade: {
			d: 'M206.555 53.5547C211.747 58.3478 221.733 76.1743 224.928 89.9024C228.124 103.631 229.322 132.641 229.322 147.02C229.322 161.4 224.928 182.569 220.934 195.75C216.94 208.931 210.15 222.911 206.555 232.497C202.96 242.083 194.572 257.262 180.992 278.831',
			texture: {
				x: 123.854,
				y: -3.57922,
				width: 162.602,
				height: 339.547,
				frequency: [0.638672411441803, 0.638672411441803],
				numOctaves: 3,
				seed: 9325,
				scale: 60.744625091552734,
			},
		},
		stripes: [
			{
				d: 'M225.328 166.991V187.362C225.328 187.362 202.598 185.764 161.819 185.764C121.041 185.764 95.9141 187.362 95.9141 187.362V166.991C95.9141 166.991 121.041 165.394 161.819 165.394C202.598 165.394 225.328 166.991 225.328 166.991Z',
				texture: {
					x: 95.4587,
					y: 164.938,
					width: 130.325,
					height: 22.8791,
					frequency: [0.5960943698883057, 0.5960943698883057],
					numOctaves: 3,
					seed: 2172,
					scale: 0.9106900691986084,
				},
			},
			{
				d: 'M225.328 200.943V221.314C225.328 221.314 202.598 219.716 161.819 219.716C121.041 219.716 95.9141 221.314 95.9141 221.314V200.943C95.9141 200.943 121.041 199.346 161.819 199.346C202.598 199.346 225.328 200.943 225.328 200.943Z',
				texture: {
					x: 95.4587,
					y: 198.89,
					width: 130.325,
					height: 22.8791,
					frequency: [0.5960943698883057, 0.5960943698883057],
					numOctaves: 3,
					seed: 2172,
					scale: 0.9106900691986084,
				},
			},
			{
				d: 'M225.328 234.494V254.865C225.328 254.865 202.598 253.267 161.819 253.267C121.041 253.267 95.9141 254.865 95.9141 254.865V234.494C95.9141 234.494 121.041 232.896 161.819 232.896C202.598 232.896 225.328 234.494 225.328 234.494Z',
				texture: {
					x: 95.4587,
					y: 232.441,
					width: 130.325,
					height: 22.8791,
					frequency: [0.5960943698883057, 0.5960943698883057],
					numOctaves: 3,
					seed: 2172,
					scale: 0.9106900691986084,
				},
			},
		],
		eyes: [
			{
				d: 'M119.432 125.786C124.038 125.786 127.772 120.436 127.772 113.836C127.772 107.235 127.038 110.885 119.432 112.885C114.575 114.162 111.092 110.235 111.092 116.836C111.092 123.436 114.826 125.786 119.432 125.786Z',
				texture: {
					x: 109.846,
					y: 108.814,
					width: 19.1721,
					height: 18.2181,
					frequency: [0.9990000128746033, 0.9990000128746033],
					numOctaves: 3,
					seed: 6148,
					scale: 1.6935639381408691,
				},
			},
			{
				d: 'M167.363 125.786C171.969 125.786 175.703 123.436 175.703 116.836C175.703 110.235 172.219 114.162 167.363 112.885C159.757 110.885 159.023 107.235 159.023 113.836C159.023 120.436 162.757 125.786 167.363 125.786Z',
				texture: {
					x: 157.777,
					y: 108.814,
					width: 19.1726,
					height: 18.2181,
					frequency: [0.9990000128746033, 0.9990000128746033],
					numOctaves: 3,
					seed: 6148,
					scale: 1.6935639381408691,
				},
			},
		],
		stinger: {
			d: 'M193.202 275.238C199.258 262.089 214.487 270.95 207.579 281.869C201.651 291.239 189.686 298.802 180.712 299.995C178.933 300.111 178.408 298.053 179.77 296.904C184.094 295.207 187.147 288.387 193.202 275.238Z',
			texture: {
				x: 178.181,
				y: 267.844,
				width: 31.9785,
				height: 32.9751,
				frequency: [0.9282835721969604, 0.7064296007156372],
				numOctaves: 3,
				seed: 192,
				scale: 1.6381428241729736,
			},
		},
		stars: [],
		squiggles: [],
		prop: null,
	},
	disappointedRight: {
		source: 'disappointedRight.svg',
		viewBox: {
			width: 320,
			height: 320,
		},
		wings: {
			tealRight: {
				d: 'M243.639 188.466C218.717 201.663 159 173.619 143.156 165.714C141.358 164.818 141.176 162.16 142.833 160.954C177.823 135.487 243.294 127.098 272.575 126.108C302.89 125.083 265.765 176.749 243.639 188.466Z',
				texture: {
					x: 140.502,
					y: 124.902,
					width: 144.693,
					height: 68.2325,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
			tealLeft: {
				d: 'M52.0754 189.856C76.9968 203.053 136.714 175.009 152.559 167.104C154.356 166.207 154.538 163.55 152.882 162.344C117.891 136.877 52.4199 128.488 23.139 127.497C-7.1763 126.473 29.9484 178.139 52.0754 189.856Z',
				texture: {
					x: 10.5197,
					y: 126.292,
					width: 144.693,
					height: 68.2325,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
			purpleRight: {
				d: 'M238.915 161.052C219.919 181.895 154.238 175.68 136.654 173.594C134.66 173.358 133.59 170.918 134.742 169.223C159.068 133.431 217.853 103.41 245.076 92.5846C273.262 81.3754 255.781 142.547 238.915 161.052Z',
				texture: {
					x: 133.078,
					y: 90.0333,
					width: 128.077,
					height: 87.2541,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
			purpleLeft: {
				d: 'M56.2354 161.747C75.2312 182.589 140.912 176.375 158.496 174.289C160.49 174.052 161.56 171.613 160.408 169.918C136.082 134.126 77.2973 104.105 50.0734 93.2788C21.8878 82.0703 39.3695 143.242 56.2354 161.747Z',
				texture: {
					x: 33.9943,
					y: 90.7277,
					width: 128.077,
					height: 87.2545,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
		},
		leftArm: {
			d: 'M107.466 163.994C107.466 163.994 98.0713 182.371 95.0204 196.739C91.9694 211.106 95.2365 233.494 95.2365 233.494',
			texture: {
				x: 79.8908,
				y: 150.165,
				width: 41.4045,
				height: 97.1579,
				frequency: [0.9990000128746033, 0.732045590877533],
				numOctaves: 3,
				seed: 8637,
				scale: 1.5817248821258545,
			},
			front: true,
			renderMode: 'stroke',
		},
		rightArm: {
			d: 'M216.121 161.598C216.121 161.598 218.919 184.21 221.894 199.435C224.869 214.661 238.489 231.897 238.489 231.897',
			texture: {
				x: 202.293,
				y: 147.77,
				width: 50.0229,
				height: 97.954,
				frequency: [0.9990000128746033, 0.732045590877533],
				numOctaves: 3,
				seed: 8637,
				scale: 1.5817248821258545,
			},
			front: false,
			renderMode: 'stroke',
		},
		antennae: [
			{
				stem: {
					d: 'M143.772 65.9223C126.947 63.8953 108.186 67.5521 96.4583 85.0855',
					texture: {
						x: 91.4973,
						y: 60.462,
						width: 57.236,
						height: 29.5847,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 2801,
						scale: 1.933219313621521,
					},
				},
				tip: {
					d: 'M105.126 88.2346C103.812 93.1355 98.775 96.0439 93.8742 94.7307C88.9733 93.4175 86.065 88.3801 87.3781 83.4792C88.6913 78.5784 93.7288 75.67 98.6296 76.9832C103.53 78.2964 106.439 83.3338 105.126 88.2346Z',
					texture: {
						x: 85.6965,
						y: 75.3018,
						width: 21.1105,
						height: 21.1102,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 8737,
						scale: 2.732070207595825,
					},
				},
				front: true,
			},
			{
				stem: {
					d: 'M188.784 67.7734C205.714 67.0207 224.145 72.0817 234.518 90.4494',
					texture: {
						x: 183.823,
						y: 62.7421,
						width: 55.6561,
						height: 32.6688,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 2801,
						scale: 1.933219313621521,
					},
				},
				tip: {
					d: 'M225.638 92.9362C226.577 97.9221 231.381 101.202 236.367 100.262C241.353 99.3221 244.633 94.5183 243.693 89.5324C242.753 84.5465 237.949 81.2666 232.963 82.2065C227.978 83.1464 224.698 87.9503 225.638 92.9362Z',
					texture: {
						x: 224.111,
						y: 80.6799,
						width: 21.1093,
						height: 21.1089,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 8737,
						scale: 2.732070207595825,
					},
				},
				front: false,
			},
		],
		body: {
			d: 'M101.858 96.8471C102.719 76.5189 118.724 60.087 139.022 58.6899L161.405 57.1494L183.998 59.0027C204.371 60.6738 220.194 77.4571 220.664 97.8933L222.132 161.718L220.766 224.058C220.248 247.709 201.096 266.705 177.441 267.028L161.419 267.247H145.569C121.993 267.247 102.62 248.64 101.668 225.084L99.1089 161.718L101.858 96.8471Z',
			texture: {
				x: 95.944,
				y: 53.9815,
				width: 129.352,
				height: 216.429,
				frequency: [0.29947322607040405, 0.24354049563407898],
				numOctaves: 3,
				seed: 6337,
				scale: 3.131495714187622,
			},
		},
		bodyMask:
			'M100.989 96.1398C101.952 74.6109 120.056 57.9994 141.599 58.5671L163.59 59.1465L179.396 58.6943C201.489 58.0621 219.895 75.4905 220.468 97.5842L222.132 161.718L221.01 223.995C220.58 247.832 201.219 266.977 177.379 267.139L161.42 267.247L143.865 267.128C120.657 266.971 101.573 248.791 100.643 225.601C99.8241 205.167 99.0643 180.842 99.1093 161.718C99.156 141.918 100.066 116.767 100.989 96.1398Z',
		bodyShade: {
			d: 'M206.555 53.5547C211.747 58.3478 221.733 76.1743 224.928 89.9024C228.124 103.631 229.322 132.641 229.322 147.02C229.322 161.4 224.928 182.569 220.934 195.75C216.94 208.931 210.15 222.911 206.555 232.497C202.96 242.083 194.572 257.262 180.992 278.831',
			texture: {
				x: 123.854,
				y: -3.57922,
				width: 162.602,
				height: 339.547,
				frequency: [0.638672411441803, 0.638672411441803],
				numOctaves: 3,
				seed: 9325,
				scale: 60.744625091552734,
			},
		},
		stripes: [
			{
				d: 'M225.328 166.991V187.362C225.328 187.362 202.598 185.764 161.819 185.764C121.041 185.764 95.9141 187.362 95.9141 187.362V166.991C95.9141 166.991 121.041 165.394 161.819 165.394C202.598 165.394 225.328 166.991 225.328 166.991Z',
				texture: {
					x: 95.4587,
					y: 164.938,
					width: 130.325,
					height: 22.8791,
					frequency: [0.5960943698883057, 0.5960943698883057],
					numOctaves: 3,
					seed: 2172,
					scale: 0.9106900691986084,
				},
			},
			{
				d: 'M225.328 200.943V221.314C225.328 221.314 202.598 219.716 161.819 219.716C121.041 219.716 95.9141 221.314 95.9141 221.314V200.943C95.9141 200.943 121.041 199.346 161.819 199.346C202.598 199.346 225.328 200.943 225.328 200.943Z',
				texture: {
					x: 95.4587,
					y: 198.89,
					width: 130.325,
					height: 22.8791,
					frequency: [0.5960943698883057, 0.5960943698883057],
					numOctaves: 3,
					seed: 2172,
					scale: 0.9106900691986084,
				},
			},
			{
				d: 'M225.328 234.494V254.865C225.328 254.865 202.598 253.267 161.819 253.267C121.041 253.267 95.9141 254.865 95.9141 254.865V234.494C95.9141 234.494 121.041 232.896 161.819 232.896C202.598 232.896 225.328 234.494 225.328 234.494Z',
				texture: {
					x: 95.4587,
					y: 232.441,
					width: 130.325,
					height: 22.8791,
					frequency: [0.5960943698883057, 0.5960943698883057],
					numOctaves: 3,
					seed: 2172,
					scale: 0.9106900691986084,
				},
			},
		],
		eyes: [
			{
				d: 'M153.902 125.786C158.508 125.786 162.242 120.436 162.242 113.836C162.242 107.235 161.508 110.885 153.902 112.885C149.046 114.162 145.562 110.235 145.562 116.836C145.562 123.436 149.296 125.786 153.902 125.786Z',
				texture: {
					x: 144.316,
					y: 108.814,
					width: 19.1726,
					height: 18.2181,
					frequency: [0.9990000128746033, 0.9990000128746033],
					numOctaves: 3,
					seed: 6148,
					scale: 1.6935639381408691,
				},
			},
			{
				d: 'M201.833 125.786C206.439 125.786 210.173 123.436 210.173 116.836C210.173 110.235 206.69 114.162 201.833 112.885C194.227 110.885 193.493 107.235 193.493 113.836C193.493 120.436 197.227 125.786 201.833 125.786Z',
				texture: {
					x: 192.247,
					y: 108.814,
					width: 19.1721,
					height: 18.2181,
					frequency: [0.9990000128746033, 0.9990000128746033],
					numOctaves: 3,
					seed: 6148,
					scale: 1.6935639381408691,
				},
			},
		],
		stinger: {
			d: 'M126.429 274.238C120.374 261.089 105.144 269.95 112.052 280.869C117.98 290.239 129.946 297.802 138.919 298.995C140.698 299.111 141.224 297.053 139.861 295.904C135.538 294.207 132.485 287.387 126.429 274.238Z',
			texture: {
				x: 109.472,
				y: 266.844,
				width: 31.979,
				height: 32.9751,
				frequency: [0.9282835721969604, 0.7064296007156372],
				numOctaves: 3,
				seed: 192,
				scale: 1.6381428241729736,
			},
		},
		stars: [],
		squiggles: [],
		prop: null,
	},
	searchingLeft: {
		source: 'searchingLeft.svg',
		viewBox: {
			width: 320,
			height: 320,
		},
		wings: {
			tealRight: {
				d: 'M267.929 189.466C243.007 202.663 183.29 174.619 167.446 166.714C165.648 165.818 165.466 163.16 167.123 161.954C202.113 136.487 267.584 128.098 296.865 127.108C327.18 126.083 290.055 177.749 267.929 189.466Z',
				texture: {
					x: 164.792,
					y: 125.902,
					width: 144.693,
					height: 68.2325,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
			tealLeft: {
				d: 'M76.3654 190.856C101.287 204.053 161.004 176.009 176.849 168.104C178.646 167.207 178.828 164.55 177.172 163.344C142.181 137.877 76.7099 129.488 47.429 128.497C17.1137 127.473 54.2385 179.139 76.3654 190.856Z',
				texture: {
					x: 34.8097,
					y: 127.292,
					width: 144.693,
					height: 68.2325,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
			purpleRight: {
				d: 'M263.205 162.052C244.209 182.895 178.528 176.68 160.944 174.594C158.95 174.358 157.88 171.918 159.032 170.223C183.358 134.431 242.143 104.41 269.366 93.5846C297.552 82.3754 280.071 143.547 263.205 162.052Z',
				texture: {
					x: 157.368,
					y: 91.0333,
					width: 128.077,
					height: 87.2541,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
			purpleLeft: {
				d: 'M80.5254 162.747C99.5213 183.589 165.202 177.375 182.786 175.289C184.78 175.052 185.85 172.613 184.698 170.918C160.372 135.126 101.587 105.105 74.3635 94.2788C46.1779 83.0703 63.6595 144.242 80.5254 162.747Z',
				texture: {
					x: 58.2843,
					y: 91.7277,
					width: 128.077,
					height: 87.2545,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
		},
		leftArm: {
			d: 'M95 164.5C95 164.5 86.0001 134 86 119C85.9999 104 96 96 96 96',
			texture: {
				x: 72.1735,
				y: 82.1729,
				width: 37.6535,
				height: 96.1572,
				frequency: [0.9990000128746033, 0.732045590877533],
				numOctaves: 3,
				seed: 8637,
				scale: 1.5817248821258545,
			},
			front: true,
			renderMode: 'stroke',
		},
		rightArm: {
			d: 'M216 165C216 165 231.769 180 231.667 189.698C231.566 199.396 216 216 216 216',
			texture: {
				x: 202.173,
				y: 151.173,
				width: 43.321,
				height: 78.6534,
				frequency: [0.9990000128746033, 0.732045590877533],
				numOctaves: 3,
				seed: 8637,
				scale: 1.5817248821258545,
			},
			front: true,
			renderMode: 'stroke',
		},
		antennae: [
			{
				stem: {
					d: 'M128.667 71.9279C131.063 55.1521 139.451 37.9768 159.422 31.1865',
					texture: {
						x: 123.705,
						y: 26.2246,
						width: 40.6788,
						height: 50.6648,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 2801,
						scale: 1.933219313621521,
					},
				},
				tip: {
					d: 'M160.221 40.3736C165.295 40.3736 169.408 36.2605 169.408 31.1868C169.408 26.113 165.295 22 160.221 22C155.147 22 151.034 26.113 151.034 31.1868C151.034 36.2605 155.147 40.3736 160.221 40.3736Z',
					texture: {
						x: 149.668,
						y: 20.634,
						width: 21.1056,
						height: 21.1056,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 8737,
						scale: 2.732070207595825,
					},
				},
				front: false,
			},
			{
				stem: {
					d: 'M176.598 71.9279C178.994 55.1521 187.382 37.9768 207.353 31.1865',
					texture: {
						x: 171.636,
						y: 26.2246,
						width: 40.6788,
						height: 50.6648,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 2801,
						scale: 1.933219313621521,
					},
				},
				tip: {
					d: 'M208.152 40.3736C213.226 40.3736 217.339 36.2605 217.339 31.1868C217.339 26.113 213.226 22 208.152 22C203.078 22 198.965 26.113 198.965 31.1868C198.965 36.2605 203.078 40.3736 208.152 40.3736Z',
					texture: {
						x: 197.599,
						y: 20.634,
						width: 21.1056,
						height: 21.1056,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 8737,
						scale: 2.732070207595825,
					},
				},
				front: true,
			},
		],
		body: {
			d: 'M101.858 96.8471C102.719 76.5189 118.724 60.087 139.022 58.6899L161.405 57.1494L183.998 59.0027C204.371 60.6738 220.194 77.4571 220.664 97.8933L222.132 161.718L220.766 224.058C220.248 247.709 201.096 266.705 177.441 267.028L161.419 267.247H145.569C121.993 267.247 102.62 248.64 101.668 225.084L99.1089 161.718L101.858 96.8471Z',
			texture: {
				x: 95.944,
				y: 53.9815,
				width: 129.352,
				height: 216.429,
				frequency: [0.29947322607040405, 0.24354049563407898],
				numOctaves: 3,
				seed: 6337,
				scale: 3.131495714187622,
			},
		},
		bodyMask:
			'M100.989 96.1398C101.952 74.6109 120.056 57.9994 141.599 58.5671L163.59 59.1465L179.396 58.6943C201.489 58.0621 219.895 75.4905 220.468 97.5842L222.132 161.718L221.01 223.995C220.58 247.832 201.219 266.977 177.379 267.139L161.42 267.247L143.865 267.128C120.657 266.971 101.573 248.791 100.643 225.601C99.8241 205.167 99.0643 180.842 99.1093 161.718C99.156 141.918 100.066 116.767 100.989 96.1398Z',
		bodyShade: {
			d: 'M206.555 53.5547C211.747 58.3478 221.733 76.1743 224.928 89.9024C228.124 103.631 229.322 132.641 229.322 147.02C229.322 161.4 224.928 182.569 220.934 195.75C216.94 208.931 210.15 222.911 206.555 232.497C202.96 242.083 194.572 257.262 180.992 278.831',
			texture: {
				x: 123.854,
				y: -3.57922,
				width: 162.602,
				height: 339.547,
				frequency: [0.638672411441803, 0.638672411441803],
				numOctaves: 3,
				seed: 9325,
				scale: 60.744625091552734,
			},
		},
		stripes: [
			{
				d: 'M225.328 166.991V187.362C225.328 187.362 202.598 185.764 161.819 185.764C121.041 185.764 95.9141 187.362 95.9141 187.362V166.991C95.9141 166.991 121.041 165.394 161.819 165.394C202.598 165.394 225.328 166.991 225.328 166.991Z',
				texture: {
					x: 95.4587,
					y: 164.938,
					width: 130.325,
					height: 22.8791,
					frequency: [0.5960943698883057, 0.5960943698883057],
					numOctaves: 3,
					seed: 2172,
					scale: 0.9106900691986084,
				},
			},
			{
				d: 'M225.328 200.943V221.314C225.328 221.314 202.598 219.716 161.819 219.716C121.041 219.716 95.9141 221.314 95.9141 221.314V200.943C95.9141 200.943 121.041 199.346 161.819 199.346C202.598 199.346 225.328 200.943 225.328 200.943Z',
				texture: {
					x: 95.4587,
					y: 198.89,
					width: 130.325,
					height: 22.8791,
					frequency: [0.5960943698883057, 0.5960943698883057],
					numOctaves: 3,
					seed: 2172,
					scale: 0.9106900691986084,
				},
			},
			{
				d: 'M225.328 234.494V254.865C225.328 254.865 202.598 253.267 161.819 253.267C121.041 253.267 95.9141 254.865 95.9141 254.865V234.494C95.9141 234.494 121.041 232.896 161.819 232.896C202.598 232.896 225.328 234.494 225.328 234.494Z',
				texture: {
					x: 95.4587,
					y: 232.441,
					width: 130.325,
					height: 22.8791,
					frequency: [0.5960943698883057, 0.5960943698883057],
					numOctaves: 3,
					seed: 2172,
					scale: 0.9106900691986084,
				},
			},
		],
		eyes: [
			{
				d: 'M114.432 124.786C119.038 124.786 122.772 125.436 122.772 118.836C122.772 112.235 119.038 106.885 114.432 106.885C109.826 106.885 106.092 112.235 106.092 118.836C106.092 125.436 109.826 124.786 114.432 124.786Z',
				texture: {
					x: 104.846,
					y: 105.639,
					width: 19.1726,
					height: 20.4116,
					frequency: [0.9990000128746033, 0.9990000128746033],
					numOctaves: 3,
					seed: 6148,
					scale: 1.6935639381408691,
				},
			},
			{
				d: 'M162.363 124.786C166.969 124.786 170.703 125.436 170.703 118.836C170.703 112.235 166.969 106.885 162.363 106.885C157.757 106.885 154.023 112.235 154.023 118.836C154.023 125.436 157.757 124.786 162.363 124.786Z',
				texture: {
					x: 152.777,
					y: 105.639,
					width: 19.1726,
					height: 20.4116,
					frequency: [0.9990000128746033, 0.9990000128746033],
					numOctaves: 3,
					seed: 6148,
					scale: 1.6935639381408691,
				},
			},
		],
		stinger: {
			d: 'M209.429 275.238C203.374 262.089 188.144 270.95 195.052 281.869C200.98 291.239 212.946 298.802 221.919 299.995C223.698 300.111 224.224 298.053 222.861 296.904C218.538 295.207 215.485 288.387 209.429 275.238Z',
			texture: {
				x: 192.472,
				y: 267.844,
				width: 31.9785,
				height: 32.9749,
				frequency: [0.9282835721969604, 0.7064296007156372],
				numOctaves: 3,
				seed: 192,
				scale: 1.6381428241729736,
			},
		},
		stars: [],
		squiggles: [],
		prop: null,
	},
	searchingRight: {
		source: 'searchingRight.svg',
		viewBox: {
			width: 320,
			height: 320,
		},
		wings: {
			tealRight: {
				d: 'M243.639 188.466C218.717 201.663 159 173.619 143.156 165.714C141.358 164.818 141.176 162.16 142.833 160.954C177.823 135.487 243.294 127.098 272.575 126.108C302.89 125.083 265.765 176.749 243.639 188.466Z',
				texture: {
					x: 140.502,
					y: 124.902,
					width: 144.693,
					height: 68.2325,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
			tealLeft: {
				d: 'M52.0754 189.856C76.9968 203.053 136.714 175.009 152.559 167.104C154.356 166.207 154.538 163.55 152.882 162.344C117.891 136.877 52.4199 128.488 23.139 127.497C-7.1763 126.473 29.9484 178.139 52.0754 189.856Z',
				texture: {
					x: 10.5197,
					y: 126.292,
					width: 144.693,
					height: 68.2325,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
			purpleRight: {
				d: 'M238.915 161.052C219.918 181.895 154.238 175.68 136.654 173.594C134.66 173.358 133.59 170.918 134.742 169.223C159.067 133.431 217.853 103.41 245.076 92.5846C273.262 81.3754 255.78 142.547 238.915 161.052Z',
				texture: {
					x: 133.078,
					y: 90.0333,
					width: 128.077,
					height: 87.2541,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
			purpleLeft: {
				d: 'M56.2354 161.747C75.2312 182.589 140.912 176.375 158.496 174.289C160.49 174.052 161.56 171.613 160.408 169.918C136.082 134.126 77.2973 104.105 50.0734 93.2788C21.8878 82.0703 39.3695 143.242 56.2354 161.747Z',
				texture: {
					x: 33.9943,
					y: 90.7277,
					width: 128.077,
					height: 87.2545,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
		},
		leftArm: {
			d: 'M107.466 163.994C107.466 163.994 89.5509 173.132 86.5 187.5C83.4491 201.868 107.466 211.5 107.466 211.5',
			texture: {
				x: 72.3815,
				y: 150.165,
				width: 48.9145,
				height: 75.1655,
				frequency: [0.9990000128746033, 0.732045590877533],
				numOctaves: 3,
				seed: 8637,
				scale: 1.5817248821258545,
			},
			front: true,
			renderMode: 'stroke',
		},
		rightArm: {
			d: 'M225 164.5C225 164.5 234 134 234 119C234 104 224 96 224 96',
			texture: {
				x: 210.173,
				y: 82.1729,
				width: 37.654,
				height: 96.1572,
				frequency: [0.9990000128746033, 0.732045590877533],
				numOctaves: 3,
				seed: 8637,
				scale: 1.5817248821258545,
			},
			front: true,
			renderMode: 'stroke',
		},
		antennae: [
			{
				stem: {
					d: 'M129.667 70.9279C132.063 54.1521 140.451 36.9768 160.422 30.1865',
					texture: {
						x: 124.705,
						y: 25.2246,
						width: 40.6793,
						height: 50.6648,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 2801,
						scale: 1.933219313621521,
					},
				},
				tip: {
					d: 'M161.221 39.3736C166.295 39.3736 170.408 35.2605 170.408 30.1868C170.408 25.113 166.295 21 161.221 21C156.147 21 152.034 25.113 152.034 30.1868C152.034 35.2605 156.147 39.3736 161.221 39.3736Z',
					texture: {
						x: 150.668,
						y: 19.634,
						width: 21.1056,
						height: 21.1056,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 8737,
						scale: 2.732070207595825,
					},
				},
				front: true,
			},
			{
				stem: {
					d: 'M177.598 70.9279C179.994 54.1521 188.382 36.9768 208.353 30.1865',
					texture: {
						x: 172.636,
						y: 25.2246,
						width: 40.6793,
						height: 50.6648,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 2801,
						scale: 1.933219313621521,
					},
				},
				tip: {
					d: 'M209.152 39.3736C214.226 39.3736 218.339 35.2605 218.339 30.1868C218.339 25.113 214.226 21 209.152 21C204.078 21 199.965 25.113 199.965 30.1868C199.965 35.2605 204.078 39.3736 209.152 39.3736Z',
					texture: {
						x: 198.599,
						y: 19.634,
						width: 21.1056,
						height: 21.1056,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 8737,
						scale: 2.732070207595825,
					},
				},
				front: false,
			},
		],
		body: {
			d: 'M102.858 95.8472C103.72 75.5191 119.724 59.0871 140.022 57.69L162.405 56.1495L184.998 58.0028C205.371 59.6739 221.195 76.4572 221.665 96.8934L223.132 160.718L221.767 223.058C221.248 246.71 202.096 265.705 178.441 266.028L162.42 266.247H146.569C122.994 266.247 103.62 247.64 102.668 224.084L100.109 160.718L102.858 95.8472Z',
			texture: {
				x: 96.9443,
				y: 52.9816,
				width: 129.352,
				height: 216.429,
				frequency: [0.29947322607040405, 0.24354049563407898],
				numOctaves: 3,
				seed: 6337,
				scale: 3.131495714187622,
			},
		},
		bodyMask:
			'M101.989 95.1398C102.952 73.6109 121.056 56.9994 142.599 57.5671L164.59 58.1465L180.396 57.6943C202.489 57.0621 220.895 74.4905 221.468 96.5842L223.132 160.718L222.01 222.995C221.58 246.832 202.219 265.977 178.379 266.139L162.42 266.247L144.865 266.128C121.657 265.971 102.573 247.791 101.643 224.601C100.824 204.167 100.064 179.842 100.109 160.718C100.156 140.918 101.066 115.767 101.989 95.1398Z',
		bodyShade: {
			d: 'M207.555 52.5547C212.747 57.3478 222.733 75.1743 225.928 88.9024C229.124 102.631 230.322 131.641 230.322 146.02C230.322 160.4 225.928 181.569 221.934 194.75C217.94 207.931 211.15 221.911 207.555 231.497C203.96 241.083 195.572 256.262 181.991 277.831',
			texture: {
				x: 124.854,
				y: -4.57922,
				width: 162.602,
				height: 339.547,
				frequency: [0.638672411441803, 0.638672411441803],
				numOctaves: 3,
				seed: 9325,
				scale: 60.744625091552734,
			},
		},
		stripes: [
			{
				d: 'M226.328 165.991V186.362C226.328 186.362 203.598 184.764 162.819 184.764C122.04 184.764 96.9138 186.362 96.9138 186.362V165.991C96.9138 165.991 122.04 164.393 162.819 164.393C203.598 164.393 226.328 165.991 226.328 165.991Z',
				texture: {
					x: 96.4585,
					y: 163.938,
					width: 130.325,
					height: 22.8791,
					frequency: [0.5960943698883057, 0.5960943698883057],
					numOctaves: 3,
					seed: 2172,
					scale: 0.9106900691986084,
				},
			},
			{
				d: 'M226.328 199.943V220.314C226.328 220.314 203.598 218.716 162.819 218.716C122.04 218.716 96.9138 220.314 96.9138 220.314V199.943C96.9138 199.943 122.04 198.346 162.819 198.346C203.598 198.346 226.328 199.943 226.328 199.943Z',
				texture: {
					x: 96.4585,
					y: 197.89,
					width: 130.325,
					height: 22.8791,
					frequency: [0.5960943698883057, 0.5960943698883057],
					numOctaves: 3,
					seed: 2172,
					scale: 0.9106900691986084,
				},
			},
			{
				d: 'M226.328 233.494V253.865C226.328 253.865 203.598 252.267 162.819 252.267C122.04 252.267 96.9138 253.865 96.9138 253.865V233.494C96.9138 233.494 122.04 231.896 162.819 231.896C203.598 231.896 226.328 233.494 226.328 233.494Z',
				texture: {
					x: 96.4585,
					y: 231.441,
					width: 130.325,
					height: 22.8791,
					frequency: [0.5960943698883057, 0.5960943698883057],
					numOctaves: 3,
					seed: 2172,
					scale: 0.9106900691986084,
				},
			},
		],
		eyes: [
			{
				d: 'M157.432 123.786C162.038 123.786 165.772 125.436 165.772 118.836C165.772 112.235 162.038 106.885 157.432 106.885C152.826 106.885 149.092 112.235 149.092 118.836C149.092 125.436 152.826 123.786 157.432 123.786Z',
				texture: {
					x: 147.846,
					y: 105.639,
					width: 19.1723,
					height: 19.5772,
					frequency: [0.9990000128746033, 0.9990000128746033],
					numOctaves: 3,
					seed: 6148,
					scale: 1.6935639381408691,
				},
			},
			{
				d: 'M205.363 123.786C209.969 123.786 213.703 125.436 213.703 118.836C213.703 112.235 209.969 106.885 205.363 106.885C200.757 106.885 197.023 112.235 197.023 118.836C197.023 125.436 200.757 123.786 205.363 123.786Z',
				texture: {
					x: 195.777,
					y: 105.639,
					width: 19.1723,
					height: 19.5772,
					frequency: [0.9990000128746033, 0.9990000128746033],
					numOctaves: 3,
					seed: 6148,
					scale: 1.6935639381408691,
				},
			},
		],
		stinger: {
			d: 'M110.493 274.238C116.549 261.089 131.778 269.95 124.87 280.869C118.942 290.239 106.977 297.802 98.0034 298.995C96.2245 299.111 95.6986 297.053 97.0613 295.904C101.385 294.207 104.438 287.387 110.493 274.238Z',
			texture: {
				x: 95.4717,
				y: 266.844,
				width: 31.9787,
				height: 32.9749,
				frequency: [0.9282835721969604, 0.7064296007156372],
				numOctaves: 3,
				seed: 192,
				scale: 1.6381428241729736,
			},
		},
		stars: [],
		squiggles: [],
		prop: null,
	},
	searching: {
		source: 'searching.svg',
		viewBox: {
			width: 320,
			height: 320,
		},
		wings: {
			tealRight: {
				d: 'M267.929 189.466C243.007 202.663 183.29 174.619 167.446 166.714C165.648 165.818 165.466 163.16 167.123 161.954C202.113 136.487 267.584 128.098 296.865 127.108C327.18 126.083 290.055 177.749 267.929 189.466Z',
				texture: {
					x: 164.792,
					y: 125.902,
					width: 144.693,
					height: 68.2324,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
			tealLeft: {
				d: 'M76.3654 190.856C101.287 204.053 161.004 176.009 176.849 168.104C178.646 167.207 178.828 164.55 177.172 163.344C142.181 137.877 76.7099 129.488 47.429 128.497C17.1137 127.473 54.2385 179.139 76.3654 190.856Z',
				texture: {
					x: 34.8097,
					y: 127.292,
					width: 144.693,
					height: 68.2324,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
			purpleRight: {
				d: 'M263.205 162.052C244.209 182.895 178.528 176.68 160.944 174.594C158.95 174.358 157.88 171.918 159.032 170.223C183.358 134.431 242.143 104.41 269.366 93.5846C297.552 82.3754 280.071 143.547 263.205 162.052Z',
				texture: {
					x: 157.368,
					y: 91.0333,
					width: 128.077,
					height: 87.2541,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
			purpleLeft: {
				d: 'M80.5254 162.747C99.5213 183.589 165.202 177.375 182.786 175.289C184.78 175.052 185.85 172.613 184.698 170.918C160.372 135.126 101.587 105.105 74.3635 94.2788C46.1779 83.0703 63.6595 144.242 80.5254 162.747Z',
				texture: {
					x: 58.2843,
					y: 91.7277,
					width: 128.077,
					height: 87.2546,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
		},
		leftArm: {
			d: 'M113 179.265C113 179.265 99.3845 198.349 91.3784 185.627C83.3722 172.904 79 159.5 79 159.5',
			texture: {
				x: 65.1698,
				y: 145.67,
				width: 61.6578,
				height: 58.1569,
				frequency: [0.9990000128746033, 0.732045590877533],
				numOctaves: 3,
				seed: 8637,
				scale: 1.5817248821258545,
			},
			front: false,
			renderMode: 'stroke',
		},
		rightArm: {
			d: 'M215.741 164.994C215.741 164.994 228.449 173.632 231.5 188C234.551 202.368 215.741 212.5 215.741 212.5',
			texture: {
				x: 201.912,
				y: 151.166,
				width: 43.7634,
				height: 75.163,
				frequency: [0.9990000128746033, 0.732045590877533],
				numOctaves: 3,
				seed: 8637,
				scale: 1.5817248821258545,
			},
			front: true,
			renderMode: 'stroke',
		},
		antennae: [
			{
				stem: {
					d: 'M128.667 71.9279C131.063 55.1521 139.451 37.9768 159.422 31.1865',
					texture: {
						x: 123.705,
						y: 26.2246,
						width: 40.6791,
						height: 50.6647,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 2801,
						scale: 1.933219313621521,
					},
				},
				tip: {
					d: 'M160.221 40.3736C165.295 40.3736 169.408 36.2605 169.408 31.1868C169.408 26.113 165.295 22 160.221 22C155.147 22 151.034 26.113 151.034 31.1868C151.034 36.2605 155.147 40.3736 160.221 40.3736Z',
					texture: {
						x: 149.668,
						y: 20.634,
						width: 21.1057,
						height: 21.1056,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 8737,
						scale: 2.732070207595825,
					},
				},
				front: false,
			},
			{
				stem: {
					d: 'M176.598 71.9279C178.994 55.1521 187.382 37.9768 207.353 31.1865',
					texture: {
						x: 171.636,
						y: 26.2246,
						width: 40.6791,
						height: 50.6647,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 2801,
						scale: 1.933219313621521,
					},
				},
				tip: {
					d: 'M208.152 40.3736C213.226 40.3736 217.339 36.2605 217.339 31.1868C217.339 26.113 213.226 22 208.152 22C203.078 22 198.965 26.113 198.965 31.1868C198.965 36.2605 203.078 40.3736 208.152 40.3736Z',
					texture: {
						x: 197.599,
						y: 20.634,
						width: 21.1057,
						height: 21.1056,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 8737,
						scale: 2.732070207595825,
					},
				},
				front: true,
			},
		],
		body: {
			d: 'M101.858 96.8471C102.719 76.5189 118.724 60.087 139.022 58.6899L161.405 57.1494L183.998 59.0027C204.371 60.6738 220.194 77.4571 220.664 97.8933L222.132 161.718L220.766 224.058C220.248 247.709 201.096 266.705 177.441 267.028L161.419 267.247H145.569C121.993 267.247 102.62 248.64 101.668 225.084L99.1089 161.718L101.858 96.8471Z',
			texture: {
				x: 95.9441,
				y: 53.9814,
				width: 129.352,
				height: 216.429,
				frequency: [0.29947322607040405, 0.24354049563407898],
				numOctaves: 3,
				seed: 6337,
				scale: 3.131495714187622,
			},
		},
		bodyMask:
			'M100.989 96.1398C101.952 74.6109 120.056 57.9994 141.599 58.5671L163.59 59.1465L179.396 58.6943C201.489 58.0621 219.895 75.4905 220.468 97.5842L222.132 161.718L221.01 223.995C220.58 247.832 201.219 266.977 177.379 267.139L161.42 267.247L143.865 267.128C120.657 266.971 101.573 248.791 100.643 225.601C99.8241 205.167 99.0643 180.842 99.1093 161.718C99.156 141.918 100.066 116.767 100.989 96.1398Z',
		bodyShade: {
			d: 'M206.555 53.5547C211.747 58.3478 221.733 76.1743 224.928 89.9024C228.124 103.631 229.322 132.641 229.322 147.02C229.322 161.4 224.928 182.569 220.934 195.75C216.94 208.931 210.15 222.911 206.555 232.497C202.96 242.083 194.572 257.262 180.992 278.831',
			texture: {
				x: 123.854,
				y: -3.57934,
				width: 162.602,
				height: 339.547,
				frequency: [0.638672411441803, 0.638672411441803],
				numOctaves: 3,
				seed: 9325,
				scale: 60.744625091552734,
			},
		},
		stripes: [
			{
				d: 'M225.328 166.991V187.362C225.328 187.362 202.598 185.764 161.819 185.764C121.041 185.764 95.9141 187.362 95.9141 187.362V166.991C95.9141 166.991 121.041 165.394 161.819 165.394C202.598 165.394 225.328 166.991 225.328 166.991Z',
				texture: {
					x: 95.4587,
					y: 164.938,
					width: 130.325,
					height: 22.8792,
					frequency: [0.5960943698883057, 0.5960943698883057],
					numOctaves: 3,
					seed: 2172,
					scale: 0.9106900691986084,
				},
			},
			{
				d: 'M225.328 200.943V221.314C225.328 221.314 202.598 219.716 161.819 219.716C121.041 219.716 95.9141 221.314 95.9141 221.314V200.943C95.9141 200.943 121.041 199.346 161.819 199.346C202.598 199.346 225.328 200.943 225.328 200.943Z',
				texture: {
					x: 95.4587,
					y: 198.89,
					width: 130.325,
					height: 22.8792,
					frequency: [0.5960943698883057, 0.5960943698883057],
					numOctaves: 3,
					seed: 2172,
					scale: 0.9106900691986084,
				},
			},
			{
				d: 'M225.328 234.494V254.865C225.328 254.865 202.598 253.267 161.819 253.267C121.041 253.267 95.9141 254.865 95.9141 254.865V234.494C95.9141 234.494 121.041 232.896 161.819 232.896C202.598 232.896 225.328 234.494 225.328 234.494Z',
				texture: {
					x: 95.4587,
					y: 232.441,
					width: 130.325,
					height: 22.8792,
					frequency: [0.5960943698883057, 0.5960943698883057],
					numOctaves: 3,
					seed: 2172,
					scale: 0.9106900691986084,
				},
			},
		],
		eyes: [
			{
				d: 'M119.432 122.786C124.038 122.786 127.772 123.436 127.772 116.836C127.772 110.235 124.038 104.885 119.432 104.885C114.826 104.885 111.092 110.235 111.092 116.836C111.092 123.436 114.826 122.786 119.432 122.786Z',
				texture: {
					x: 109.846,
					y: 103.639,
					width: 19.1724,
					height: 20.4116,
					frequency: [0.9990000128746033, 0.9990000128746033],
					numOctaves: 3,
					seed: 6148,
					scale: 1.6935639381408691,
				},
			},
			{
				d: 'M167.363 122.786C171.969 122.786 175.703 123.436 175.703 116.836C175.703 110.235 171.969 104.885 167.363 104.885C162.757 104.885 159.023 110.235 159.023 116.836C159.023 123.436 162.757 122.786 167.363 122.786Z',
				texture: {
					x: 157.777,
					y: 103.639,
					width: 19.1724,
					height: 20.4116,
					frequency: [0.9990000128746033, 0.9990000128746033],
					numOctaves: 3,
					seed: 6148,
					scale: 1.6935639381408691,
				},
			},
		],
		stinger: {
			d: 'M209.429 275.238C203.374 262.089 188.144 270.95 195.052 281.869C200.98 291.239 212.946 298.802 221.919 299.995C223.698 300.111 224.224 298.053 222.861 296.904C218.538 295.207 215.485 288.387 209.429 275.238Z',
			texture: {
				x: 192.472,
				y: 267.844,
				width: 31.9786,
				height: 32.9751,
				frequency: [0.9282835721969604, 0.7064296007156372],
				numOctaves: 3,
				seed: 192,
				scale: 1.6381428241729736,
			},
		},
		stars: [],
		squiggles: [],
		prop: {
			behindEye:
				'<defs><filter id="filter19_i_4737_18897" x="86.5704" y="80.7051" width="57.6824" height="58.8704" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">\n<feFlood flood-opacity="0" result="BackgroundImageFix"/>\n<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>\n<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>\n<feOffset dx="4.74" dy="3.64"/>\n<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>\n<feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.45 0"/>\n<feBlend mode="normal" in2="shape" result="effect1_innerShadow_4737_18897"/>\n</filter><filter id="filter20_g_4737_18897" x="44.9772" y="54.9771" width="129.837" height="129.837" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">\n<feFlood flood-opacity="0" result="BackgroundImageFix"/>\n<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>\n<feTurbulence type="fractalNoise" baseFrequency="0.25 0.25" numOctaves="3" seed="7683" />\n<feDisplacementMap in="shape" scale="2" xChannelSelector="R" yChannelSelector="G" result="displacedImage" width="100%" height="100%" />\n<feMerge result="effect1_texture_4737_18897">\n<feMergeNode in="displacedImage"/>\n</feMerge>\n</filter><filter id="filter21_g_4737_18897" x="76.2408" y="136.659" width="26.4852" height="35.833" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">\n<feFlood flood-opacity="0" result="BackgroundImageFix"/>\n<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>\n<feTurbulence type="fractalNoise" baseFrequency="0.25 0.25" numOctaves="3" seed="8482" />\n<feDisplacementMap in="shape" scale="2" xChannelSelector="R" yChannelSelector="G" result="displacedImage" width="100%" height="100%" />\n<feMerge result="effect1_texture_4737_18897">\n<feMergeNode in="displacedImage"/>\n</feMerge>\n</filter></defs><rect x="89.147" y="83.9226" width="34.6865" height="51.5492" rx="17.3432" fill="#FFCC55"/>',
			eye: {
				d: 'M116.5 131C123.404 131 129 122.941 129 113C129 103.059 123.404 95 116.5 95C109.596 95 104 103.059 104 113C104 122.941 109.596 131 116.5 131Z',
				texture: {
					x: 101.684,
					y: 92.6838,
					width: 29.6321,
					height: 40.6324,
					frequency: [0.680351972579956, 0.680351972579956],
					numOctaves: 3,
					seed: 6148,
					scale: 3.1475088596343994,
				},
			},
			inFrontOfEye:
				'<g filter="url(#filter19_i_4737_18897)" style="mix-blend-mode:screen">\n<ellipse cx="115.412" cy="110.14" rx="28.8365" ry="29.4372" transform="rotate(-4.27656 115.412 110.14)" fill="white" fill-opacity="0.2"/>\n</g>\n<g filter="url(#filter20_g_4737_18897)">\n<path d="M82.7548 167.834L100.849 135.875M124.015 138.44C107.89 142.907 91.1962 133.456 86.7293 117.33C82.2623 101.205 91.7134 84.5116 107.839 80.0446C123.964 75.5777 140.658 85.0288 145.125 101.154C149.591 117.28 140.14 133.973 124.015 138.44Z" stroke="#656C7B" stroke-width="5.95481" stroke-linecap="round" stroke-linejoin="round"/>\n</g>\n<g filter="url(#filter21_g_4737_18897)">\n<rect x="94.3752" y="135.646" width="10.885" height="37.5581" rx="5.44252" transform="rotate(30.6518 94.3752 135.646)" fill="#956028"/>\n</g>',
		},
	},
	peeking: {
		source: 'peeking.svg',
		viewBox: {
			width: 320,
			height: 320,
		},
		wings: {
			tealRight: {
				d: 'M256.929 189.466C232.007 202.663 172.29 174.619 156.446 166.714C154.648 165.818 154.466 163.16 156.123 161.954C191.113 136.487 256.584 128.098 285.865 127.108C316.18 126.083 279.055 177.749 256.929 189.466Z',
				texture: {
					x: 153.792,
					y: 125.902,
					width: 144.693,
					height: 68.2325,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
			tealLeft: {
				d: 'M65.3654 190.856C90.2869 204.053 150.004 176.009 165.849 168.104C167.646 167.207 167.828 164.55 166.172 163.344C131.181 137.877 65.7099 129.488 36.429 128.497C6.11374 127.473 43.2385 179.139 65.3654 190.856Z',
				texture: {
					x: 23.8097,
					y: 127.292,
					width: 144.693,
					height: 68.2325,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
			purpleRight: {
				d: 'M252.205 162.052C233.209 182.895 167.528 176.68 149.944 174.594C147.95 174.358 146.88 171.918 148.032 170.223C172.358 134.431 231.143 104.41 258.366 93.5846C286.552 82.3754 269.071 143.547 252.205 162.052Z',
				texture: {
					x: 146.368,
					y: 91.0333,
					width: 128.077,
					height: 87.2541,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
			purpleLeft: {
				d: 'M69.5254 162.747C88.5213 183.589 154.202 177.375 171.786 175.289C173.78 175.052 174.85 172.613 173.698 170.918C149.372 135.126 90.5874 105.105 63.3635 94.2788C35.1779 83.0703 52.6595 144.242 69.5254 162.747Z',
				texture: {
					x: 47.2843,
					y: 91.7277,
					width: 128.077,
					height: 87.2545,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
		},
		leftArm: {
			d: 'M93.7045 174.772C99.3913 179.215 107.576 178.221 111.985 172.552C116.395 166.882 115.359 158.684 109.672 154.241L101.688 164.507L93.7045 174.772ZM94.3927 98.6813C93.3525 91.5487 86.737 86.5809 79.6166 87.5853C72.4962 88.5898 67.5672 95.1861 68.6073 102.319L81.5 100.5L94.3927 98.6813ZM101.688 164.507C109.672 154.241 109.678 154.246 109.683 154.25C109.685 154.251 109.691 154.256 109.694 154.258C109.701 154.264 109.708 154.269 109.715 154.275C109.729 154.286 109.742 154.296 109.755 154.306C109.781 154.327 109.805 154.346 109.827 154.364C109.871 154.4 109.908 154.43 109.938 154.456C109.999 154.507 110.033 154.537 110.042 154.545C110.059 154.561 109.977 154.488 109.815 154.318C109.492 153.98 108.841 153.246 108.015 152.04C106.379 149.652 103.961 145.273 102.094 138.22L89.5 141.5L76.9062 144.78C79.5393 154.727 83.2153 161.852 86.5483 166.717C88.2071 169.138 89.7593 170.968 91.0185 172.287C91.6473 172.946 92.2014 173.475 92.6571 173.886C92.885 174.092 93.0881 174.267 93.2637 174.415C93.3515 174.488 93.4323 174.555 93.5059 174.614C93.5427 174.644 93.5777 174.672 93.6108 174.698C93.6274 174.712 93.6435 174.724 93.6591 174.737C93.6669 174.743 93.6746 174.749 93.6822 174.755C93.6859 174.758 93.6915 174.762 93.6934 174.764C93.699 174.768 93.7045 174.772 101.688 164.507ZM89.5 141.5L102.094 138.22C99.9856 130.256 98.0607 120.433 96.642 112.415C95.9397 108.445 95.3746 104.993 94.9857 102.538C94.7914 101.312 94.6416 100.337 94.5411 99.6733C94.4908 99.3417 94.4529 99.0881 94.4279 98.9203C94.4155 98.8363 94.4062 98.7738 94.4003 98.7337C94.3974 98.7136 94.3953 98.6991 94.394 98.6903C94.3933 98.686 94.3929 98.683 94.3927 98.6815C94.3926 98.6807 94.3925 98.6803 94.3925 98.6803C94.3925 98.6803 94.3925 98.6805 94.3925 98.6805C94.3926 98.6809 94.3927 98.6813 81.5 100.5C68.6073 102.319 68.6074 102.319 68.6075 102.32C68.6076 102.32 68.6077 102.321 68.6078 102.322C68.608 102.323 68.6083 102.325 68.6086 102.327C68.6092 102.332 68.6101 102.337 68.6111 102.345C68.6132 102.359 68.6162 102.379 68.62 102.405C68.6276 102.457 68.6386 102.531 68.6529 102.627C68.6814 102.819 68.7231 103.098 68.7773 103.456C68.8857 104.171 69.0445 105.204 69.2487 106.493C69.6567 109.069 70.2478 112.68 70.983 116.835C72.4393 125.067 74.5144 135.744 76.9062 144.78L89.5 141.5Z',
			texture: {
				x: 67.6779,
				y: 86.6654,
				width: 47.8317,
				height: 91.6749,
				frequency: [0.9990000128746033, 0.732045590877533],
				numOctaves: 3,
				seed: 8637,
				scale: 1.5817248821258545,
			},
			front: true,
			renderMode: 'fill',
		},
		rightArm: {
			d: 'M232.959 170.16C229.806 176.651 222.007 179.382 215.538 176.26C209.069 173.138 206.381 165.345 209.533 158.854L221.246 164.507L232.959 170.16ZM229.01 99.5546C229.568 92.3706 235.837 86.9701 243.011 87.4922C250.186 88.0143 255.549 94.2614 254.99 101.445L242 100.5L229.01 99.5546ZM221.246 164.507C209.533 158.854 209.533 158.854 209.534 158.854C209.534 158.854 209.534 158.853 209.534 158.853C209.534 158.853 209.534 158.853 209.534 158.852C209.535 158.851 209.536 158.849 209.537 158.847C209.539 158.843 209.541 158.837 209.545 158.83C209.553 158.814 209.564 158.791 209.579 158.76C209.609 158.699 209.653 158.607 209.712 158.486C209.831 158.242 210.008 157.879 210.243 157.395C210.714 156.427 211.42 154.98 212.36 153.054C214.24 149.204 217.058 143.444 220.812 135.797L232.5 141.5L244.188 147.203C240.442 154.833 237.633 160.577 235.761 164.41C234.825 166.327 234.124 167.767 233.656 168.726C233.423 169.206 233.248 169.565 233.132 169.804C233.074 169.924 233.03 170.013 233.001 170.072C232.987 170.102 232.976 170.124 232.969 170.139C232.965 170.146 232.963 170.151 232.961 170.155C232.96 170.157 232.96 170.158 232.959 170.159C232.959 170.159 232.959 170.16 232.959 170.16C232.959 170.16 232.959 170.16 232.959 170.16C232.959 170.16 232.959 170.16 221.246 164.507ZM232.5 141.5L220.812 135.797C223.701 129.911 225.831 121.192 227.223 113.118C227.891 109.242 228.343 105.799 228.626 103.333C228.768 102.104 228.866 101.127 228.928 100.472C228.959 100.145 228.981 99.8995 228.994 99.7435C229.001 99.6655 229.005 99.61 229.008 99.5781C229.009 99.5622 229.01 99.5522 229.01 99.5482C229.01 99.5463 229.011 99.5458 229.01 99.5469C229.01 99.5474 229.01 99.5483 229.01 99.5496C229.01 99.5502 229.01 99.5515 229.01 99.5518C229.01 99.5532 229.01 99.5546 242 100.5C254.99 101.445 254.99 101.447 254.99 101.449C254.99 101.449 254.99 101.451 254.99 101.453C254.989 101.456 254.989 101.459 254.989 101.463C254.988 101.47 254.988 101.479 254.987 101.489C254.985 101.51 254.983 101.537 254.98 101.57C254.975 101.637 254.967 101.728 254.957 101.842C254.938 102.07 254.909 102.392 254.871 102.798C254.794 103.61 254.678 104.762 254.514 106.183C254.188 109.017 253.671 112.96 252.902 117.424C251.419 126.031 248.799 137.812 244.188 147.203L232.5 141.5Z',
			texture: {
				x: 207.423,
				y: 86.6664,
				width: 48.3981,
				height: 91.6763,
				frequency: [0.9990000128746033, 0.732045590877533],
				numOctaves: 3,
				seed: 8637,
				scale: 1.5817248821258545,
			},
			front: true,
			renderMode: 'fill',
		},
		antennae: [
			{
				stem: {
					d: 'M134.56 71.9279C136.956 55.1521 145.344 37.9768 165.315 31.1865',
					texture: {
						x: 129.598,
						y: 26.2246,
						width: 40.6788,
						height: 50.6648,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 2801,
						scale: 1.933219313621521,
					},
				},
				tip: {
					d: 'M166.115 40.3736C171.188 40.3736 175.301 36.2605 175.301 31.1868C175.301 26.113 171.188 22 166.115 22C161.041 22 156.928 26.113 156.928 31.1868C156.928 36.2605 161.041 40.3736 166.115 40.3736Z',
					texture: {
						x: 155.562,
						y: 20.634,
						width: 21.1056,
						height: 21.1056,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 8737,
						scale: 2.732070207595825,
					},
				},
				front: true,
			},
			{
				stem: {
					d: 'M182.49 71.9279C184.887 55.1521 193.275 37.9768 213.246 31.1865',
					texture: {
						x: 177.529,
						y: 26.2246,
						width: 40.6788,
						height: 50.6648,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 2801,
						scale: 1.933219313621521,
					},
				},
				tip: {
					d: 'M214.045 40.3736C219.118 40.3736 223.231 36.2605 223.231 31.1868C223.231 26.113 219.118 22 214.045 22C208.971 22 204.858 26.113 204.858 31.1868C204.858 36.2605 208.971 40.3736 214.045 40.3736Z',
					texture: {
						x: 203.492,
						y: 20.634,
						width: 21.1056,
						height: 21.1056,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 8737,
						scale: 2.732070207595825,
					},
				},
				front: true,
			},
		],
		body: {
			d: 'M101.751 96.8471C102.613 76.5189 118.617 60.087 138.915 58.6899L161.298 57.1494L183.891 59.0027C204.264 60.6738 220.087 77.4571 220.557 97.8933L222.025 161.718L220.659 224.058C220.141 247.709 200.989 266.705 177.334 267.028L161.312 267.247H145.462C121.886 267.247 102.513 248.64 101.561 225.084L99.002 161.718L101.751 96.8471Z',
			texture: {
				x: 95.8371,
				y: 53.9815,
				width: 129.352,
				height: 216.429,
				frequency: [0.29947322607040405, 0.24354049563407898],
				numOctaves: 3,
				seed: 6337,
				scale: 3.131495714187622,
			},
		},
		bodyMask:
			'M100.881 96.1398C101.845 74.6109 119.949 57.9994 141.492 58.5671L163.482 59.1465L179.289 58.6943C201.381 58.0621 219.787 75.4905 220.361 97.5842L222.025 161.718L220.902 223.995C220.473 247.832 201.112 266.977 177.271 267.139L161.312 267.247L143.757 267.128C120.55 266.971 101.466 248.791 100.536 225.601C99.7167 205.167 98.9569 180.842 99.0019 161.718C99.0485 141.918 99.9583 116.767 100.881 96.1398Z',
		bodyShade: {
			d: 'M206.448 53.5547C211.64 58.3478 221.626 76.1743 224.821 89.9024C228.016 103.631 229.215 132.641 229.215 147.02C229.215 161.4 224.821 182.569 220.827 195.75C216.833 208.931 210.042 222.911 206.448 232.497C202.853 242.083 194.465 257.262 180.884 278.831',
			texture: {
				x: 123.747,
				y: -3.57922,
				width: 162.602,
				height: 339.547,
				frequency: [0.638672411441803, 0.638672411441803],
				numOctaves: 3,
				seed: 9325,
				scale: 60.744625091552734,
			},
		},
		stripes: [
			{
				d: 'M225.22 166.991V187.362C225.22 187.362 202.491 185.764 161.712 185.764C120.933 185.764 95.8066 187.362 95.8066 187.362V166.991C95.8066 166.991 120.933 165.393 161.712 165.393C202.491 165.393 225.22 166.991 225.22 166.991Z',
				texture: {
					x: 95.3513,
					y: 164.938,
					width: 130.325,
					height: 22.8791,
					frequency: [0.5960943698883057, 0.5960943698883057],
					numOctaves: 3,
					seed: 2172,
					scale: 0.9106900691986084,
				},
			},
			{
				d: 'M225.22 200.943V221.314C225.22 221.314 202.491 219.716 161.712 219.716C120.933 219.716 95.8066 221.314 95.8066 221.314V200.943C95.8066 200.943 120.933 199.346 161.712 199.346C202.491 199.346 225.22 200.943 225.22 200.943Z',
				texture: {
					x: 95.3513,
					y: 198.89,
					width: 130.325,
					height: 22.8791,
					frequency: [0.5960943698883057, 0.5960943698883057],
					numOctaves: 3,
					seed: 2172,
					scale: 0.9106900691986084,
				},
			},
			{
				d: 'M225.22 234.494V254.865C225.22 254.865 202.491 253.267 161.712 253.267C120.933 253.267 95.8066 254.865 95.8066 254.865V234.494C95.8066 234.494 120.933 232.896 161.712 232.896C202.491 232.896 225.22 234.494 225.22 234.494Z',
				texture: {
					x: 95.3513,
					y: 232.441,
					width: 130.325,
					height: 22.8791,
					frequency: [0.5960943698883057, 0.5960943698883057],
					numOctaves: 3,
					seed: 2172,
					scale: 0.9106900691986084,
				},
			},
		],
		eyes: [
			{
				d: 'M136.34 117.786C140.946 117.786 144.68 120.436 144.68 113.836C144.68 107.235 140.946 101.885 136.34 101.885C131.734 101.885 128 107.235 128 113.836C128 120.436 131.734 117.786 136.34 117.786Z',
				texture: {
					x: 126.754,
					y: 100.639,
					width: 19.1726,
					height: 18.9193,
					frequency: [0.9990000128746033, 0.9990000128746033],
					numOctaves: 3,
					seed: 6148,
					scale: 1.6935639381408691,
				},
			},
			{
				d: 'M184.271 117.786C188.877 117.786 192.611 120.436 192.611 113.836C192.611 107.235 188.877 101.885 184.271 101.885C179.665 101.885 175.931 107.235 175.931 113.836C175.931 120.436 179.665 117.786 184.271 117.786Z',
				texture: {
					x: 174.685,
					y: 100.639,
					width: 19.1726,
					height: 18.9193,
					frequency: [0.9990000128746033, 0.9990000128746033],
					numOctaves: 3,
					seed: 6148,
					scale: 1.6935639381408691,
				},
			},
		],
		stinger: {
			d: 'M209.322 275.238C203.266 262.089 188.037 270.95 194.945 281.869C200.873 291.239 212.838 298.802 221.812 299.995C223.59 300.111 224.116 298.053 222.754 296.904C218.43 295.207 215.377 288.387 209.322 275.238Z',
			texture: {
				x: 192.365,
				y: 267.844,
				width: 31.9785,
				height: 32.9751,
				frequency: [0.9282835721969604, 0.7064296007156372],
				numOctaves: 3,
				seed: 192,
				scale: 1.6381428241729736,
			},
		},
		stars: [],
		squiggles: [],
		prop: null,
	},
	bored: {
		source: 'bored.svg',
		viewBox: {
			width: 320,
			height: 324,
		},
		wings: {
			tealRight: {
				d: 'M139.456 314.86C128.372 310.925 167.612 302.61 178.536 300.413C179.775 300.164 182.731 300.186 183.83 300.454C207.043 306.109 207.18 315.956 204.196 320.308C201.105 324.814 149.297 318.354 139.456 314.86Z',
				texture: {
					x: 136.313,
					y: 299.049,
					width: 70.4177,
					height: 23.9921,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
			tealLeft: {
				d: 'M153.128 312.002C146.129 308.513 193.419 302.113 206.465 300.431C207.944 300.24 210.85 300.305 211.668 300.547C228.945 305.674 219.117 313.976 211.756 317.598C204.135 321.349 159.343 315.1 153.128 312.002Z',
				texture: {
					x: 151.235,
					y: 299.129,
					width: 71.2424,
					height: 20.8229,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
			purpleRight: {
				d: 'M171.033 314.77C150.694 311.569 166.69 301.963 171.438 299.4C171.977 299.109 174.816 298.996 176.525 299.198C212.61 303.468 237.533 312.729 245.682 316.961C254.119 321.342 189.092 317.612 171.033 314.77Z',
				texture: {
					x: 159.778,
					y: 297.906,
					width: 87.8452,
					height: 22.2561,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
			purpleLeft: {
				d: 'M183.921 312.324C167.008 309.31 192.576 301.462 199.874 299.375C200.702 299.138 203.629 299.087 205.117 299.284C236.549 303.442 251.869 311.635 255.66 315.328C259.587 319.152 198.937 314.999 183.921 312.324Z',
				texture: {
					x: 177.054,
					y: 297.972,
					width: 79.9792,
					height: 20.0912,
					frequency: [0.7387896180152893, 0.6869447231292725],
					numOctaves: 3,
					seed: 2705,
					scale: 2.380575656890869,
				},
			},
		},
		leftArm: {
			d: 'M158.094 246.027C158.094 246.027 150.5 267 138.5 278.5C126.5 290 107 293 107 293',
			texture: {
				x: 93.1715,
				y: 232.197,
				width: 78.7521,
				height: 74.6316,
				frequency: [0.9990000128746033, 0.732045590877533],
				numOctaves: 3,
				seed: 8637,
				scale: 1.5817248821258545,
			},
			front: true,
			renderMode: 'stroke',
		},
		rightArm: {
			d: 'M160.482 236.729C160.482 236.729 137.87 233.931 122.645 230.956C107.419 227.981 90.1835 214.361 90.1835 214.361',
			texture: {
				x: 76.3566,
				y: 200.534,
				width: 97.9538,
				height: 50.023,
				frequency: [0.9990000128746033, 0.732045590877533],
				numOctaves: 3,
				seed: 8637,
				scale: 1.5817248821258545,
			},
			front: false,
			renderMode: 'stroke',
		},
		antennae: [
			{
				stem: {
					d: 'M251 246C263.765 249.195 276.833 260.377 282 287',
					texture: {
						x: 246.038,
						y: 241.038,
						width: 40.9235,
						height: 50.9234,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 2801,
						scale: 1.933219313621521,
					},
				},
				tip: {
					d: 'M272.707 286.795C272.707 291.868 276.82 295.982 281.893 295.982C286.967 295.982 291.08 291.868 291.08 286.795C291.08 281.721 286.967 277.608 281.893 277.608C276.82 277.608 272.707 281.721 272.707 286.795Z',
					texture: {
						x: 271.341,
						y: 276.242,
						width: 21.1056,
						height: 21.1057,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 8737,
						scale: 2.732070207595825,
					},
				},
				front: true,
			},
			{
				stem: {
					d: 'M251.53 237.165C263.753 237.079 278.121 244.141 289 267',
					texture: {
						x: 246.569,
						y: 232.203,
						width: 47.3929,
						height: 39.7584,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 2801,
						scale: 1.933219313621521,
					},
				},
				tip: {
					d: 'M279.99 269.797C281.262 274.709 286.275 277.659 291.187 276.386C296.098 275.113 299.048 270.1 297.776 265.189C296.503 260.277 291.49 257.327 286.579 258.6C281.667 259.872 278.717 264.885 279.99 269.797Z',
					texture: {
						x: 278.328,
						y: 256.938,
						width: 21.1102,
						height: 21.1101,
						frequency: [0.9990000128746033, 0.9990000128746033],
						numOctaves: 3,
						seed: 8737,
						scale: 2.732070207595825,
					},
				},
				front: false,
			},
		],
		body: {
			d: 'M225.972 183.436C246.3 184.297 262.732 200.302 264.129 220.6L265.669 242.983L263.816 265.576C262.145 285.949 245.362 301.772 224.926 302.242L161.101 303.71L98.7612 302.344C75.1094 301.826 56.1142 282.674 55.7907 259.019L55.5716 242.997L55.5716 227.147C55.5716 203.571 74.1787 184.197 97.7353 183.246L161.101 180.687L225.972 183.436Z',
			texture: {
				x: 52.4079,
				y: 177.522,
				width: 216.43,
				height: 129.352,
				frequency: [0.29947322607040405, 0.24354049563407898],
				numOctaves: 3,
				seed: 6337,
				scale: 3.131495714187622,
			},
		},
		bodyMask:
			'M226.94 182.631C248.469 183.595 265.081 201.699 264.513 223.242L263.934 245.232L264.386 261.039C265.018 283.131 247.59 301.537 225.496 302.111L161.362 303.775L99.0853 302.652C75.2482 302.223 56.1032 282.862 55.9413 259.021L55.8329 243.062L55.952 225.507C56.1096 202.3 74.2895 183.216 97.479 182.286C117.913 181.467 142.238 180.707 161.362 180.752C181.162 180.799 206.313 181.708 226.94 182.631Z',
		bodyShade: {
			d: 'M269.525 288.197C264.732 293.39 246.906 303.375 233.178 306.571C219.45 309.766 190.439 310.965 176.06 310.965C161.681 310.965 140.511 306.571 127.33 302.577C114.149 298.582 100.169 291.792 90.5828 288.197C80.9966 284.602 65.8184 276.215 44.2494 262.634',
			texture: {
				x: -12.8879,
				y: 205.497,
				width: 339.547,
				height: 162.602,
				frequency: [0.638672411441803, 0.638672411441803],
				numOctaves: 3,
				seed: 9325,
				scale: 60.744625091552734,
			},
		},
		stripes: [
			{
				d: 'M156.089 306.97L135.718 306.97C135.718 306.97 137.316 284.241 137.316 243.462C137.316 202.683 135.718 177.557 135.718 177.557L156.089 177.557C156.089 177.557 157.687 202.683 157.687 243.462C157.687 284.241 156.089 306.97 156.089 306.97Z',
				texture: {
					x: 135.262,
					y: 177.101,
					width: 22.8794,
					height: 130.325,
					frequency: [0.5960943698883057, 0.5960943698883057],
					numOctaves: 3,
					seed: 2172,
					scale: 0.9106900691986084,
				},
			},
			{
				d: 'M122.137 306.97L101.766 306.97C101.766 306.97 103.364 284.241 103.364 243.462C103.364 202.683 101.766 177.557 101.766 177.557L122.137 177.557C122.137 177.557 123.734 202.683 123.734 243.462C123.734 284.241 122.137 306.97 122.137 306.97Z',
				texture: {
					x: 101.31,
					y: 177.101,
					width: 22.8794,
					height: 130.325,
					frequency: [0.5960943698883057, 0.5960943698883057],
					numOctaves: 3,
					seed: 2172,
					scale: 0.9106900691986084,
				},
			},
			{
				d: 'M88.5859 306.97L68.2152 306.97C68.2152 306.97 69.8129 284.241 69.8129 243.462C69.8129 202.683 68.2152 177.557 68.2152 177.557L88.5859 177.557C88.5859 177.557 90.1836 202.683 90.1836 243.462C90.1836 284.241 88.5859 306.97 88.5859 306.97Z',
				texture: {
					x: 67.7595,
					y: 177.101,
					width: 22.8794,
					height: 130.325,
					frequency: [0.5960943698883057, 0.5960943698883057],
					numOctaves: 3,
					seed: 2172,
					scale: 0.9106900691986084,
				},
			},
		],
		eyes: [
			{
				d: 'M197.294 201.914C197.294 206.52 202.644 210.254 209.245 210.254C215.845 210.254 221.195 206.52 221.195 201.914C221.195 197.308 215.845 193.574 209.245 193.574C202.644 193.574 197.294 197.308 197.294 201.914Z',
				texture: {
					x: 196.048,
					y: 192.328,
					width: 26.3938,
					height: 19.1724,
					frequency: [0.9990000128746033, 0.9990000128746033],
					numOctaves: 3,
					seed: 6148,
					scale: 1.6935639381408691,
				},
			},
		],
		stinger: {
			d: 'M47.5527 303.47C62.0282 303.643 60.5599 286.084 47.7327 287.638C36.7255 288.972 24.7601 296.534 19.8313 304.127C18.9629 305.684 20.5967 307.042 22.2194 306.304C25.6073 303.127 33.0773 303.297 47.5527 303.47Z',
			texture: {
				x: 18.7708,
				y: 286.722,
				width: 39.935,
				height: 20.6083,
				frequency: [0.9282835721969604, 0.7064296007156372],
				numOctaves: 3,
				seed: 192,
				scale: 1.6381428241729736,
			},
		},
		stars: [],
		squiggles: [
			{
				d: 'M186.163 170.33C182.1 163.293 179.684 158.177 185.157 150.786C189.766 144.562 198.918 136.37 205.628 143.653C209.022 147.336 206.934 147.95 202.664 150.262C198.107 152.728 194.45 149.456 192.288 145.711C188.612 139.344 191.631 134.443 196.216 129.122C200.978 123.595 205.438 120.315 211.683 124.877C217.437 129.08 205.91 128.967 203.451 127.766C198.471 125.334 195.278 119.089 198.414 114.383',
				texture: {
					x: 177.473,
					y: 109.883,
					width: 40.3008,
					height: 64.9474,
					frequency: [0.20000000298023224, 0.20000000298023224],
					numOctaves: 3,
					seed: 7973,
					scale: 6,
				},
			},
		],
		prop: null,
	},
} as const satisfies Record<Bizy3State, Bizy3Pose>;
